// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { $OpenApiTs } from './models';

export class AsrProviderWebhooksService {
  /**
   * Relay a provider completion webhook to ASR Proxy
   * @returns void
   * @throws ApiError
   */
  public static relayAsrProxyProviderWebhook(
    data: $OpenApiTs['/api/asr-proxy/provider-webhooks/{provider}/{proxyId}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/asr-proxy/provider-webhooks/{provider}/{proxyId}']['post']['res'][204]> {
    const { provider, proxyId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/asr-proxy/provider-webhooks/{provider}/{proxyId}',
      path: {
        provider,
        proxyId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}

export class AdminInternalDailyJobsReportService {
  /**
   * Fire the daily jobs report on demand
   * Pulls the last 24h of jobs from Postgres, builds a CSV with per-stage timings, and uploads it to the Slack warnings channel. Same code path as the midnight Eastern cron. Requires INTERNAL_API_KEY.
   * @returns any
   * @throws ApiError
   */
  public static fire(): CancelablePromise<
    $OpenApiTs['/api/admin/internal/daily-jobs-report/fire']['post']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/internal/daily-jobs-report/fire',
    });
  }
}

export class SlackService {
  /**
   * @returns any
   * @throws ApiError
   */
  public static handleSlackAction(): CancelablePromise<$OpenApiTs['/api/slack/actions']['post']['res'][200]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/slack/actions',
    });
  }
}

export class NotificationsService {
  /**
   * Save a subscription if not saved yet
   * @returns SaveSubscriptionResponseDto
   * @throws ApiError
   */
  public static saveSubscription(
    data: $OpenApiTs['/api/notifications/subscriptions']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/notifications/subscriptions']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/notifications/subscriptions',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get subscriptions list
   * @returns SubscriptionsListResponseDto
   * @throws ApiError
   */
  public static getSubscriptions(): CancelablePromise<
    $OpenApiTs['/api/notifications/subscriptions']['get']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/notifications/subscriptions',
    });
  }

  /**
   * Delete subscription
   * @returns void
   * @throws ApiError
   */
  public static deleteSubscription(
    data: $OpenApiTs['/api/notifications/subscriptions/{sid}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/notifications/subscriptions/{sid}']['delete']['res'][204]> {
    const { sid } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/notifications/subscriptions/{sid}',
      path: {
        sid,
      },
    });
  }

  /**
   * Get all notifications
   * @returns LastNotificationResponseDto
   * @throws ApiError
   */
  public static getAllNotifications(): CancelablePromise<$OpenApiTs['/api/notifications']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/notifications',
    });
  }

  /**
   * Get notification settings
   * @returns GetNotificationSettingsResponseDto
   * @throws ApiError
   */
  public static getNotificationSettings(): CancelablePromise<
    $OpenApiTs['/api/notifications/settings']['get']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/notifications/settings',
    });
  }

  /**
   * Set notification settings
   * @returns UpdateNotificationSettingsResponseDto
   * @throws ApiError
   */
  public static updateNotificationSettings(
    data: $OpenApiTs['/api/notifications/settings']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/notifications/settings']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/notifications/settings',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Set all notifications read
   * @returns SetAllNotificationsReadResponseDto
   * @throws ApiError
   */
  public static setAllNotificationsRead(): CancelablePromise<
    $OpenApiTs['/api/notifications/read']['post']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/notifications/read',
    });
  }

  /**
   * Set notification read
   * @returns void
   * @throws ApiError
   */
  public static setNotificationRead(
    data: $OpenApiTs['/api/notifications/read/{notificationId}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/notifications/read/{notificationId}']['post']['res'][204]> {
    const { notificationId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/notifications/read/{notificationId}',
      path: {
        notificationId,
      },
    });
  }

  /**
   * Unsubscribe
   * @returns void
   * @throws ApiError
   */
  public static unsubscribe(
    data: $OpenApiTs['/api/notifications/unsubscribe']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/notifications/unsubscribe']['post']['res'][204]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/notifications/unsubscribe',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete notification
   * @returns void
   * @throws ApiError
   */
  public static deleteNotification(
    data: $OpenApiTs['/api/notifications/{notificationId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/notifications/{notificationId}']['delete']['res'][204]> {
    const { notificationId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/notifications/{notificationId}',
      path: {
        notificationId,
      },
    });
  }
}

export class NoticeExtractorService {
  /**
   * Extract legal notice data from a PDF in a job S3 folder
   * @returns NoticeExtractorWorkflowResponseDto Notice extraction Temporal workflow
   * @throws ApiError
   */
  public static extractJobAttachment(
    data: $OpenApiTs['/api/notice-extractor/jobs/{jobId}/attachments/{attachmentId}/extract']['post']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/notice-extractor/jobs/{jobId}/attachments/{attachmentId}/extract']['post']['res'][200]
  > {
    const { jobId, attachmentId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/notice-extractor/jobs/{jobId}/attachments/{attachmentId}/extract',
      path: {
        jobId,
        attachmentId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Extract legal notice data from raw text and save the result to S3
   * @returns NoticeExtractorWorkflowResponseDto Notice extraction Temporal workflow
   * @throws ApiError
   */
  public static extractText(
    data: $OpenApiTs['/api/notice-extractor/text/extract']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/notice-extractor/text/extract']['post']['res'][200]> {
    const { apiKey, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/notice-extractor/text/extract',
      headers: {
        'api-key': apiKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Extract legal notice data from a PDF file in S3 and save the result to S3
   * @returns NoticeExtractorWorkflowResponseDto Notice extraction Temporal workflow
   * @throws ApiError
   */
  public static extractSourceFile(
    data: $OpenApiTs['/api/notice-extractor/source-file/extract']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/notice-extractor/source-file/extract']['post']['res'][200]> {
    const { apiKey, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/notice-extractor/source-file/extract',
      headers: {
        'api-key': apiKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get notice extraction Temporal workflow status
   * @returns NoticeExtractorWorkflowStatusResponseDto Notice extraction Temporal workflow status
   * @throws ApiError
   */
  public static getExtractionJobStatus(
    data: $OpenApiTs['/api/notice-extractor/workflows/{jobId}/status']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/notice-extractor/workflows/{jobId}/status']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/notice-extractor/workflows/{jobId}/status',
      path: {
        jobId,
      },
    });
  }
}

export class JobsAdminService {
  /**
   * Get jobs TranscriptUnlockType can be changed status (for admin)
   * @returns ResultResponseDto
   * @throws ApiError
   */
  public static adminGetJobCanChangeTranscriptUnlockType(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/can-change-transcript-unlock-type']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/can-change-transcript-unlock-type']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{jobId}/can-change-transcript-unlock-type',
      path: {
        jobId,
      },
    });
  }

  /**
   * Get job license usage history (for admin)
   * @returns JobLicenseUsageHistoryResponseDto
   * @throws ApiError
   */
  public static adminFindJobLicenseUsageHistory(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/license-usage-history']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/license-usage-history']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{jobId}/license-usage-history',
      path: {
        jobId,
      },
    });
  }

  /**
   * Get job backup files list (for admin)
   * @returns string
   * @throws ApiError
   */
  public static adminGetJobBackupFiles(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/backup-files']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/backup-files']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{jobId}/backup-files',
      path: {
        jobId,
      },
    });
  }

  /**
   * Mixdown and upload backup files (for admin)
   * @returns string
   * @throws ApiError
   */
  public static adminMixdownJobBackupFiles(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/backup-files/mix-down']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/backup-files/mix-down']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{jobId}/backup-files/mix-down',
      path: {
        jobId,
      },
    });
  }

  /**
   * Get mixdown processing status (for admin)
   * @returns CommonBullJobResponseDto
   * @throws ApiError
   */
  public static adminGetMixdownJobBackupFilesStatus(
    data: $OpenApiTs['/api/admin/jobs/{mixdownId}/backup-files/mix-down/status']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{mixdownId}/backup-files/mix-down/status']['get']['res'][200]> {
    const { mixdownId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{mixdownId}/backup-files/mix-down/status',
      path: {
        mixdownId,
      },
    });
  }

  /**
   * Update directly job status for Playwright tests
   * @returns AdminUpdateJobStatusResponseDto
   * @throws ApiError
   */
  public static updateJobStatus(
    data: $OpenApiTs['/api/admin/jobs/jobs/{jobId}/status/{status}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/jobs/{jobId}/status/{status}']['patch']['res'][200]> {
    const { jobId, status } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/jobs/jobs/{jobId}/status/{status}',
      path: {
        jobId,
        status,
      },
    });
  }

  /**
   * Update job transcriptUnlockType
   * @returns void
   * @throws ApiError
   */
  public static updateJobTranscriptUnlockTypeAdmin(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/transcript-unlock-type']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/transcript-unlock-type']['post']['res'][204]> {
    const { jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs/{jobId}/transcript-unlock-type',
      path: {
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Move job to another WS for VS Admins
   * @returns void
   * @throws ApiError
   */
  public static adminMoveJobToOrgWs(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/workspace']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/workspace']['post']['res'][204]> {
    const { jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs/{jobId}/workspace',
      path: {
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Regenerate a job with a new cloud layout (VS Admin)
   * @returns void
   * @throws ApiError
   */
  public static adminRegenerateWithNewLayout(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/regenerate-with-new-layout']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/regenerate-with-new-layout']['post']['res'][204]> {
    const { jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs/{jobId}/regenerate-with-new-layout',
      path: {
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Enqueue clone job from another environment (VS Admin)
   * Returns a Bull queue job id for polling via clone-from-environment/:cloneQueueJobId/status
   * @returns AdminCloneJobEnqueueResponseDto
   * @throws ApiError
   */
  public static adminCloneJobFromEnvironment(
    data: $OpenApiTs['/api/admin/jobs/clone-from-environment']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/clone-from-environment']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs/clone-from-environment',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Enqueue bulk clone jobs from another environment for regression QA (API key)
   * Returns one Bull queue job id for polling via bulk-clone-from-environment/:cloneQueueJobId/status
   * @returns AdminCloneJobEnqueueResponseDto
   * @throws ApiError
   */
  public static adminBulkCloneJobsFromEnvironment(
    data: $OpenApiTs['/api/admin/jobs/bulk-clone-from-environment']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/bulk-clone-from-environment']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs/bulk-clone-from-environment',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get clone-from-environment queue job status (VS Admin)
   * @returns AdminCloneJobStatusResponseDto
   * @throws ApiError
   */
  public static adminGetCloneJobFromEnvironmentStatus(
    data: $OpenApiTs['/api/admin/jobs/clone-from-environment/{cloneQueueJobId}/status']['get']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/admin/jobs/clone-from-environment/{cloneQueueJobId}/status']['get']['res'][200]
  > {
    const { cloneQueueJobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/clone-from-environment/{cloneQueueJobId}/status',
      path: {
        cloneQueueJobId,
      },
    });
  }

  /**
   * Get bulk-clone-from-environment queue job status (API key)
   * @returns AdminBulkCloneJobStatusResponseDto
   * @throws ApiError
   */
  public static adminGetBulkCloneJobsFromEnvironmentStatus(
    data: $OpenApiTs['/api/admin/jobs/bulk-clone-from-environment/{cloneQueueJobId}/status']['get']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/admin/jobs/bulk-clone-from-environment/{cloneQueueJobId}/status']['get']['res'][200]
  > {
    const { cloneQueueJobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/bulk-clone-from-environment/{cloneQueueJobId}/status',
      path: {
        cloneQueueJobId,
      },
    });
  }

  /**
   * Export full job metadata for cloning (API key)
   * Returns job metadata including state snapshot and recording session info for cross-environment cloning
   * @returns AdminCloneJobExportResponseDto
   * @throws ApiError
   */
  public static adminExportJobForClone(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/export-for-clone']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/export-for-clone']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{jobId}/export-for-clone',
      path: {
        jobId,
      },
    });
  }

  /**
   * Update the job No Show attribute (Admin only)
   * @returns void
   * @throws ApiError
   */
  public static updateJobNoShow(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/no-show']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/no-show']['patch']['res'][204]> {
    const { jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/jobs/{jobId}/no-show',
      path: {
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Resubmit job (Admin only)
   * @returns void
   * @throws ApiError
   */
  public static resubmitJob(
    data: $OpenApiTs['/api/admin/jobs/jobs/{jobId}/resubmit-by-admin']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/jobs/{jobId}/resubmit-by-admin']['post']['res'][204]> {
    const {
      jobId,
      chosenTranscriptionModel,
      forceRetranscribe,
      priority,
      clearStylefixCache,
      rushedJob,
      noShow,
      forcePreprocessing,
      useAssemblyTwoStageClustering,
      speakersExpected,
      minSpeakersExpected,
      maxSpeakersExpected,
      llmTranscriptSelectionMode,
    } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs/jobs/{jobId}/resubmit-by-admin',
      path: {
        jobId,
      },
      query: {
        chosenTranscriptionModel,
        forceRetranscribe,
        priority,
        clearStylefixCache,
        rushedJob,
        noShow,
        forcePreprocessing,
        useAssemblyTwoStageClustering,
        speakersExpected,
        minSpeakersExpected,
        maxSpeakersExpected,
        llmTranscriptSelectionMode,
      },
    });
  }

  /**
   * Mark job as reported by admin (Admin only)
   * @returns void
   * @throws ApiError
   */
  public static markJobAsReportedByAdmin(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/mark-as-reported-by-admin']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/mark-as-reported-by-admin']['post']['res'][204]> {
    const { jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs/{jobId}/mark-as-reported-by-admin',
      path: {
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}

export class JobsService {
  /**
   * @returns QuarantineStatusResponseDto
   * @throws ApiError
   */
  public static getJobQuarantineStatus(
    data: $OpenApiTs['/api/jobs/{jobId}/quarantined']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/jobs/{jobId}/quarantined']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/{jobId}/quarantined',
      path: {
        jobId,
      },
    });
  }

  /**
   * @returns GetJobLinkResponseDto
   * @throws ApiError
   */
  public static getJobLink(
    data: $OpenApiTs['/api/jobs/{jobId}/details-link']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/jobs/{jobId}/details-link']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/{jobId}/details-link',
      path: {
        jobId,
      },
    });
  }

  /**
   * Get job backup files list
   * @returns string
   * @throws ApiError
   */
  public static getJobBackupFiles(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/backup-files']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/backup-files']['get']['res'][200]> {
    const { jobId, wsid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/{wsid}/jobs/{jobId}/backup-files',
      path: {
        jobId,
        wsid,
      },
    });
  }

  /**
   * Get mixdown processing status
   * @returns string
   * @throws ApiError
   */
  public static mixdownJobBackupFiles(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/backup-files/mix-down']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/backup-files/mix-down']['get']['res'][200]> {
    const { jobId, wsid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/{wsid}/jobs/{jobId}/backup-files/mix-down',
      path: {
        jobId,
        wsid,
      },
    });
  }

  /**
   * Get mixdown processing status
   * @returns CommonBullJobResponseDto
   * @throws ApiError
   */
  public static getMixdownJobBackupFilesStatus(
    data: $OpenApiTs['/api/{wsid}/jobs/{mixdownId}/backup-files/mix-down/status']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{mixdownId}/backup-files/mix-down/status']['get']['res'][200]> {
    const { mixdownId, wsid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/{wsid}/jobs/{mixdownId}/backup-files/mix-down/status',
      path: {
        mixdownId,
        wsid,
      },
    });
  }

  /**
   * Get jobs TranscriptUnlockType can be changed status
   * @returns ResultResponseDto
   * @throws ApiError
   */
  public static getJobCanChangeTranscriptUnlockType(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/can-change-transcript-unlock-type']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/can-change-transcript-unlock-type']['get']['res'][200]> {
    const { wsid, jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/{wsid}/jobs/{jobId}/can-change-transcript-unlock-type',
      path: {
        wsid,
        jobId,
      },
    });
  }

  /**
   * Get jobs list
   * @returns PaginatedJobResponseDto
   * @throws ApiError
   */
  public static getWsJobs(
    data: $OpenApiTs['/api/{wsid}/jobs']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs']['get']['res'][200]> {
    const { wsid, pageNo, pageSize, orderBy, orderType, search, status, from, to } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/{wsid}/jobs',
      path: {
        wsid,
      },
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
        status,
        from,
        to,
      },
    });
  }

  /**
   * Create job
   * @returns JobResponseDto
   * @throws ApiError
   */
  public static createJob(
    data: $OpenApiTs['/api/{wsid}/jobs']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs']['post']['res'][200]> {
    const { wsid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs',
      path: {
        wsid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete jobs
   * Soft-deletes several jobs. Requires the "Delete jobs" organization permission. Every job id must belong to the workspace in the URL, otherwise the request is rejected and nothing is deleted.
   * @returns SoftDeleteJobsResponseDto
   * @throws ApiError
   */
  public static softDeleteJobs(
    data: $OpenApiTs['/api/{wsid}/jobs']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs']['delete']['res'][200]> {
    const { wsid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/{wsid}/jobs',
      path: {
        wsid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get jobs list for repository
   * @returns PaginatedJobResponseDto
   * @throws ApiError
   */
  public static getRepoJobs(
    data: $OpenApiTs['/api/repository/{repositoryId}/jobs']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repository/{repositoryId}/jobs']['get']['res'][200]> {
    const { repositoryId, pageNo, pageSize, orderBy, orderType, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/repository/{repositoryId}/jobs',
      path: {
        repositoryId,
      },
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
      },
    });
  }

  /**
   * Bulk update
   * @returns BulkUpdateJobsResponseDto
   * @throws ApiError
   */
  public static bulkUpdateJobs(
    data: $OpenApiTs['/api/{wsid}/jobs/bulk']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/bulk']['post']['res'][200]> {
    const { wsid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/bulk',
      path: {
        wsid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Bulk create from repository
   * @returns BulkCreateJobFromRepositoryResponseDto
   * @throws ApiError
   */
  public static bulkCreateRepositoryJobs(
    data: $OpenApiTs['/api/repository/{repositoryId}/jobs/bulk']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repository/{repositoryId}/jobs/bulk']['post']['res'][200]> {
    const { repositoryId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/repository/{repositoryId}/jobs/bulk',
      path: {
        repositoryId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get my jobs list
   * @returns PaginatedJobResponseDto
   * @throws ApiError
   */
  public static getMyJobs(
    data: $OpenApiTs['/api/{wsid}/jobs/my']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/my']['get']['res'][200]> {
    const { wsid, pageNo, pageSize, orderBy, orderType, search, from, to } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/{wsid}/jobs/my',
      path: {
        wsid,
      },
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
        from,
        to,
      },
    });
  }

  /**
   * Get job by ID
   * @returns JobResponseDto
   * @throws ApiError
   */
  public static getJobById(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}']['get']['res'][200]> {
    const { jobId, wsid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/{wsid}/jobs/{jobId}',
      path: {
        jobId,
        wsid,
      },
    });
  }

  /**
   * Edit WS job
   * @returns JobResponseDto
   * @throws ApiError
   */
  public static editJob(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}']['patch']['res'][200]> {
    const { wsid, jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/{wsid}/jobs/{jobId}',
      path: {
        wsid,
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete job
   * Soft-deletes a single job. Requires the "Delete jobs" organization permission.
   * @returns SoftDeleteWSJobResponseDto
   * @throws ApiError
   */
  public static softDeleteWsJob(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}']['delete']['res'][200]> {
    const { wsid, jobId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/{wsid}/jobs/{jobId}',
      path: {
        wsid,
        jobId,
      },
    });
  }

  /**
   * Download Repository ZIP from a job
   * @returns string
   * @throws ApiError
   */
  public static getWsJobRepoZipById(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/repo/zip']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/repo/zip']['get']['res'][200]> {
    const { wsid, jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/{wsid}/jobs/{jobId}/repo/zip',
      path: {
        wsid,
        jobId,
      },
    });
  }

  /**
   * Get job status history
   * @returns GetJobStatusHistoryResponseDto
   * @throws ApiError
   */
  public static getJobStatusHistory(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/status']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/status']['get']['res'][200]> {
    const { jobId, wsid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/{wsid}/jobs/{jobId}/status',
      path: {
        jobId,
        wsid,
      },
    });
  }

  /**
   * Get job assignee history
   * @returns GetJobAssigneeHistoryResponseDto
   * @throws ApiError
   */
  public static getJobAssigneeHistory(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/assignee']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/assignee']['get']['res'][200]> {
    const { jobId, wsid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/{wsid}/jobs/{jobId}/assignee',
      path: {
        jobId,
        wsid,
      },
    });
  }

  /**
   * Get job locked status
   * @returns GetJobLockedStatusResponseDto
   * @throws ApiError
   */
  public static getJobLockedStatus(
    data: $OpenApiTs['/api/jobs/{jobId}/is-locked']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/jobs/{jobId}/is-locked']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/{jobId}/is-locked',
      path: {
        jobId,
      },
    });
  }

  /**
   * Get job locked status
   * @returns GetJobLockedStatusResponseDto
   * @throws ApiError
   */
  public static getJobLockedStatusByRecordingId(
    data: $OpenApiTs['/api/jobs/recording-session/{jobId}/is-locked']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/jobs/recording-session/{jobId}/is-locked']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/recording-session/{jobId}/is-locked',
      path: {
        jobId,
      },
    });
  }

  /**
   * Get job partial unlocked files
   * @returns JobPartialUnlockedFilesResponseDto
   * @throws ApiError
   */
  public static getJobPartialUnlockedFiles(
    data: $OpenApiTs['/api/jobs/{jobId}/partial-unlocked-files']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/jobs/{jobId}/partial-unlocked-files']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/{jobId}/partial-unlocked-files',
      path: {
        jobId,
      },
    });
  }

  /**
   * Download partial unlocked files as ZIP
   * @returns binary ZIP file stream
   * @throws ApiError
   */
  public static downloadPartialUnlockedFilesZip(
    data: $OpenApiTs['/api/jobs/{jobId}/partial-unlocked-files/download-zip']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/jobs/{jobId}/partial-unlocked-files/download-zip']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/{jobId}/partial-unlocked-files/download-zip',
      path: {
        jobId,
      },
    });
  }

  /**
   * Download job attachments as ZIP
   * @returns binary ZIP file stream
   * @throws ApiError
   */
  public static downloadAttachmentsZip(
    data: $OpenApiTs['/api/jobs/{jobId}/attachments/download-zip']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/jobs/{jobId}/attachments/download-zip']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/{jobId}/attachments/download-zip',
      path: {
        jobId,
      },
    });
  }

  /**
   * Move jobs to another WS
   * @returns JobUpdateResponseDto
   * @throws ApiError
   */
  public static moveJobsToWs(
    data: $OpenApiTs['/api/{wsid}/jobs/workspace']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/workspace']['post']['res'][200]> {
    const { wsid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/workspace',
      path: {
        wsid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Change job editing progress
   * @returns string
   * @throws ApiError
   */
  public static setEditingProgress(
    data: $OpenApiTs['/api/jobs/{jobId}/editing-progress']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/jobs/{jobId}/editing-progress']['post']['res'][200]> {
    const { jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/jobs/{jobId}/editing-progress',
      path: {
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Remove draft job
   * @returns void Draft job removed successfully
   * @throws ApiError
   */
  public static removeDraftJob(
    data: $OpenApiTs['/api/{wsid}/draft-jobs/{jobId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/draft-jobs/{jobId}']['delete']['res'][204]> {
    const { wsid, jobId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/{wsid}/draft-jobs/{jobId}',
      path: {
        wsid,
        jobId,
      },
    });
  }

  /**
   * Import keyterms from extracted notice attachments
   * @returns JobResponseDto
   * @throws ApiError
   */
  public static importKeyTermsFromExtractedNotices(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/keyterms/import-from-extracted-notices']['post']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/{wsid}/jobs/{jobId}/keyterms/import-from-extracted-notices']['post']['res'][200]
  > {
    const { wsid, jobId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{jobId}/keyterms/import-from-extracted-notices',
      path: {
        wsid,
        jobId,
      },
    });
  }

  /**
   * Add new attorney access
   * @returns AttorneyAccessResponseDto
   * @throws ApiError
   */
  public static addNewAttorneyAccess(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/attorney-access/{email}/{recordingSessionId}']['post']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/{wsid}/jobs/{jobId}/attorney-access/{email}/{recordingSessionId}']['post']['res'][200]
  > {
    const { wsid, jobId, email, recordingSessionId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{jobId}/attorney-access/{email}/{recordingSessionId}',
      path: {
        wsid,
        jobId,
        email,
        recordingSessionId,
      },
    });
  }

  /**
   * Post job comment
   * @returns CommentJobResponseDto
   * @throws ApiError
   */
  public static commentJob(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/comment']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/comment']['post']['res'][200]> {
    const { wsid, jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{jobId}/comment',
      path: {
        wsid,
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Claim job for transcribing or proofreading
   * @returns ClaimJobResponseDto
   * @throws ApiError
   */
  public static claimJob(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/claim']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/claim']['post']['res'][200]> {
    const { wsid, jobId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{jobId}/claim',
      path: {
        wsid,
        jobId,
      },
    });
  }

  /**
   * Reassign job
   * @returns ReassignJobResponseDto
   * @throws ApiError
   */
  public static reassignJob(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/reassign']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/reassign']['post']['res'][200]> {
    const { wsid, jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{jobId}/reassign',
      path: {
        wsid,
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Update job case (repository)
   * @returns JobUpdateResponseDto
   * @throws ApiError
   */
  public static updateCase(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/case']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/case']['post']['res'][200]> {
    const { wsid, jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{jobId}/case',
      path: {
        wsid,
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Edit job notes
   * @returns EditJobNotesResponseDto
   * @throws ApiError
   */
  public static editJobNotes(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/notes']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/notes']['post']['res'][200]> {
    const { wsid, jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{jobId}/notes',
      path: {
        wsid,
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Edit job tags
   * @returns EditJobTagsResponseDto
   * @throws ApiError
   */
  public static editJobTags(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/tags']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/tags']['post']['res'][200]> {
    const { wsid, jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{jobId}/tags',
      path: {
        wsid,
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete job tag
   * @returns void
   * @throws ApiError
   */
  public static deleteTag(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/tags']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/tags']['delete']['res'][204]> {
    const { jobId, wsid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/{wsid}/jobs/{jobId}/tags',
      path: {
        jobId,
        wsid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Update job transcriptUnlockType
   * @returns void
   * @throws ApiError
   */
  public static updateJobTranscriptUnlockType(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/transcript-unlock-type']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/transcript-unlock-type']['post']['res'][204]> {
    const { wsid, jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{jobId}/transcript-unlock-type',
      path: {
        wsid,
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Update deadline
   * @returns UpdateDeadlineResponseDto
   * @throws ApiError
   */
  public static updateDeadline(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/deadline']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/deadline']['post']['res'][200]> {
    const { wsid, jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{jobId}/deadline',
      path: {
        wsid,
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Move job to another WS
   * @returns JobUpdateResponseDto
   * @throws ApiError
   */
  public static moveJobToWs(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/workspace']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/workspace']['post']['res'][200]> {
    const { wsid, jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{jobId}/workspace',
      path: {
        wsid,
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Set job status to ready for proofreading (transcribing is complete)
   * @returns void
   * @throws ApiError
   */
  public static markJobAsReadyForProofreading(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/readyForProofreading']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/readyForProofreading']['post']['res'][204]> {
    const { wsid, jobId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{jobId}/readyForProofreading',
      path: {
        wsid,
        jobId,
      },
    });
  }

  /**
   * Set job status to ready for final (proofreading is complete)
   * @returns void
   * @throws ApiError
   */
  public static markJobAsReadyForFinal(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/readyForFinal']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/readyForFinal']['post']['res'][204]> {
    const { wsid, jobId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{jobId}/readyForFinal',
      path: {
        wsid,
        jobId,
      },
    });
  }

  /**
   * Set job status to complete
   * @returns void
   * @throws ApiError
   */
  public static markJobAsComplete(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/complete']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/complete']['post']['res'][204]> {
    const { wsid, jobId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{jobId}/complete',
      path: {
        wsid,
        jobId,
      },
    });
  }

  /**
   * Resubmit job
   * @returns void
   * @throws ApiError
   */
  public static resubmitJobWs(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/resubmit']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/resubmit']['post']['res'][204]> {
    const { jobId, wsid } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{jobId}/resubmit',
      path: {
        jobId,
        wsid,
      },
    });
  }

  /**
   * Update job title
   * @returns void
   * @throws ApiError
   */
  public static updateTitle(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/name']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/name']['post']['res'][204]> {
    const { jobId, wsid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{jobId}/name',
      path: {
        jobId,
        wsid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Update job layout
   * @returns UpdateJobLayoutResponseDto
   * @throws ApiError
   */
  public static updateLayout(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/layout']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/layout']['post']['res'][200]> {
    const { jobId, wsid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{jobId}/layout',
      path: {
        jobId,
        wsid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns string
   * @throws ApiError
   */
  public static checkMediaInJob(
    data: $OpenApiTs['/api/jobs/{jobId}/check-media']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/jobs/{jobId}/check-media']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/{jobId}/check-media',
      path: {
        jobId,
      },
    });
  }

  /**
   * @returns JobWorkspacePermissionsResponseDto
   * @throws ApiError
   */
  public static getJobWorkspacePermissions(
    data: $OpenApiTs['/api/jobs/{jobId}/permissions']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/jobs/{jobId}/permissions']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/{jobId}/permissions',
      path: {
        jobId,
      },
    });
  }

  /**
   * Update job layout and trigger transcript preparer
   * @returns void
   * @throws ApiError
   */
  public static regenerateWithNewLayout(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/regenerate-with-new-layout']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/regenerate-with-new-layout']['post']['res'][204]> {
    const { jobId, wsid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{jobId}/regenerate-with-new-layout',
      path: {
        jobId,
        wsid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get S3 upload params for Job Attachments file
   * @returns JobAttachmentUploadLinkResponseDto
   * @throws ApiError
   */
  public static getJobAttachmentUploadLink(
    data: $OpenApiTs['/api/{oid}/{jobId}/attachment-upload-params']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{oid}/{jobId}/attachment-upload-params']['get']['res'][200]> {
    const { oid, jobId, file } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/{oid}/{jobId}/attachment-upload-params',
      path: {
        oid,
        jobId,
      },
      query: {
        file,
      },
    });
  }

  /**
   * Create Job Attachment file
   * @returns JobAttachmentResponseDto
   * @throws ApiError
   */
  public static putAttachment(
    data: $OpenApiTs['/api/{oid}/{jobId}/attachment']['put']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{oid}/{jobId}/attachment']['put']['res'][200]> {
    const { oid, jobId, file, attachmentType } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/{oid}/{jobId}/attachment',
      path: {
        oid,
        jobId,
      },
      query: {
        file,
        attachmentType,
      },
    });
  }

  /**
   * Delete Job Attachment file
   * @returns void Attachment deleted successfully
   * @throws ApiError
   */
  public static deleteAttachment(
    data: $OpenApiTs['/api/{oid}/{jobId}/attachment']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{oid}/{jobId}/attachment']['delete']['res'][204]> {
    const { oid, jobId, file } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/{oid}/{jobId}/attachment',
      path: {
        oid,
        jobId,
      },
      query: {
        file,
      },
    });
  }
}

export class RepositoriesService {
  /**
   * Bulk create from repository
   * @returns BulkCreateJobFromRepositoryResponseDto
   * @throws ApiError
   */
  public static bulkCreateRepositoryJobs(
    data: $OpenApiTs['/api/repository/{repositoryId}/jobs/bulk']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repository/{repositoryId}/jobs/bulk']['post']['res'][200]> {
    const { repositoryId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/repository/{repositoryId}/jobs/bulk',
      path: {
        repositoryId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get S3 upload params for repository file
   * @returns RepositoryUploadParamsResponseDto
   * @throws ApiError
   */
  public static generateUploadParams(
    data: $OpenApiTs['/api/repositories/upload-params']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repositories/upload-params']['get']['res'][200]> {
    const { repositoryId, file } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/repositories/upload-params',
      query: {
        repositoryId,
        file,
      },
    });
  }

  /**
   * Create a new Repository
   * @returns PrismaRepositoryDto
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/repositories']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repositories']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/repositories',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Admin Find all Repository
   * @returns FindOneRepositoryResponseDto
   * @throws ApiError
   */
  public static adminFindAll(): CancelablePromise<$OpenApiTs['/api/repositories']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/repositories',
    });
  }

  /**
   * Find a Repository
   * @returns FindOneRepositoryResponseDto
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/repositories/{repositoryId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repositories/{repositoryId}']['get']['res'][200]> {
    const { repositoryId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/repositories/{repositoryId}',
      path: {
        repositoryId,
      },
    });
  }

  /**
   * Update a Repository
   * @returns PrismaRepositoryDto
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/repositories/{repositoryId}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repositories/{repositoryId}']['patch']['res'][200]> {
    const { repositoryId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/repositories/{repositoryId}',
      path: {
        repositoryId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete a Repository
   * @returns RemoveRepositoryResponseDto
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/repositories/{repositoryId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repositories/{repositoryId}']['delete']['res'][200]> {
    const { repositoryId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/repositories/{repositoryId}',
      path: {
        repositoryId,
      },
    });
  }

  /**
   * Find a Repository
   * @returns FindOneRepositoryResponseDto
   * @throws ApiError
   */
  public static adminFindOne(
    data: $OpenApiTs['/api/repositories/admin/{repositoryId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repositories/admin/{repositoryId}']['get']['res'][200]> {
    const { repositoryId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/repositories/admin/{repositoryId}',
      path: {
        repositoryId,
      },
    });
  }

  /**
   * Find a Repository by slug
   * @returns FindOneRepositoryResponseDto
   * @throws ApiError
   */
  public static findOneBySlug(
    data: $OpenApiTs['/api/repositories/slug/{orgSlug}/{slug}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repositories/slug/{orgSlug}/{slug}']['get']['res'][200]> {
    const { orgSlug, slug } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/repositories/slug/{orgSlug}/{slug}',
      path: {
        orgSlug,
        slug,
      },
    });
  }

  /**
   * Check if the given slug is available (with except the existing repo)
   * @returns SlugAvailableResponseDto
   * @throws ApiError
   */
  public static isRepositorySlugAvailable(
    data: $OpenApiTs['/api/repositories/is-available/{orgSlug}/{repositoryId}/{slug}']['get']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/repositories/is-available/{orgSlug}/{repositoryId}/{slug}']['get']['res'][200]
  > {
    const { orgSlug, repositoryId, slug } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/repositories/is-available/{orgSlug}/{repositoryId}/{slug}',
      path: {
        orgSlug,
        repositoryId,
        slug,
      },
    });
  }

  /**
   * Find all audio Repository attachments
   * @returns PrismaRepositoryAttachmentDto
   * @throws ApiError
   */
  public static findAllAudioAttachments(
    data: $OpenApiTs['/api/repositories/{repositoryId}/attachments/audio']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repositories/{repositoryId}/attachments/audio']['get']['res'][200]> {
    const { repositoryId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/repositories/{repositoryId}/attachments/audio',
      path: {
        repositoryId,
      },
    });
  }

  /**
   * Create a Repository attachment
   * @returns CreateAttachmentResponseDto
   * @throws ApiError
   */
  public static createAttachments(
    data: $OpenApiTs['/api/repositories/{repositoryId}/attachments']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repositories/{repositoryId}/attachments']['post']['res'][200]> {
    const { repositoryId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/repositories/{repositoryId}/attachments',
      path: {
        repositoryId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Download a Repository attachment
   * @returns DownloadAttachmentResponseDto
   * @throws ApiError
   */
  public static downloadAttachment(
    data: $OpenApiTs['/api/repositories/attachments/{repositoryAttachmentId}/download']['get']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/repositories/attachments/{repositoryAttachmentId}/download']['get']['res'][200]
  > {
    const { repositoryAttachmentId, disposition } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/repositories/attachments/{repositoryAttachmentId}/download',
      path: {
        repositoryAttachmentId,
      },
      query: {
        disposition,
      },
    });
  }

  /**
   * Delete a Repository attachment
   * @returns RemoveRepositoryResponseDto
   * @throws ApiError
   */
  public static removeAttachment(
    data: $OpenApiTs['/api/repositories/attachments/{repositoryAttachmentId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repositories/attachments/{repositoryAttachmentId}']['delete']['res'][200]> {
    const { repositoryAttachmentId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/repositories/attachments/{repositoryAttachmentId}',
      path: {
        repositoryAttachmentId,
      },
    });
  }

  /**
   * Reassign job
   * @returns ReassignRepoResponseDto
   * @throws ApiError
   */
  public static reassignRepo(
    data: $OpenApiTs['/api/repositories/{repositoryId}/reassign']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repositories/{repositoryId}/reassign']['post']['res'][200]> {
    const { repositoryId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/repositories/{repositoryId}/reassign',
      path: {
        repositoryId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}

export class JobAttachmentsService {
  /**
   * Get one job attachment
   * @returns JobAttachmentResponseDto
   * @throws ApiError
   */
  public static getAttachment(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/attachments/{attachmentId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/attachments/{attachmentId}']['get']['res'][200]> {
    const { wsid, jobId, attachmentId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/{wsid}/jobs/{jobId}/attachments/{attachmentId}',
      path: {
        wsid,
        jobId,
        attachmentId,
      },
    });
  }

  /**
   * Get one job attachment for admin
   * @returns JobAttachmentResponseDto
   * @throws ApiError
   */
  public static adminGetAttachment(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/attachments/{attachmentId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/attachments/{attachmentId}']['get']['res'][200]> {
    const { jobId, attachmentId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{jobId}/attachments/{attachmentId}',
      path: {
        jobId,
        attachmentId,
      },
    });
  }
}

export class AdminPipelineStatusService {
  /**
   * @returns JobPipelineStatusResponseDto
   * @throws ApiError
   */
  public static getJobPipelineStatus(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/pipeline-status']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/pipeline-status']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{jobId}/pipeline-status',
      path: {
        jobId,
      },
    });
  }

  /**
   * @returns AttemptSummaryDto
   * @throws ApiError
   */
  public static getJobAttempts(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/attempts']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/attempts']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{jobId}/attempts',
      path: {
        jobId,
      },
    });
  }

  /**
   * @returns AttemptDetailsResponseDto
   * @throws ApiError
   */
  public static getAttemptDetails(
    data: $OpenApiTs['/api/admin/jobs/attempts/{attemptId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/attempts/{attemptId}']['get']['res'][200]> {
    const { attemptId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/attempts/{attemptId}',
      path: {
        attemptId,
      },
    });
  }

  /**
   * @returns AttemptLogsResponseDto
   * @throws ApiError
   */
  public static getAttemptLogs(
    data: $OpenApiTs['/api/admin/jobs/attempts/{attemptId}/logs']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/attempts/{attemptId}/logs']['get']['res'][200]> {
    const { attemptId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/attempts/{attemptId}/logs',
      path: {
        attemptId,
      },
    });
  }

  /**
   * @returns JobSummaryDto
   * @throws ApiError
   */
  public static getJobsByStatus(
    data: $OpenApiTs['/api/admin/jobs/by-status/{status}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/by-status/{status}']['get']['res'][200]> {
    const { status, limit } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/by-status/{status}',
      path: {
        status,
      },
      query: {
        limit,
      },
    });
  }

  /**
   * @returns PipelineStatisticsResponseDto
   * @throws ApiError
   */
  public static getPipelineStatistics(
    data: $OpenApiTs['/api/admin/jobs/statistics']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/statistics']['get']['res'][200]> {
    const { from, to } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/statistics',
      query: {
        from,
        to,
      },
    });
  }
}

export class MediaService {
  /**
   * Get upload params
   * @returns any Upload URL and params (JSON)
   * @throws ApiError
   */
  public static generateUploadParams(
    data: $OpenApiTs['/api/media/upload-params']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/upload-params']['get']['res'][200]> {
    const { jobId, file } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/upload-params',
      query: {
        jobId,
        file,
      },
    });
  }

  /**
   * @returns PrismaMediaDto
   * @throws ApiError
   */
  public static createMedia(
    data: $OpenApiTs['/api/media']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/media',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns DeleteMediaResponseDto
   * @throws ApiError
   */
  public static deleteMedia(): CancelablePromise<$OpenApiTs['/api/media']['delete']['res'][200]> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/media',
    });
  }

  /**
   * @returns CommonBullJobResponseDto
   * @throws ApiError
   */
  public static getAnalysisStatus(
    data: $OpenApiTs['/api/media/analysis-status/{mediaId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/analysis-status/{mediaId}']['get']['res'][200]> {
    const { mediaId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/analysis-status/{mediaId}',
      path: {
        mediaId,
      },
    });
  }

  /**
   * @returns any Created media items with jobId, id, fileName, fileSize, fileExtension, weight
   * @throws ApiError
   */
  public static copyRepositoryAttachmentsAsMedia(
    data: $OpenApiTs['/api/media/from-repository']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/from-repository']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/media/from-repository',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static updateMedia(
    data: $OpenApiTs['/api/media/{jobId}/{mediaId}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/{jobId}/{mediaId}']['post']['res'][204]> {
    const { jobId, mediaId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/media/{jobId}/{mediaId}',
      path: {
        jobId,
        mediaId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Download file
   * @returns any File stream (application/octet-stream)
   * @throws ApiError
   */
  public static versionDownload(
    data: $OpenApiTs['/api/media/{jobId}/versions/{versionId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/{jobId}/versions/{versionId}']['get']['res'][200]> {
    const { jobId, versionId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{jobId}/versions/{versionId}',
      path: {
        jobId,
        versionId,
      },
    });
  }

  /**
   * Download file
   * @returns any File stream
   * @throws ApiError
   */
  public static downloadEnhancedMediaFile(
    data: $OpenApiTs['/api/media/{jobId}/enhanced/{file}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/{jobId}/enhanced/{file}']['get']['res'][200]> {
    const { jobId, file } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{jobId}/enhanced/{file}',
      path: {
        jobId,
        file,
      },
    });
  }

  /**
   * Download file
   * @returns any File stream
   * @throws ApiError
   */
  public static downloadTranscriptFile(
    data: $OpenApiTs['/api/media/{jobId}/transcript/{file}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/{jobId}/transcript/{file}']['get']['res'][200]> {
    const { jobId, file } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{jobId}/transcript/{file}',
      path: {
        jobId,
        file,
      },
    });
  }

  /**
   * Download backup file
   * @returns any File stream
   * @throws ApiError
   */
  public static downloadBackupFile(
    data: $OpenApiTs['/api/media/{jobId}/backup/{file}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/{jobId}/backup/{file}']['get']['res'][200]> {
    const { jobId, file } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{jobId}/backup/{file}',
      path: {
        jobId,
        file,
      },
    });
  }

  /**
   * Download exhibit file
   * @returns any File stream
   * @throws ApiError
   */
  public static downloadExhibitFile(
    data: $OpenApiTs['/api/media/{jobId}/exhibits/{file}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/{jobId}/exhibits/{file}']['get']['res'][200]> {
    const { jobId, file } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{jobId}/exhibits/{file}',
      path: {
        jobId,
        file,
      },
    });
  }

  /**
   * Download file
   * @returns any File stream
   * @throws ApiError
   */
  public static downloadAttachmentFile(
    data: $OpenApiTs['/api/media/{jobId}/attachments/{file}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/{jobId}/attachments/{file}']['get']['res'][200]> {
    const { jobId, file } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{jobId}/attachments/{file}',
      path: {
        jobId,
        file,
      },
    });
  }

  /**
   * Download file
   * @returns any File stream
   * @throws ApiError
   */
  public static downloadExhibitAttachmentFile(
    data: $OpenApiTs['/api/media/{jobId}/attachments/exhibits/{file}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/{jobId}/attachments/exhibits/{file}']['get']['res'][200]> {
    const { jobId, file } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{jobId}/attachments/exhibits/{file}',
      path: {
        jobId,
        file,
      },
    });
  }

  /**
   * Download file
   * @returns any File stream
   * @throws ApiError
   */
  public static downloadReporterNotesFile(
    data: $OpenApiTs['/api/media/{jobId}/reporter-notes/{file}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/{jobId}/reporter-notes/{file}']['get']['res'][200]> {
    const { jobId, file } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{jobId}/reporter-notes/{file}',
      path: {
        jobId,
        file,
      },
    });
  }

  /**
   * Download file
   * @returns any File stream
   * @throws ApiError
   */
  public static downloadMediaFile(
    data: $OpenApiTs['/api/media/{jobId}/{file}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/{jobId}/{file}']['get']['res'][200]> {
    const { jobId, file } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{jobId}/{file}',
      path: {
        jobId,
        file,
      },
    });
  }

  /**
   * Download file
   * @returns SignedUrlResponseDto
   * @throws ApiError
   */
  public static downloadSignedMediaFile(
    data: $OpenApiTs['/api/media/job/{jobId}/signed/{file}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/job/{jobId}/signed/{file}']['get']['res'][200]> {
    const { jobId, file, disposition } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/job/{jobId}/signed/{file}',
      path: {
        jobId,
        file,
      },
      query: {
        disposition,
      },
    });
  }

  /**
   * @returns GetFilesListResponseDto
   * @throws ApiError
   */
  public static getFilesList(
    data: $OpenApiTs['/api/media/{jobId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/{jobId}']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{jobId}',
      path: {
        jobId,
      },
    });
  }

  /**
   * @returns DesktopDownloadLinksResponseDto
   * @throws ApiError
   */
  public static getDesktopDownloadLinks(
    data: $OpenApiTs['/api/media/desktop/link/{jobId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/desktop/link/{jobId}']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/desktop/link/{jobId}',
      path: {
        jobId,
      },
    });
  }
}

export class MediaAdminService {
  /**
   * Signed URL (admin)
   * @returns SignedUrlResponseDto
   * @throws ApiError
   */
  public static adminGetSignedUrl(
    data: $OpenApiTs['/api/admin/media/job/{jobId}/signed/{file}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/media/job/{jobId}/signed/{file}']['get']['res'][200]> {
    const { jobId, file, forceCache, disposition } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/media/job/{jobId}/signed/{file}',
      path: {
        jobId,
        file,
      },
      query: {
        forceCache,
        disposition,
      },
    });
  }
}

export class SubscriptionsService {
  /**
   * @returns CreateSubscriptionResponseDto
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/billing-account/{baId}/subscription']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/{baId}/subscription']['post']['res'][200]> {
    const { baId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/billing-account/{baId}/subscription',
      path: {
        baId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns UpgradeSubscriptionResponseDto
   * @throws ApiError
   */
  public static upgrade(
    data: $OpenApiTs['/api/billing-account/{baId}/subscription/{subscriptionId}/upgrade']['post']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/billing-account/{baId}/subscription/{subscriptionId}/upgrade']['post']['res'][200]
  > {
    const { baId, subscriptionId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/billing-account/{baId}/subscription/{subscriptionId}/upgrade',
      path: {
        baId,
        subscriptionId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns RetrySubscriptionPaymentResponseDto
   * @throws ApiError
   */
  public static retryPayment(
    data: $OpenApiTs['/api/billing-account/{baId}/subscription/{subscriptionId}/retry-payment']['post']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/billing-account/{baId}/subscription/{subscriptionId}/retry-payment']['post']['res'][200]
  > {
    const { baId, subscriptionId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/billing-account/{baId}/subscription/{subscriptionId}/retry-payment',
      path: {
        baId,
        subscriptionId,
      },
    });
  }

  /**
   * @returns AdminCreateSubscriptionResponseDto
   * @throws ApiError
   */
  public static adminCreate(
    data: $OpenApiTs['/api/admin/billing-account/{baId}/subscription']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/billing-account/{baId}/subscription']['post']['res'][200]> {
    const { baId, requestBody, overrideExternalManagement } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/billing-account/{baId}/subscription',
      path: {
        baId,
      },
      query: {
        overrideExternalManagement,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns AdminRetrySubscriptionPaymentResponseDto
   * @throws ApiError
   */
  public static adminRetryPayment(
    data: $OpenApiTs['/api/admin/billing-account/{baId}/subscription/{subscriptionId}/retry-payment']['post']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/admin/billing-account/{baId}/subscription/{subscriptionId}/retry-payment']['post']['res'][200]
  > {
    const { baId, subscriptionId, overrideExternalManagement } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/billing-account/{baId}/subscription/{subscriptionId}/retry-payment',
      path: {
        baId,
        subscriptionId,
      },
      query: {
        overrideExternalManagement,
      },
    });
  }

  /**
   * @returns PrismaSubscriptionDto
   * @throws ApiError
   */
  public static findAll(
    data: $OpenApiTs['/api/billing-account/{baId}/subscriptions']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/{baId}/subscriptions']['get']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing-account/{baId}/subscriptions',
      path: {
        baId,
      },
    });
  }

  /**
   * @returns FindOneSubscriptionResponseDto
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/billing-account/{baId}/subscription/{subscriptionId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/{baId}/subscription/{subscriptionId}']['get']['res'][200]> {
    const { baId, subscriptionId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing-account/{baId}/subscription/{subscriptionId}',
      path: {
        baId,
        subscriptionId,
      },
    });
  }

  /**
   * @returns UpdateSubscriptionResponseDto
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/billing-account/{baId}/subscription/{subscriptionId}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/{baId}/subscription/{subscriptionId}']['patch']['res'][200]> {
    const { baId, subscriptionId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/billing-account/{baId}/subscription/{subscriptionId}',
      path: {
        baId,
        subscriptionId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns CancelSubscriptionResponseDto
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/billing-account/{baId}/subscription/{subscriptionId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/{baId}/subscription/{subscriptionId}']['delete']['res'][200]> {
    const { baId, subscriptionId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/billing-account/{baId}/subscription/{subscriptionId}',
      path: {
        baId,
        subscriptionId,
      },
    });
  }

  /**
   * @returns FindOneSubscriptionForAdminResponseDto
   * @throws ApiError
   */
  public static adminFindOne(
    data: $OpenApiTs['/api/admin/subscription/{subscriptionId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/subscription/{subscriptionId}']['get']['res'][200]> {
    const { subscriptionId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/subscription/{subscriptionId}',
      path: {
        subscriptionId,
      },
    });
  }

  /**
   * @returns CancelSubscriptionResponseDto
   * @throws ApiError
   */
  public static adminRemove(
    data: $OpenApiTs['/api/admin/subscription/{subscriptionId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/subscription/{subscriptionId}']['delete']['res'][200]> {
    const { subscriptionId, overrideExternalManagement } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/admin/subscription/{subscriptionId}',
      path: {
        subscriptionId,
      },
      query: {
        overrideExternalManagement,
      },
    });
  }

  /**
   * @returns AdminUpdateSubscriptionResponseDto
   * @throws ApiError
   */
  public static adminUpdate(
    data: $OpenApiTs['/api/admin/billing-account/{baId}/subscription/{subscriptionId}']['patch']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/admin/billing-account/{baId}/subscription/{subscriptionId}']['patch']['res'][200]
  > {
    const { subscriptionId, baId, requestBody, overrideExternalManagement } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/billing-account/{baId}/subscription/{subscriptionId}',
      path: {
        subscriptionId,
        baId,
      },
      query: {
        overrideExternalManagement,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get Organization members list available to assign license
   * @returns GetOrgMembersResponseDto
   * @throws ApiError
   */
  public static getOrgMembers(
    data: $OpenApiTs['/api/billing-account/{baId}/subscription/{subscriptionId}/available-members']['get']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/billing-account/{baId}/subscription/{subscriptionId}/available-members']['get']['res'][200]
  > {
    const { baId, subscriptionId, pageNo, pageSize, orderBy, orderType, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing-account/{baId}/subscription/{subscriptionId}/available-members',
      path: {
        baId,
        subscriptionId,
      },
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
      },
    });
  }

  /**
   * @returns AssignLicenseResponseDto
   * @throws ApiError
   */
  public static assignLicense(
    data: $OpenApiTs['/api/billing-account/{baId}/assign-license']['put']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/{baId}/assign-license']['put']['res'][200]> {
    const { baId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/billing-account/{baId}/assign-license',
      path: {
        baId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static updateLicenseTranscriptUnlockType(
    data: $OpenApiTs['/api/billing-account/{baId}/license/{licenseId}/transcript-unlock-type']['put']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/billing-account/{baId}/license/{licenseId}/transcript-unlock-type']['put']['res'][204]
  > {
    const { baId, licenseId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/billing-account/{baId}/license/{licenseId}/transcript-unlock-type',
      path: {
        baId,
        licenseId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static updateLicenseBackupRecordingFlag(
    data: $OpenApiTs['/api/billing-account/{baId}/license/{licenseId}/backup-recording-flag']['put']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/billing-account/{baId}/license/{licenseId}/backup-recording-flag']['put']['res'][204]
  > {
    const { baId, licenseId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/billing-account/{baId}/license/{licenseId}/backup-recording-flag',
      path: {
        baId,
        licenseId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static updateSubscriptionTranscriptUnlockTypes(
    data: $OpenApiTs['/api/billing-account/{baId}/subscription/{subscriptionId}/transcript-unlock-type']['put']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/billing-account/{baId}/subscription/{subscriptionId}/transcript-unlock-type']['put']['res'][204]
  > {
    const { baId, subscriptionId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/billing-account/{baId}/subscription/{subscriptionId}/transcript-unlock-type',
      path: {
        baId,
        subscriptionId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static adminUpdateSubscriptionTranscriptUnlockTypes(
    data: $OpenApiTs['/api/admin/billing-account/{baId}/subscription/{subscriptionId}/transcript-unlock-type']['put']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/admin/billing-account/{baId}/subscription/{subscriptionId}/transcript-unlock-type']['put']['res'][204]
  > {
    const { baId, subscriptionId, requestBody, overrideExternalManagement } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/admin/billing-account/{baId}/subscription/{subscriptionId}/transcript-unlock-type',
      path: {
        baId,
        subscriptionId,
      },
      query: {
        overrideExternalManagement,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static adminUpdateLicenseTranscriptUnlockType(
    data: $OpenApiTs['/api/admin/billing-account/{baId}/license/{licenseId}/transcript-unlock-type']['put']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/admin/billing-account/{baId}/license/{licenseId}/transcript-unlock-type']['put']['res'][204]
  > {
    const { baId, licenseId, requestBody, overrideExternalManagement } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/admin/billing-account/{baId}/license/{licenseId}/transcript-unlock-type',
      path: {
        baId,
        licenseId,
      },
      query: {
        overrideExternalManagement,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}

export class OrganizationsService {
  /**
   * Create a new organizations with the current user as the owner
   * @returns PrismaOrganizationDto
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/organizations']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/organizations',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * List all organizations for the current user
   * @returns MeResponseDtoOrganization
   * @throws ApiError
   */
  public static findAll(): CancelablePromise<$OpenApiTs['/api/organizations']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations',
    });
  }

  /**
   * Get all attorneys for the organization
   * @returns GetAllAttorneysTransactionsResponseDto
   * @throws ApiError
   */
  public static getAllAttorneysTransactions(
    data: $OpenApiTs['/api/organizations/{organizationId}/attorneys-transactions']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{organizationId}/attorneys-transactions']['get']['res'][200]> {
    const { organizationId, skip, limit, search, orderBy, orderType, from, to } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{organizationId}/attorneys-transactions',
      path: {
        organizationId,
      },
      query: {
        skip,
        limit,
        search,
        orderBy,
        orderType,
        from,
        to,
      },
    });
  }

  /**
   * Get all organization jobs list
   * @returns PaginatedJobResponseDto
   * @throws ApiError
   */
  public static getAllOrganizationJobs(
    data: $OpenApiTs['/api/organizations/{oid}/jobs']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/jobs']['get']['res'][200]> {
    const { oid, statuses, pageNo, pageSize, orderBy, orderType, search, jobsFrom, jobsTo } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}/jobs',
      path: {
        oid,
      },
      query: {
        statuses,
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
        jobsFrom,
        jobsTo,
      },
    });
  }

  /**
   * Shows the details for a particular organization
   * @returns PrismaOrganizationDto
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/organizations/{oid}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}',
      path: {
        oid,
      },
    });
  }

  /**
   * Updates an organization
   * @returns PrismaOrganizationDto
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/organizations/{oid}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}']['patch']['res'][200]> {
    const { oid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/organizations/{oid}',
      path: {
        oid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Deletes an organization
   * @returns RemoveOrganizationResponseDto
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/organizations/{oid}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}']['delete']['res'][200]> {
    const { oid, overrideExternalManagement } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/organizations/{oid}',
      path: {
        oid,
      },
      query: {
        overrideExternalManagement,
      },
    });
  }

  /**
   * Disable user for organization
   * @returns SuccessErrorResponseDto
   * @throws ApiError
   */
  public static disableUser(
    data: $OpenApiTs['/api/organizations/{oid}/disable-user/{userId}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/disable-user/{userId}']['patch']['res'][200]> {
    const { oid, userId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/organizations/{oid}/disable-user/{userId}',
      path: {
        oid,
        userId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete user from organization
   * @returns SuccessErrorResponseDto
   * @throws ApiError
   */
  public static deleteUser(
    data: $OpenApiTs['/api/organizations/{oid}/user/{userId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/user/{userId}']['delete']['res'][200]> {
    const { oid, userId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/organizations/{oid}/user/{userId}',
      path: {
        oid,
        userId,
      },
    });
  }

  /**
   * Updates an organization (for admin)
   * @returns PrismaOrganizationDto
   * @throws ApiError
   */
  public static adminUpdate(
    data: $OpenApiTs['/api/organizations/admin/{oid}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/admin/{oid}']['patch']['res'][200]> {
    const { oid, requestBody, overrideExternalManagement } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/organizations/admin/{oid}',
      path: {
        oid,
      },
      query: {
        overrideExternalManagement,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get upload image params
   * @returns S3SignedUrlResponseDto
   * @throws ApiError
   */
  public static signedUpload(
    data: $OpenApiTs['/api/organizations/{oid}/signed-upload']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/signed-upload']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}/signed-upload',
      path: {
        oid,
      },
    });
  }

  /**
   * Get upload image params (for admin)
   * @returns S3SignedUrlResponseDto
   * @throws ApiError
   */
  public static adminSignedUpload(
    data: $OpenApiTs['/api/organizations/admin/{oid}/signed-upload']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/admin/{oid}/signed-upload']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/admin/{oid}/signed-upload',
      path: {
        oid,
      },
    });
  }

  /**
   * Deletes an organization image
   * @returns SuccessBooleanResponseDto
   * @throws ApiError
   */
  public static removeImage(
    data: $OpenApiTs['/api/organizations/{oid}/image']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/image']['delete']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/organizations/{oid}/image',
      path: {
        oid,
      },
    });
  }

  /**
   * Deletes an organization image (for admin)
   * @returns SuccessBooleanResponseDto
   * @throws ApiError
   */
  public static adminRemoveImage(
    data: $OpenApiTs['/api/organizations/admin/{oid}/image']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/admin/{oid}/image']['delete']['res'][200]> {
    const { oid, overrideExternalManagement } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/organizations/admin/{oid}/image',
      path: {
        oid,
      },
      query: {
        overrideExternalManagement,
      },
    });
  }

  /**
   * Check if the given slug is available (with except the given workspace)
   * @returns AvailableResponseDto
   * @throws ApiError
   */
  public static isOrganizationSlugAvailable(
    data: $OpenApiTs['/api/organizations/is-available/{oid}/{slug}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/is-available/{oid}/{slug}']['get']['res'][200]> {
    const { oid, slug } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/is-available/{oid}/{slug}',
      path: {
        oid,
        slug,
      },
    });
  }

  /**
   * Check if the given slug is available
   * @returns ResultResponseDto
   * @throws ApiError
   */
  public static isSlugAvailable(
    data: $OpenApiTs['/api/organizations/is-available/{slug}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/is-available/{slug}']['get']['res'][200]> {
    const { slug } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/is-available/{slug}',
      path: {
        slug,
      },
    });
  }

  /**
   * Get Organization members list
   * @returns GetOrgMembersResponseDto
   * @throws ApiError
   */
  public static getOrgMembers(
    data: $OpenApiTs['/api/organizations/{oid}/members']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/members']['get']['res'][200]> {
    const { oid, pageNo, pageSize, orderBy, orderType, search, teamsSlugFilter } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}/members',
      path: {
        oid,
      },
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
        teamsSlugFilter,
      },
    });
  }

  /**
   * Get Organization members list for workspace
   * @returns GetOrgMembersMemberResponseDto
   * @throws ApiError
   */
  public static getWorkspaceMembers(
    data: $OpenApiTs['/api/organizations/{oid}/{workspaceId}/members']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/{workspaceId}/members']['get']['res'][200]> {
    const { oid, workspaceId, search, teamsSlugFilter } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}/{workspaceId}/members',
      path: {
        oid,
        workspaceId,
      },
      query: {
        search,
        teamsSlugFilter,
      },
    });
  }

  /**
   * Set members can manage layouts flag
   * @returns void
   * @throws ApiError
   */
  public static setMemberCanManageLayoutFlag(
    data: $OpenApiTs['/api/organizations/{oid}/members/{memberId}/can-manage-layouts']['post']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/organizations/{oid}/members/{memberId}/can-manage-layouts']['post']['res'][204]
  > {
    const { oid, memberId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/organizations/{oid}/members/{memberId}/can-manage-layouts',
      path: {
        oid,
        memberId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get Organization members list for reports
   * @returns GetOrgMemberReportsResponseDto
   * @throws ApiError
   */
  public static getOrgMemberReports(
    data: $OpenApiTs['/api/organizations/{oid}/member-reports']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/member-reports']['get']['res'][200]> {
    const { oid, pageNo, pageSize, orderBy, orderType, search, jobsFrom, jobsTo } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}/member-reports',
      path: {
        oid,
      },
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
        jobsFrom,
        jobsTo,
      },
    });
  }

  /**
   * Change member concurrentJobsLimit
   * @returns ChangeConcurrentJobsLimitResponseDto
   * @throws ApiError
   */
  public static changeConcurrentJobsLimit(
    data: $OpenApiTs['/api/organizations/{oid}/members/{memberId}/concurrentJobsLimit']['post']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/organizations/{oid}/members/{memberId}/concurrentJobsLimit']['post']['res'][200]
  > {
    const { oid, memberId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/organizations/{oid}/members/{memberId}/concurrentJobsLimit',
      path: {
        oid,
        memberId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get Organization workspaces list with statuses
   * @returns WorkspaceWithStatusesResponseDto
   * @throws ApiError
   */
  public static getOrgWorkspaces(
    data: $OpenApiTs['/api/organizations/{oid}/workspaces/statuses']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/workspaces/statuses']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}/workspaces/statuses',
      path: {
        oid,
      },
    });
  }

  /**
   * Get organization invitations list
   * @returns InvitationWithTeams
   * @throws ApiError
   */
  public static getWsInvitations(
    data: $OpenApiTs['/api/organizations/{oid}/invitations']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/invitations']['get']['res'][200]> {
    const { oid, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}/invitations',
      path: {
        oid,
      },
      query: {
        search,
      },
    });
  }

  /**
   * Create organization invitation
   * @returns void
   * @throws ApiError
   */
  public static createInvitation(
    data: $OpenApiTs['/api/organizations/{oid}/invitations']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/invitations']['post']['res'][204]> {
    const { oid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/organizations/{oid}/invitations',
      path: {
        oid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete organization invitation
   * @returns void
   * @throws ApiError
   */
  public static deleteWsInvitation(
    data: $OpenApiTs['/api/organizations/{oid}/invitations/{iid}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/invitations/{iid}']['delete']['res'][204]> {
    const { oid, iid } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/organizations/{oid}/invitations/{iid}',
      path: {
        oid,
        iid,
      },
    });
  }

  /**
   * Create organization invitations by bulk
   * @returns void
   * @throws ApiError
   */
  public static createInvitations(
    data: $OpenApiTs['/api/organizations/{oid}/invitations/bulk']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/invitations/bulk']['post']['res'][204]> {
    const { oid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/organizations/{oid}/invitations/bulk',
      path: {
        oid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get Organization repositories
   * @returns PrismaRepositoryDto
   * @throws ApiError
   */
  public static getOrgReposList(
    data: $OpenApiTs['/api/organizations/{oid}/repositories']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/repositories']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}/repositories',
      path: {
        oid,
      },
    });
  }

  /**
   * Get Organization repositories list with statuses
   * @returns RepositoriesWithStatusesResponseDto
   * @throws ApiError
   */
  public static getOrgRepos(
    data: $OpenApiTs['/api/organizations/{oid}/repositories/statuses']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/repositories/statuses']['get']['res'][200]> {
    const { oid, pageNo, pageSize, orderBy, orderType, search, from, to } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}/repositories/statuses',
      path: {
        oid,
      },
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
        from,
        to,
      },
    });
  }

  /**
   * Get Organization teams list
   * @returns OrganizationTeamResponseDto
   * @throws ApiError
   */
  public static getOrgTeams(
    data: $OpenApiTs['/api/organizations/{oid}/teams']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/teams']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}/teams',
      path: {
        oid,
      },
    });
  }

  /**
   * Get Organization entities list for search
   * @returns SearchResponseDto
   * @throws ApiError
   */
  public static search(
    data: $OpenApiTs['/api/organizations/{oid}/search/{search}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/search/{search}']['get']['res'][200]> {
    const { oid, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}/search/{search}',
      path: {
        oid,
        search,
      },
    });
  }

  /**
   * Get value of org feature flag which is allowing backup recording
   * @returns ResultResponseDto
   * @throws ApiError
   */
  public static getAsOneBackupRecordingAllowedFlag(
    data: $OpenApiTs['/api/organizations/{oid}/asone-backup-recording-allowed']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/asone-backup-recording-allowed']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}/asone-backup-recording-allowed',
      path: {
        oid,
      },
    });
  }

  /**
   * Set subscription backup recording flag globally (updates all licenses)
   * @returns void
   * @throws ApiError
   */
  public static setAsOneBackupRecordingAllowedFlag(
    data: $OpenApiTs['/api/organizations/{oid}/{subscriptionId}/global-asone-backup-recording-flag']['post']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/organizations/{oid}/{subscriptionId}/global-asone-backup-recording-flag']['post']['res'][204]
  > {
    const { oid, subscriptionId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/organizations/{oid}/{subscriptionId}/global-asone-backup-recording-flag',
      path: {
        oid,
        subscriptionId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Set asOneBackupRecordingTermsAccepted flag
   * @returns void
   * @throws ApiError
   */
  public static asOneBackupRecordingAcceptTerms(
    data: $OpenApiTs['/api/organizations/{oid}/asone-backup-recording-accept-terms']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/asone-backup-recording-accept-terms']['post']['res'][204]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/organizations/{oid}/asone-backup-recording-accept-terms',
      path: {
        oid,
      },
    });
  }

  /**
   * Remove organization feature flag (for admin)
   * @returns void
   * @throws ApiError
   */
  public static adminRemoveOrgFeatureFlag(
    data: $OpenApiTs['/api/organizations/admin/{oid}/feature-flag/{ffname}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/admin/{oid}/feature-flag/{ffname}']['delete']['res'][204]> {
    const { oid, ffname, overrideExternalManagement } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/organizations/admin/{oid}/feature-flag/{ffname}',
      path: {
        oid,
        ffname,
      },
      query: {
        overrideExternalManagement,
      },
    });
  }

  /**
   * Get transcription options supported by the organization ASR model
   * @returns TranscriptionSettingsResponseDto
   * @throws ApiError
   */
  public static getOrganizationTranscriptionSettings(
    data: $OpenApiTs['/api/organizations/{organizationId}/transcription-settings']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{organizationId}/transcription-settings']['get']['res'][200]> {
    const { organizationId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{organizationId}/transcription-settings',
      path: {
        organizationId,
      },
    });
  }
}

export class BillingAccountService {
  /**
   * Get available plans
   * @returns GetAllSubscriptionPlansPlanResponseDto
   * @throws ApiError
   */
  public static getAsOnePlans(): CancelablePromise<
    $OpenApiTs['/api/billing-account/subscription-plans']['get']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing-account/subscription-plans',
    });
  }

  /**
   * Get all plans (even unpublished)
   * @returns GetAllSubscriptionPlansPlanResponseDto
   * @throws ApiError
   */
  public static getAllAsOnePlans(): CancelablePromise<
    $OpenApiTs['/api/billing-account/subscription-plans/all']['get']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing-account/subscription-plans/all',
    });
  }

  /**
   * View a Billing Account
   * @returns GetBillingAccountResponseDto
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/billing-account/{baId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/{baId}']['get']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing-account/{baId}',
      path: {
        baId,
      },
    });
  }

  /**
   * Update a Billing Account for an Organization
   * @returns PrismaBillingAccountDto
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/billing-account/{baId}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/{baId}']['patch']['res'][200]> {
    const { baId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/billing-account/{baId}',
      path: {
        baId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * List pending top-ups
   * @returns PendingTopUpResponseDto
   * @throws ApiError
   */
  public static getPendingTopUps(
    data: $OpenApiTs['/api/billing-account/{baId}/pending-top-ups']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/{baId}/pending-top-ups']['get']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing-account/{baId}/pending-top-ups',
      path: {
        baId,
      },
    });
  }

  /**
   * Update a Billing Account auto renew flag
   * @returns PrismaBillingAccountDto
   * @throws ApiError
   */
  public static setAutoRenew(
    data: $OpenApiTs['/api/billing-account/{baId}/auto-renew']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/{baId}/auto-renew']['patch']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/billing-account/{baId}/auto-renew',
      path: {
        baId,
      },
    });
  }

  /**
   * Update a Billing Account auto top up settings
   * @returns PrismaAutoTopUpSettingsDto
   * @throws ApiError
   */
  public static setAutoTopUpSettings(
    data: $OpenApiTs['/api/billing-account/{baId}/auto-top-up-settings']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/{baId}/auto-top-up-settings']['patch']['res'][200]> {
    const { baId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/billing-account/{baId}/auto-top-up-settings',
      path: {
        baId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * List transactions
   * @returns GetTransactionsTransactionResponseDto
   * @throws ApiError
   */
  public static getTransactions(
    data: $OpenApiTs['/api/billing-account/{baId}/transactions']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/{baId}/transactions']['get']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing-account/{baId}/transactions',
      path: {
        baId,
      },
    });
  }

  /**
   * List transactions (for VS Admin)
   * @returns TransactionListResponseDto
   * @throws ApiError
   */
  public static adminGetTransactions(
    data: $OpenApiTs['/api/billing-account/admin/{baId}/transactions']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/admin/{baId}/transactions']['get']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing-account/admin/{baId}/transactions',
      path: {
        baId,
      },
    });
  }

  /**
   * View a Billing Account (for VS Admin)
   * @returns GetBillingAccountResponseDto
   * @throws ApiError
   */
  public static adminFindOne(
    data: $OpenApiTs['/api/billing-account/admin/{baId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/admin/{baId}']['get']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing-account/admin/{baId}',
      path: {
        baId,
      },
    });
  }

  /**
   * Get Billing Account tier rates history
   * @returns GetBillingAccountTierRatesHistoryDto Billing account tier rates history
   * @throws ApiError
   */
  public static getBillingAccountTierRatesHistory(
    data: $OpenApiTs['/api/billing-account/admin/{baId}/tier-rates-history']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/admin/{baId}/tier-rates-history']['get']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing-account/admin/{baId}/tier-rates-history',
      path: {
        baId,
      },
    });
  }
}

export class BillingService {
  /**
   * Unlock a job
   * @returns UnlockJobResponseDto
   * @throws ApiError
   */
  public static unlockJob(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/unlock']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/unlock']['patch']['res'][200]> {
    const { wsid, jobId } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/{wsid}/jobs/{jobId}/unlock',
      path: {
        wsid,
        jobId,
      },
    });
  }

  /**
   * Get ASR usage and current total cost
   * @returns BillingUsageResponseDto
   * @throws ApiError
   */
  public static getUsage(): CancelablePromise<$OpenApiTs['/api/billing/usage']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing/usage',
    });
  }

  /**
   * Get job pricing
   * @returns CalculateJobPricingResponseDto
   * @throws ApiError
   */
  public static calculateJobPricing(
    data: $OpenApiTs['/api/billing/calculate/{jobId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing/calculate/{jobId}']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing/calculate/{jobId}',
      path: {
        jobId,
      },
    });
  }

  /**
   * Get job enhancement pricing
   * @returns CalculateJobEnhancementPricingResponseDto
   * @throws ApiError
   */
  public static calculateJobEnhancementPricing(
    data: $OpenApiTs['/api/billing/calculate-enhance/{jobId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing/calculate-enhance/{jobId}']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing/calculate-enhance/{jobId}',
      path: {
        jobId,
      },
    });
  }

  /**
   * Get job unlock pricing
   * @returns CalculateJobUnlockPricingResponseDto
   * @throws ApiError
   */
  public static calculateJobUnlockPricing(
    data: $OpenApiTs['/api/billing/calculate/{jobId}/unlock']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing/calculate/{jobId}/unlock']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing/calculate/{jobId}/unlock',
      path: {
        jobId,
      },
    });
  }
}

export class StripeService {
  /**
   * Stripe webhook
   * @returns StripeWebhookResponseDto Webhook processed
   * @throws ApiError
   */
  public static stripeWebhook(): CancelablePromise<$OpenApiTs['/api/stripe/webhook']['post']['res'][200]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/stripe/webhook',
    });
  }
}

export class WorkspacesService {
  /**
   * List all workspaces for the current user
   * @returns MeResponseDtoOrganizationWorkspace
   * @throws ApiError
   */
  public static findAll(): CancelablePromise<$OpenApiTs['/api/workspaces']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/workspaces',
    });
  }

  /**
   * Create workspace
   * @returns PrismaWorkspaceDto
   * @throws ApiError
   */
  public static createWorkspace(
    data: $OpenApiTs['/api/workspaces']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/workspaces',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get workspace (for Admin)
   * @returns AdminGetWorkspaceResponseDto
   * @throws ApiError
   */
  public static adminGetWorkspace(
    data: $OpenApiTs['/api/workspaces/admin/{wsid}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces/admin/{wsid}']['get']['res'][200]> {
    const { wsid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/workspaces/admin/{wsid}',
      path: {
        wsid,
      },
    });
  }

  /**
   * Get workspace teams (for Admin)
   * @returns GetTeamsResponseDto
   * @throws ApiError
   */
  public static adminGetTeams(
    data: $OpenApiTs['/api/workspaces/admin/{wsid}/teams']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces/admin/{wsid}/teams']['get']['res'][200]> {
    const { wsid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/workspaces/admin/{wsid}/teams',
      path: {
        wsid,
      },
    });
  }

  /**
   * Check if the given slug is available (with except the given workspace)
   * @returns AvailableResponseDto
   * @throws ApiError
   */
  public static isWorkspaceSlugAvailable(
    data: $OpenApiTs['/api/workspaces/is-available/{oid}/{wsid}/{wsSlug}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces/is-available/{oid}/{wsid}/{wsSlug}']['get']['res'][200]> {
    const { oid, wsid, wsSlug } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/workspaces/is-available/{oid}/{wsid}/{wsSlug}',
      path: {
        oid,
        wsid,
        wsSlug,
      },
    });
  }

  /**
   * Check if the given slug is available
   * @returns AvailableResponseDto
   * @throws ApiError
   */
  public static isSlugAvailable(
    data: $OpenApiTs['/api/workspaces/is-available/{oid}/{wsSlug}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces/is-available/{oid}/{wsSlug}']['get']['res'][200]> {
    const { wsSlug, oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/workspaces/is-available/{oid}/{wsSlug}',
      path: {
        wsSlug,
        oid,
      },
    });
  }

  /**
   * Delete workspace
   * @returns SuccessErrorResponseDto
   * @throws ApiError
   */
  public static deleteWs(
    data: $OpenApiTs['/api/workspaces/{wsid}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces/{wsid}']['delete']['res'][200]> {
    const { wsid, overrideExternalManagement } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/workspaces/{wsid}',
      path: {
        wsid,
      },
      query: {
        overrideExternalManagement,
      },
    });
  }

  /**
   * Update workspace
   * @returns SuccessErrorResponseDto
   * @throws ApiError
   */
  public static updateWorkspace(
    data: $OpenApiTs['/api/workspaces/{wsid}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces/{wsid}']['post']['res'][200]> {
    const { wsid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/workspaces/{wsid}',
      path: {
        wsid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Request workspace access
   * @returns void
   * @throws ApiError
   */
  public static requestWsAccess(
    data: $OpenApiTs['/api/workspaces/{orgSlug}/{wsSlug}/request-access']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces/{orgSlug}/{wsSlug}/request-access']['post']['res'][204]> {
    const { orgSlug, wsSlug } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/workspaces/{orgSlug}/{wsSlug}/request-access',
      path: {
        orgSlug,
        wsSlug,
      },
    });
  }

  /**
   * Get workspace teams
   * @returns GetTeamsResponseDto
   * @throws ApiError
   */
  public static getTeams(
    data: $OpenApiTs['/api/workspaces/{orgSlug}/{wsSlug}/teams']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces/{orgSlug}/{wsSlug}/teams']['get']['res'][200]> {
    const { orgSlug, wsSlug } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/workspaces/{orgSlug}/{wsSlug}/teams',
      path: {
        orgSlug,
        wsSlug,
      },
    });
  }

  /**
   * Update workspace by adding a team
   * @returns void
   * @throws ApiError
   */
  public static updateWorkspaceByAddingTeam(
    data: $OpenApiTs['/api/workspaces/{orgSlug}/{wsSlug}/teams']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces/{orgSlug}/{wsSlug}/teams']['post']['res'][204]> {
    const { orgSlug, wsSlug, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/workspaces/{orgSlug}/{wsSlug}/teams',
      path: {
        orgSlug,
        wsSlug,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get available teams for workspace
   * @returns OrganizationTeamWithMembersResponseDto
   * @throws ApiError
   */
  public static getAvailableTeams(
    data: $OpenApiTs['/api/workspaces/{orgSlug}/{wsSlug}/teams/available']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces/{orgSlug}/{wsSlug}/teams/available']['get']['res'][200]> {
    const { orgSlug, wsSlug } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/workspaces/{orgSlug}/{wsSlug}/teams/available',
      path: {
        orgSlug,
        wsSlug,
      },
    });
  }

  /**
   * Update workspace by removing a team
   * @returns void
   * @throws ApiError
   */
  public static updateWorkspaceByRemovingTeam(
    data: $OpenApiTs['/api/workspaces/{orgSlug}/{wsSlug}/teams/{teamId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces/{orgSlug}/{wsSlug}/teams/{teamId}']['delete']['res'][204]> {
    const { orgSlug, wsSlug, teamId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/workspaces/{orgSlug}/{wsSlug}/teams/{teamId}',
      path: {
        orgSlug,
        wsSlug,
        teamId,
      },
    });
  }

  /**
   * Get workspace
   * @returns GetWorkspaceBySlugsResponseDto
   * @throws ApiError
   */
  public static getWorkspaceBySlugs(
    data: $OpenApiTs['/api/workspaces/{orgSlug}/{wsSlug}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces/{orgSlug}/{wsSlug}']['get']['res'][200]> {
    const { orgSlug, wsSlug } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/workspaces/{orgSlug}/{wsSlug}',
      path: {
        orgSlug,
        wsSlug,
      },
    });
  }
}

export class SsoProviderService {
  /**
   * Create new SSO Provider
   * @returns PrismaSSOProviderDto
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/sso-providers/admin']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/sso-providers/admin']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/sso-providers/admin',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Find all SSO Providers
   * @returns FindAllSsoProvidersResponseDto
   * @throws ApiError
   */
  public static findAll(
    data: $OpenApiTs['/api/sso-providers/admin']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/sso-providers/admin']['get']['res'][200]> {
    const { pageNo, pageSize, orderBy, orderType, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/sso-providers/admin',
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
      },
    });
  }

  /**
   * Find one SSO Provider
   * @returns PrismaSSOProviderDto
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/sso-providers/admin/{ssoProviderId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/sso-providers/admin/{ssoProviderId}']['get']['res'][200]> {
    const { ssoProviderId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/sso-providers/admin/{ssoProviderId}',
      path: {
        ssoProviderId,
      },
    });
  }

  /**
   * Update a SSO Provider
   * @returns PrismaSSOProviderDto
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/sso-providers/admin/{ssoProviderId}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/sso-providers/admin/{ssoProviderId}']['patch']['res'][200]> {
    const { ssoProviderId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/sso-providers/admin/{ssoProviderId}',
      path: {
        ssoProviderId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete a SSO Provider
   * @returns PrismaSSOProviderDto
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/sso-providers/admin/{ssoProviderId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/sso-providers/admin/{ssoProviderId}']['delete']['res'][200]> {
    const { ssoProviderId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/sso-providers/admin/{ssoProviderId}',
      path: {
        ssoProviderId,
      },
    });
  }

  /**
   * Check if domain requires SSO
   * @returns CheckDomainResponseDto
   * @throws ApiError
   */
  public static checkDomain(
    data: $OpenApiTs['/api/sso-providers/check-domain']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/sso-providers/check-domain']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/sso-providers/check-domain',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}

export class AttorneysService {
  /**
   * @returns any
   * @throws ApiError
   */
  public static getOrganizationsList(
    data: $OpenApiTs['/api/attorneys/{email}/organizations']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/attorneys/{email}/organizations']['get']['res'][200]> {
    const { email } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/attorneys/{email}/organizations',
      path: {
        email,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static getRecordingSessionsListWithSearch(
    data: $OpenApiTs['/api/attorneys/{email}/recording-sessions']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/attorneys/{email}/recording-sessions']['get']['res'][200]> {
    const { email, search, statuses, from, to } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/attorneys/{email}/recording-sessions',
      path: {
        email,
      },
      query: {
        search,
        statuses,
        from,
        to,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static getRecordingSessionAccessListByOrganizationSlugWithSearch(
    data: $OpenApiTs['/api/attorneys/{email}/organizations/{slug}/recording-sessions']['get']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/attorneys/{email}/organizations/{slug}/recording-sessions']['get']['res'][200]
  > {
    const { email, slug, search, statuses, from, to } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/attorneys/{email}/organizations/{slug}/recording-sessions',
      path: {
        email,
        slug,
      },
      query: {
        search,
        statuses,
        from,
        to,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static getRecordingSession(
    data: $OpenApiTs['/api/attorneys/{email}/recording-session/{recordingSessionId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/attorneys/{email}/recording-session/{recordingSessionId}']['get']['res'][200]> {
    const { email, recordingSessionId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/attorneys/{email}/recording-session/{recordingSessionId}',
      path: {
        email,
        recordingSessionId,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static revokeRecordingSessionAccess(
    data: $OpenApiTs['/api/attorneys/{email}/recording-session/{recordingSessionId}/access']['delete']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/attorneys/{email}/recording-session/{recordingSessionId}/access']['delete']['res'][200]
  > {
    const { email, recordingSessionId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/attorneys/{email}/recording-session/{recordingSessionId}/access',
      path: {
        email,
        recordingSessionId,
      },
    });
  }

  /**
   * Get recording session liveness status for attorneys
   * Returns whether the recording session is currently active based on billing checkpoint heartbeats.
   * @returns RecordingSessionLivenessStatusResponseDto Liveness status retrieved successfully
   * @throws ApiError
   */
  public static getRecordingSessionLivenessStatus(
    data: $OpenApiTs['/api/attorneys/{email}/recording-session/{recordingSessionId}/liveness-status']['get']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/attorneys/{email}/recording-session/{recordingSessionId}/liveness-status']['get']['res'][200]
  > {
    const { email, recordingSessionId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/attorneys/{email}/recording-session/{recordingSessionId}/liveness-status',
      path: {
        email,
        recordingSessionId,
      },
      errors: {
        403: `Attorney does not have access to this recording session`,
      },
    });
  }

  /**
   * @returns boolean
   * @throws ApiError
   */
  public static updateAccessOnlineStatus(
    data: $OpenApiTs['/api/attorneys/{email}/{recordingSessionId}/online/{status}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/attorneys/{email}/{recordingSessionId}/online/{status}']['post']['res'][200]> {
    const { email, recordingSessionId, status } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/attorneys/{email}/{recordingSessionId}/online/{status}',
      path: {
        email,
        recordingSessionId,
        status,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static chargeAttorneyConnectionFee(
    data: $OpenApiTs['/api/attorneys/{email}/{recordingSessionId}/attorney-connection']['post']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/attorneys/{email}/{recordingSessionId}/attorney-connection']['post']['res'][200]
  > {
    const { email, recordingSessionId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/attorneys/{email}/{recordingSessionId}/attorney-connection',
      path: {
        email,
        recordingSessionId,
      },
    });
  }

  /**
   * Download exhibit file
   * @returns any
   * @throws ApiError
   */
  public static downloadExhibitFile(
    data: $OpenApiTs['/api/attorneys/{email}/{recordingSessionId}/exhibit/{fileName}']['get']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/attorneys/{email}/{recordingSessionId}/exhibit/{fileName}']['get']['res'][200]
  > {
    const { email, recordingSessionId, fileName } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/attorneys/{email}/{recordingSessionId}/exhibit/{fileName}',
      path: {
        email,
        recordingSessionId,
        fileName,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static uploadExhibitFile(
    data: $OpenApiTs['/api/attorneys/exhibits/upload-file']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/attorneys/exhibits/upload-file']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/attorneys/exhibits/upload-file',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns S3SignedUrlResponseDto
   * @throws ApiError
   */
  public static uploadExhibitsParams(
    data: $OpenApiTs['/api/attorneys/exhibits/upload-params']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/attorneys/exhibits/upload-params']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/attorneys/exhibits/upload-params',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static getExhibitsList(
    data: $OpenApiTs['/api/attorneys/{email}/{recordingSessionId}/exhibits/list']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/attorneys/{email}/{recordingSessionId}/exhibits/list']['get']['res'][200]> {
    const { email, recordingSessionId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/attorneys/{email}/{recordingSessionId}/exhibits/list',
      path: {
        email,
        recordingSessionId,
      },
    });
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static getInvitations(
    data: $OpenApiTs['/api/attorneys/asone/{recordingSessionId}/invitations']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/attorneys/asone/{recordingSessionId}/invitations']['get']['res'][200]> {
    const { recordingSessionId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/attorneys/asone/{recordingSessionId}/invitations',
      path: {
        recordingSessionId,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static inviteAttorney(
    data: $OpenApiTs['/api/attorneys/asone/{recordingSessionId}/invite']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/attorneys/asone/{recordingSessionId}/invite']['post']['res'][200]> {
    const { recordingSessionId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/attorneys/asone/{recordingSessionId}/invite',
      path: {
        recordingSessionId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns UsePasscodeResponseDto
   * @throws ApiError
   */
  public static usePasscode(
    data: $OpenApiTs['/api/attorneys/{email}/passcode']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/attorneys/{email}/passcode']['post']['res'][200]> {
    const { email, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/attorneys/{email}/passcode',
      path: {
        email,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static getTranscriptAiMessagesHistory(
    data: $OpenApiTs['/api/attorneys/transcript/{transcriptId}/chat/{email}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/attorneys/transcript/{transcriptId}/chat/{email}']['get']['res'][200]> {
    const { transcriptId, email } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/attorneys/transcript/{transcriptId}/chat/{email}',
      path: {
        transcriptId,
        email,
      },
    });
  }

  /**
   * Send question to AI with transcript context
   * @returns any
   * @throws ApiError
   */
  public static sendTranscriptQuestionToAi(
    data: $OpenApiTs['/api/attorneys/transcript/{transcriptId}/chat/{email}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/attorneys/transcript/{transcriptId}/chat/{email}']['post']['res'][200]> {
    const { transcriptId, email, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/attorneys/transcript/{transcriptId}/chat/{email}',
      path: {
        transcriptId,
        email,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}

export class RecordingSessionService {
  /**
   * View all active recording sessions for the current user
   * @returns PrismaRecordingSessionDto
   * @throws ApiError
   */
  public static findAllForUser(): CancelablePromise<$OpenApiTs['/api/recording-session']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/recording-session',
    });
  }

  /**
   * Create a new draft job and assign the current user
   * @returns CreateDraftJobResponseDto
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/recording-session/create']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/recording-session/create']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/recording-session/create',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Find one recording session if active
   * @returns PrismaRecordingSessionDto
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/recording-session/{recordingSessionId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/recording-session/{recordingSessionId}']['get']['res'][200]> {
    const { recordingSessionId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/recording-session/{recordingSessionId}',
      path: {
        recordingSessionId,
      },
    });
  }

  /**
   * Submit preprocessing or set recording session status
   * @returns void
   * @throws ApiError
   */
  public static submitPreprocessing(
    data: $OpenApiTs['/api/recording-session/{recordingSessionId}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/recording-session/{recordingSessionId}']['patch']['res'][204]> {
    const { recordingSessionId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/recording-session/{recordingSessionId}',
      path: {
        recordingSessionId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Find one recording session if active
   * @returns CheckAllowanceResponseDto
   * @throws ApiError
   */
  public static allowedToStartSession(
    data: $OpenApiTs['/api/recording-session/{recordingSessionId}/check']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/recording-session/{recordingSessionId}/check']['get']['res'][200]> {
    const { recordingSessionId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/recording-session/{recordingSessionId}/check',
      path: {
        recordingSessionId,
      },
    });
  }

  /**
   * Check if user can start recording session
   * @returns CheckAllowanceResponseDto
   * @throws ApiError
   */
  public static checkRecordingSession(
    data: $OpenApiTs['/api/recording-session/check-allowance-to-create-for-organization/{oid}']['get']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/recording-session/check-allowance-to-create-for-organization/{oid}']['get']['res'][200]
  > {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/recording-session/check-allowance-to-create-for-organization/{oid}',
      path: {
        oid,
      },
    });
  }

  /**
   * Check if user can start recording session
   * @returns CheckAllowanceResponseDto
   * @throws ApiError
   */
  public static checkBalanceIsValid(
    data: $OpenApiTs['/api/recording-session/valid-balance/{licenseId}/asr/{isAsrEnableByUserRequest}']['get']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/recording-session/valid-balance/{licenseId}/asr/{isAsrEnableByUserRequest}']['get']['res'][200]
  > {
    const { licenseId, isAsrEnableByUserRequest } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/recording-session/valid-balance/{licenseId}/asr/{isAsrEnableByUserRequest}',
      path: {
        licenseId,
        isAsrEnableByUserRequest,
      },
    });
  }

  /**
   * Generate a signed upload for a file
   * @returns any S3 signed upload URL
   * @throws ApiError
   */
  public static upload(
    data: $OpenApiTs['/api/recording-session/{recordingSessionId}/upload-params']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/recording-session/{recordingSessionId}/upload-params']['get']['res'][200]> {
    const { recordingSessionId, file, type } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/recording-session/{recordingSessionId}/upload-params',
      path: {
        recordingSessionId,
      },
      query: {
        file,
        type,
      },
    });
  }

  /**
   * Update job transcriptUnlockType
   * @returns string
   * @throws ApiError
   */
  public static updateJobTranscriptUnlockTypeAsOne(
    data: $OpenApiTs['/api/recording-session/{recordingSessionId}/transcript-unlock-type']['post']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/recording-session/{recordingSessionId}/transcript-unlock-type']['post']['res'][200]
  > {
    const { recordingSessionId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/recording-session/{recordingSessionId}/transcript-unlock-type',
      path: {
        recordingSessionId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Add billing checkpoint to recording session
   * @returns AddBillingCheckpointResponseDto
   * @throws ApiError
   */
  public static addBillingCheckpoint(
    data: $OpenApiTs['/api/recording-session/{recordingSessionId}/billing-checkpoint']['post']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/recording-session/{recordingSessionId}/billing-checkpoint']['post']['res'][200]
  > {
    const { recordingSessionId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/recording-session/{recordingSessionId}/billing-checkpoint',
      path: {
        recordingSessionId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get recording session liveness status
   * Returns whether the recording session is currently active based on billing checkpoint heartbeats
   * @returns RecordingSessionLivenessStatusResponseDto
   * @throws ApiError
   */
  public static getSessionLivenessStatus(
    data: $OpenApiTs['/api/recording-session/{recordingSessionId}/liveness-status']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/recording-session/{recordingSessionId}/liveness-status']['get']['res'][200]> {
    const { recordingSessionId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/recording-session/{recordingSessionId}/liveness-status',
      path: {
        recordingSessionId,
      },
    });
  }

  /**
   * Get recording session files names with sizes
   * @returns RecordingSessionFileItemResponseDto
   * @throws ApiError
   */
  public static getRecordingSessionFilesNamesWithSize(
    data: $OpenApiTs['/api/recording-session/{recordingSessionId}/files']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/recording-session/{recordingSessionId}/files']['get']['res'][200]> {
    const { recordingSessionId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/recording-session/{recordingSessionId}/files',
      path: {
        recordingSessionId,
      },
    });
  }
}

export class PaymentService {
  /**
   * @returns StripePaymentIntentResponseDto
   * @throws ApiError
   */
  public static createPaymentIntent(
    data: $OpenApiTs['/api/payment/billing-account/{baId}/payment']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/payment/billing-account/{baId}/payment']['post']['res'][200]> {
    const { baId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/payment/billing-account/{baId}/payment',
      path: {
        baId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns StripePaymentIntentResponseDto
   * @throws ApiError
   */
  public static billingAccountSavePaymentForJobSubmit(
    data: $OpenApiTs['/api/payment/billing-account/{baId}/payment/job-submit']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/payment/billing-account/{baId}/payment/job-submit']['post']['res'][200]> {
    const { baId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/payment/billing-account/{baId}/payment/job-submit',
      path: {
        baId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns StripePaymentIntentResponseDto
   * @throws ApiError
   */
  public static confirmPaymentIntent(
    data: $OpenApiTs['/api/payment/billing-account/payment/confirm']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/payment/billing-account/payment/confirm']['patch']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/payment/billing-account/payment/confirm',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns StripePaymentIntentResponseDto
   * @throws ApiError
   */
  public static getPaymentIntent(
    data: $OpenApiTs['/api/payment/getPaymentIntent']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/payment/getPaymentIntent']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/payment/getPaymentIntent',
      query: {
        id,
      },
    });
  }

  /**
   * @returns PaymentMethodResponseDto
   * @throws ApiError
   */
  public static billingAccountPaymentMethodList(
    data: $OpenApiTs['/api/payment/billing-account/{baId}/payment-methods']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/payment/billing-account/{baId}/payment-methods']['get']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/payment/billing-account/{baId}/payment-methods',
      path: {
        baId,
      },
    });
  }

  /**
   * @returns HasPaymentMethodResponseDto
   * @throws ApiError
   */
  public static billingAccountHasPaymentMethod(
    data: $OpenApiTs['/api/payment/billing-account/{baId}/has-payment-method']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/payment/billing-account/{baId}/has-payment-method']['get']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/payment/billing-account/{baId}/has-payment-method',
      path: {
        baId,
      },
    });
  }

  /**
   * @returns PaymentMethodResponseDto
   * @throws ApiError
   */
  public static adminBillingAccountPaymentMethodList(
    data: $OpenApiTs['/api/payment/admin/billing-account/{baId}/payment-methods']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/payment/admin/billing-account/{baId}/payment-methods']['get']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/payment/admin/billing-account/{baId}/payment-methods',
      path: {
        baId,
      },
    });
  }

  /**
   * @returns PaymentMethodResponseDto
   * @throws ApiError
   */
  public static billingAccountPaymentMethodListForJobSubmission(
    data: $OpenApiTs['/api/payment/billing-account/{baId}/payment-methods/job-submit']['get']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/payment/billing-account/{baId}/payment-methods/job-submit']['get']['res'][200]
  > {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/payment/billing-account/{baId}/payment-methods/job-submit',
      path: {
        baId,
      },
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static billingAccountSetDefaultPaymentMethod(
    data: $OpenApiTs['/api/payment/billing-account/{baId}/payment-method/{paymentMethodId}/set-default']['patch']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/payment/billing-account/{baId}/payment-method/{paymentMethodId}/set-default']['patch']['res'][204]
  > {
    const { baId, paymentMethodId } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/payment/billing-account/{baId}/payment-method/{paymentMethodId}/set-default',
      path: {
        baId,
        paymentMethodId,
      },
    });
  }

  /**
   * @returns ReceiptResponseDto
   * @throws ApiError
   */
  public static billingAccountReceipts(
    data: $OpenApiTs['/api/payment/billing-account/{baId}/receipts']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/payment/billing-account/{baId}/receipts']['get']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/payment/billing-account/{baId}/receipts',
      path: {
        baId,
      },
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static billingAccountCancelPaymentMethod(
    data: $OpenApiTs['/api/payment/billing-account/{baId}/payment-method/{paymentMethodId}']['delete']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/payment/billing-account/{baId}/payment-method/{paymentMethodId}']['delete']['res'][204]
  > {
    const { baId, paymentMethodId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/payment/billing-account/{baId}/payment-method/{paymentMethodId}',
      path: {
        baId,
        paymentMethodId,
      },
    });
  }

  /**
   * @returns CreateBankAccountResponseDto
   * @throws ApiError
   */
  public static billingAccountCreateBankAccount(
    data: $OpenApiTs['/api/payment/billing-account/{baId}/bank-account']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/payment/billing-account/{baId}/bank-account']['post']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/payment/billing-account/{baId}/bank-account',
      path: {
        baId,
      },
    });
  }

  /**
   * @returns BillingAccountAddPaymentMethodResponseDto
   * @throws ApiError
   */
  public static billingAccountAddPaymentMethod(
    data: $OpenApiTs['/api/payment/billing-account/{baId}/payment-method']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/payment/billing-account/{baId}/payment-method']['post']['res'][200]> {
    const { baId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/payment/billing-account/{baId}/payment-method',
      path: {
        baId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get invoices
   * @returns InvoiceListItemResponseDto
   * @throws ApiError
   */
  public static billingAccountGetInvoices(
    data: $OpenApiTs['/api/payment/billing-account/{baId}/invoices']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/payment/billing-account/{baId}/invoices']['get']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/payment/billing-account/{baId}/invoices',
      path: {
        baId,
      },
    });
  }

  /**
   * Get invoice data
   * @returns InvoiceWithLinesResponseDto
   * @throws ApiError
   */
  public static getInvoice(
    data: $OpenApiTs['/api/payment/billing-account/{baId}/invoice/{invoiceId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/payment/billing-account/{baId}/invoice/{invoiceId}']['get']['res'][200]> {
    const { baId, invoiceId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/payment/billing-account/{baId}/invoice/{invoiceId}',
      path: {
        baId,
        invoiceId,
      },
    });
  }
}

export class UserService {
  /**
   * Get upload avatar params
   * @returns S3SignedUrlResponseDto
   * @throws ApiError
   */
  public static ftpUploads(): CancelablePromise<$OpenApiTs['/api/user/upload-params']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/user/upload-params',
    });
  }

  /**
   * Get user details
   * @returns GetUserDetailsResponseDto
   * @throws ApiError
   */
  public static getUserDetails(
    data: $OpenApiTs['/api/user/{oid}/{userId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/user/{oid}/{userId}']['get']['res'][200]> {
    const { oid, userId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/user/{oid}/{userId}',
      path: {
        oid,
        userId,
      },
    });
  }

  /**
   * Update user info
   * @returns UpdateAccountResponseDto
   * @throws ApiError
   */
  public static updateAccount(
    data: $OpenApiTs['/api/user/account']['put']['req'],
  ): CancelablePromise<$OpenApiTs['/api/user/account']['put']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/user/account',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Update agreement flag
   * @returns void
   * @throws ApiError
   */
  public static agreement(): CancelablePromise<$OpenApiTs['/api/user/agreement']['post']['res'][204]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/user/agreement',
    });
  }

  /**
   * Upload avatar
   * @returns void
   * @throws ApiError
   */
  public static uploadAvatar(
    data: $OpenApiTs['/api/user/avatar']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/user/avatar']['post']['res'][204]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/user/avatar',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete avatar
   * @returns void
   * @throws ApiError
   */
  public static deleteAvatar(): CancelablePromise<$OpenApiTs['/api/user/avatar']['delete']['res'][204]> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/user/avatar',
    });
  }

  /**
   * Update onboarding flag
   * @returns void
   * @throws ApiError
   */
  public static onboarding(): CancelablePromise<$OpenApiTs['/api/user/onboarding']['post']['res'][204]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/user/onboarding',
    });
  }

  /**
   * Update downloaded desktop flag
   * @returns void
   * @throws ApiError
   */
  public static downloadedClient(): CancelablePromise<$OpenApiTs['/api/user/downloadedDesktop']['post']['res'][204]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/user/downloadedDesktop',
    });
  }
}

export class AuthService {
  /**
   * Get auth info
   * @returns MeResponseDto
   * @throws ApiError
   */
  public static me(): CancelablePromise<$OpenApiTs['/api/auth/me']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/auth/me',
    });
  }

  /**
   * Get last 5 notifications
   * @returns LastNotificationResponseDto
   * @throws ApiError
   */
  public static lastNotifications(): CancelablePromise<
    $OpenApiTs['/api/auth/me/last-notifications']['get']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/auth/me/last-notifications',
    });
  }

  /**
   * Get is logged in flag
   * @returns string
   * @throws ApiError
   */
  public static getUserId(): CancelablePromise<$OpenApiTs['/api/auth/userId']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/auth/userId',
    });
  }

  /**
   * Test JWT
   * @returns TestJwtResponseDto
   * @throws ApiError
   */
  public static testJwt(): CancelablePromise<$OpenApiTs['/api/auth/test-jwt']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/auth/test-jwt',
    });
  }

  /**
   * Register
   * @returns PrismaUserDto
   * @throws ApiError
   */
  public static register(
    data: $OpenApiTs['/api/auth/register']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/auth/register']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/auth/register',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Confirm account
   * @throws ApiError
   */
  public static confirm(data: $OpenApiTs['/api/auth/confirm']['get']['req']): CancelablePromise<void> {
    const { code, email, goto } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/auth/confirm',
      query: {
        code,
        email,
        goto,
      },
      errors: {
        302: `Redirect to register-success or register-token-expired`,
      },
    });
  }

  /**
   * Login
   * @returns LoginResponseDto
   * @throws ApiError
   */
  public static login(
    data: $OpenApiTs['/api/auth/login']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/auth/login']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/auth/login',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * SSO Login
   * @returns LoginResponseDto
   * @throws ApiError
   */
  public static ssoLogin(
    data: $OpenApiTs['/api/auth/sso/login']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/auth/sso/login']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/auth/sso/login',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Mark an SSO provider session as observed
   * @returns void
   * @throws ApiError
   */
  public static markSsoProviderSession(): CancelablePromise<$OpenApiTs['/api/auth/sso/session']['post']['res'][204]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/auth/sso/session',
    });
  }

  /**
   * Clear the SSO provider session marker
   * @returns void
   * @throws ApiError
   */
  public static clearSsoProviderSession(): CancelablePromise<
    $OpenApiTs['/api/auth/sso/session']['delete']['res'][204]
  > {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/auth/sso/session',
    });
  }

  /**
   * Recover password
   * @returns void
   * @throws ApiError
   */
  public static recover(
    data: $OpenApiTs['/api/auth/recover']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/auth/recover']['post']['res'][204]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/auth/recover',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Reset password
   * @returns void
   * @throws ApiError
   */
  public static resetPasswordCallback(
    data: $OpenApiTs['/api/auth/resetpassword']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/auth/resetpassword']['get']['res'][204]> {
    const { email, code } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/auth/resetpassword',
      query: {
        email,
        code,
      },
    });
  }

  /**
   * Set password
   * @returns AuthSessionResponseDto
   * @throws ApiError
   */
  public static passwd(
    data: $OpenApiTs['/api/auth/passwd']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/auth/passwd']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/auth/passwd',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Refresh JWT token
   * @returns RefreshResponseDto
   * @throws ApiError
   */
  public static refreshToken(): CancelablePromise<$OpenApiTs['/api/auth/refresh']['post']['res'][201]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/auth/refresh',
    });
  }

  /**
   * Clear application cookies and start Cognito logout
   * @returns LogoutResponseDto
   * @throws ApiError
   */
  public static logout(): CancelablePromise<$OpenApiTs['/api/auth/logout']['post']['res'][200]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/auth/logout',
    });
  }

  /**
   * Check phone number
   * @returns CheckPhoneNumberResponseDto
   * @throws ApiError
   */
  public static checkPhoneNumber(
    data: $OpenApiTs['/api/auth/check-phone-number']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/auth/check-phone-number']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/auth/check-phone-number',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Check email
   * @returns CheckEmailResponseDto
   * @throws ApiError
   */
  public static checkEmail(
    data: $OpenApiTs['/api/auth/check-email']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/auth/check-email']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/auth/check-email',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Send OTP code
   * @returns SendOtpCodeResponseDto
   * @throws ApiError
   */
  public static sendOtpCode(
    data: $OpenApiTs['/api/auth/send-otp-code']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/auth/send-otp-code']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/auth/send-otp-code',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Verify phone
   * @returns VerifyPhoneResponseDto
   * @throws ApiError
   */
  public static verifyPhone(
    data: $OpenApiTs['/api/auth/verify-otp-code']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/auth/verify-otp-code']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/auth/verify-otp-code',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Long-poll for the session produced by a desktop browser sign-in
   * @returns DesktopAuthResultResponseDto
   * @throws ApiError
   */
  public static result(
    data: $OpenApiTs['/api/auth/desktop/result']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/auth/desktop/result']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/auth/desktop/result',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}

export class PayService {
  /**
   * Job submit endpoint
   * @returns void
   * @throws ApiError
   */
  public static pay(
    data: $OpenApiTs['/api/pay/{jobId}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/pay/{jobId}']['post']['res'][204]> {
    const { jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/pay/{jobId}',
      path: {
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Job partial unlock charge
   * @returns void
   * @throws ApiError
   */
  public static partialCharge(
    data: $OpenApiTs['/api/pay/{jobId}/partial-unlock']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/pay/{jobId}/partial-unlock']['post']['res'][204]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/pay/{jobId}/partial-unlock',
      path: {
        jobId,
      },
    });
  }

  /**
   * Job enhancement charge
   * @returns void
   * @throws ApiError
   */
  public static enhance(
    data: $OpenApiTs['/api/pay/{jobId}/enhance']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/pay/{jobId}/enhance']['post']['res'][204]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/pay/{jobId}/enhance',
      path: {
        jobId,
      },
    });
  }

  /**
   * Job bulk submit endpoint
   * @returns void
   * @throws ApiError
   */
  public static payForBulkJobs(
    data: $OpenApiTs['/api/pay/bulk/submit']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/pay/bulk/submit']['post']['res'][204]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/pay/bulk/submit',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}

export class AdminService {
  /**
   * Dashboard info
   * @returns GetDashboardInfoResponse
   * @throws ApiError
   */
  public static getDashboardInfo(): CancelablePromise<$OpenApiTs['/api/admin/dashboard']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/dashboard',
    });
  }

  /**
   * Live jobs status duration dashboard
   * @returns AdminJobsLiveDashboardResponseDto
   * @throws ApiError
   */
  public static getJobsLiveDashboard(): CancelablePromise<
    $OpenApiTs['/api/admin/jobs-live-dashboard']['get']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs-live-dashboard',
    });
  }

  /**
   * Updates user email
   * @returns void
   * @throws ApiError
   */
  public static updateUserEmail(
    data: $OpenApiTs['/api/admin/user/{userId}/email']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/user/{userId}/email']['post']['res'][204]> {
    const { userId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/user/{userId}/email',
      path: {
        userId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Updates user phone
   * @returns void
   * @throws ApiError
   */
  public static updateUserPhone(
    data: $OpenApiTs['/api/admin/user/{userId}/phone']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/user/{userId}/phone']['post']['res'][204]> {
    const { userId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/user/{userId}/phone',
      path: {
        userId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Create user
   * @returns AdminCreateUserResponseDto
   * @throws ApiError
   */
  public static createUser(
    data: $OpenApiTs['/api/admin/user']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/user']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/user',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get all AutoScriptOne plans
   * @returns AdminGetAllAsonePlansPlanResponseDto
   * @throws ApiError
   */
  public static getAllAsOnePlans(): CancelablePromise<$OpenApiTs['/api/admin/as-one-plans']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/as-one-plans',
    });
  }

  /**
   * Get organization invitations
   * @returns AdminGetInvitationsItemResponseDto
   * @throws ApiError
   */
  public static getInvitations(
    data: $OpenApiTs['/api/admin/{oid}/invitations']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/{oid}/invitations']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/{oid}/invitations',
      path: {
        oid,
      },
    });
  }

  /**
   * Create organization invitation
   * @returns void
   * @throws ApiError
   */
  public static createWsInvitation(
    data: $OpenApiTs['/api/admin/{oid}/invitations']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/{oid}/invitations']['post']['res'][204]> {
    const { oid, requestBody, overrideExternalManagement } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/{oid}/invitations',
      path: {
        oid,
      },
      query: {
        overrideExternalManagement,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get organization teams
   * @returns OrganizationTeamResponseDto
   * @throws ApiError
   */
  public static getTeams(
    data: $OpenApiTs['/api/admin/{oid}/teams']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/{oid}/teams']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/{oid}/teams',
      path: {
        oid,
      },
    });
  }

  /**
   * Get organization workspaces list
   * @returns PaginatedWorkspaceResponseDto
   * @throws ApiError
   */
  public static getOrganizationWorkspaces(
    data: $OpenApiTs['/api/admin/{oid}/workspaces']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/{oid}/workspaces']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/{oid}/workspaces',
      path: {
        oid,
      },
    });
  }

  /**
   * Edit existing invitation
   * @returns void
   * @throws ApiError
   */
  public static editInvitation(
    data: $OpenApiTs['/api/admin/invitations/{invitationId}/edit']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/invitations/{invitationId}/edit']['post']['res'][204]> {
    const { invitationId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/invitations/{invitationId}/edit',
      path: {
        invitationId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Resend email for existing invitation
   * @returns void
   * @throws ApiError
   */
  public static resendInvitation(
    data: $OpenApiTs['/api/admin/invitations/{invitationId}/resend']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/invitations/{invitationId}/resend']['post']['res'][204]> {
    const { invitationId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/invitations/{invitationId}/resend',
      path: {
        invitationId,
      },
    });
  }

  /**
   * Change organization ASOneAllowed flag
   * @returns void
   * @throws ApiError
   */
  public static changeAsOneAllowed(
    data: $OpenApiTs['/api/admin/{oid}/as-one-allowed']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/{oid}/as-one-allowed']['post']['res'][204]> {
    const { oid, requestBody, overrideExternalManagement } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/{oid}/as-one-allowed',
      path: {
        oid,
      },
      query: {
        overrideExternalManagement,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get organizations list
   * @returns AdminOrganizationsListResponseDto
   * @throws ApiError
   */
  public static getOrganizationsList(
    data: $OpenApiTs['/api/admin/organizations']['get']['req'] = {},
  ): CancelablePromise<$OpenApiTs['/api/admin/organizations']['get']['res'][200]> {
    const { pageNo, pageSize, orderBy, orderType, search, includeExternallyManaged } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/organizations',
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
        includeExternallyManaged,
      },
    });
  }

  /**
   * Get all organizations list
   * @returns AdminGetAllOrganizationsResponseDto
   * @throws ApiError
   */
  public static getAllOrganizationsList(
    data: $OpenApiTs['/api/admin/organizations/all']['get']['req'] = {},
  ): CancelablePromise<$OpenApiTs['/api/admin/organizations/all']['get']['res'][200]> {
    const { includeExternallyManaged } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/organizations/all',
      query: {
        includeExternallyManaged,
      },
    });
  }

  /**
   * Get organization data
   * @returns AdminGetOrganizationResponseDto
   * @throws ApiError
   */
  public static getOrganization(
    data: $OpenApiTs['/api/admin/organizations/{organizationId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/organizations/{organizationId}']['get']['res'][200]> {
    const { organizationId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/organizations/{organizationId}',
      path: {
        organizationId,
      },
    });
  }

  /**
   * Get organization cloud layouts
   * @returns AdminGetOrganizationLayoutsResponseDto
   * @throws ApiError
   */
  public static getOrganizationLayoutsAsAdmin(
    data: $OpenApiTs['/api/admin/organizations/{oid}/layouts']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/organizations/{oid}/layouts']['get']['res'][200]> {
    const { oid, pageNo, pageSize, orderBy, orderType, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/organizations/{oid}/layouts',
      path: {
        oid,
      },
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
      },
    });
  }

  /**
   * Clone layout to another organization
   * @returns AdminLayoutResponseDto
   * @throws ApiError
   */
  public static cloneLayoutToOrganization(
    data: $OpenApiTs['/api/admin/layouts/{layoutId}/clone']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/layouts/{layoutId}/clone']['post']['res'][200]> {
    const { layoutId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/layouts/{layoutId}/clone',
      path: {
        layoutId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get billing accounts list
   * @returns PaginatedBillingAccountResponseDto
   * @throws ApiError
   */
  public static getBillingAccountsList(
    data: $OpenApiTs['/api/admin/billing-accounts']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/billing-accounts']['get']['res'][200]> {
    const { pageNo, pageSize, orderBy, orderType, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/billing-accounts',
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
      },
    });
  }

  /**
   * Get billing account
   * @returns AdminBillingAccountResponseDto
   * @throws ApiError
   */
  public static getBillingAccount(
    data: $OpenApiTs['/api/admin/billing-accounts/{baId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/billing-accounts/{baId}']['get']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/billing-accounts/{baId}',
      path: {
        baId,
      },
    });
  }

  /**
   * Get transactions list
   * @returns AdminTransactionsListResponseDto
   * @throws ApiError
   */
  public static getTransactionsList(
    data: $OpenApiTs['/api/admin/transactions']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/transactions']['get']['res'][200]> {
    const { pageNo, pageSize, orderBy, orderType, search, from, to } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/transactions',
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
        from,
        to,
      },
    });
  }

  /**
   * Create an Admin initiated transaction
   * @returns void
   * @throws ApiError
   */
  public static recalculateBalances(
    data: $OpenApiTs['/api/admin/billing-account/{baId}/recalculate']['put']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/billing-account/{baId}/recalculate']['put']['res'][204]> {
    const { baId, overrideExternalManagement } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/admin/billing-account/{baId}/recalculate',
      path: {
        baId,
      },
      query: {
        overrideExternalManagement,
      },
    });
  }

  /**
   * Create an Admin initiated transaction
   * @returns AdminAddAdminTransactionResponseDto
   * @throws ApiError
   */
  public static addAdminTransaction(
    data: $OpenApiTs['/api/admin/billing-account/{baId}/transaction']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/billing-account/{baId}/transaction']['post']['res'][200]> {
    const { baId, requestBody, overrideExternalManagement } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/billing-account/{baId}/transaction',
      path: {
        baId,
      },
      query: {
        overrideExternalManagement,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Add Good Will balance to the Free Credit billing account
   * @returns AdminAddMainBalanceToBillingAccountResponseDto
   * @throws ApiError
   */
  public static addMainBalanceToBillingAccount(
    data: $OpenApiTs['/api/admin/billing-account/{baId}/balance']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/billing-account/{baId}/balance']['post']['res'][200]> {
    const { baId, requestBody, overrideExternalManagement } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/billing-account/{baId}/balance',
      path: {
        baId,
      },
      query: {
        overrideExternalManagement,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Update a Billing Account rate
   * @returns AdminSetBillingAccountRateResponseDto
   * @throws ApiError
   */
  public static setBillingAccountRate(
    data: $OpenApiTs['/api/admin/billing-account/{baId}/rate']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/billing-account/{baId}/rate']['patch']['res'][200]> {
    const { baId, requestBody, overrideExternalManagement } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/billing-account/{baId}/rate',
      path: {
        baId,
      },
      query: {
        overrideExternalManagement,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Update Billing Account rates
   * @returns AdminSetBillingAccountRatesResponseDto
   * @throws ApiError
   */
  public static setBillingAccountRates(
    data: $OpenApiTs['/api/admin/billing-account/{baId}/rates']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/billing-account/{baId}/rates']['patch']['res'][200]> {
    const { baId, requestBody, overrideExternalManagement } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/billing-account/{baId}/rates',
      path: {
        baId,
      },
      query: {
        overrideExternalManagement,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Pause Stripe collection on a subscription invoice
   * @returns AdminPauseSubscriptionCollectionResponseDto
   * @throws ApiError
   */
  public static pauseSubscriptionCollection(
    data: $OpenApiTs['/api/admin/subscription/pause-collection']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/subscription/pause-collection']['post']['res'][200]> {
    const { requestBody, overrideExternalManagement } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/subscription/pause-collection',
      query: {
        overrideExternalManagement,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Cancel a subscription at period end (prevent renewal)
   * @returns AdminCancelSubscriptionResponseDto
   * @throws ApiError
   */
  public static cancelSubscription(
    data: $OpenApiTs['/api/admin/subscription/cancel']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/subscription/cancel']['post']['res'][200]> {
    const { requestBody, overrideExternalManagement } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/subscription/cancel',
      query: {
        overrideExternalManagement,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Cancel a subscription immediately and void the last outstanding invoice
   * @returns AdminCancelSubscriptionAndVoidInvoiceResponseDto
   * @throws ApiError
   */
  public static cancelSubscriptionAndVoidInvoice(
    data: $OpenApiTs['/api/admin/subscription/cancel-and-void-invoice']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/subscription/cancel-and-void-invoice']['post']['res'][200]> {
    const { requestBody, overrideExternalManagement } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/subscription/cancel-and-void-invoice',
      query: {
        overrideExternalManagement,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get workspaces list
   * @returns AdminWorkspacesListResponseDto
   * @throws ApiError
   */
  public static getWorkspacesList(
    data: $OpenApiTs['/api/admin/workspaces']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/workspaces']['get']['res'][200]> {
    const { pageNo, pageSize, orderBy, orderType, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/workspaces',
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
      },
    });
  }

  /**
   * Get all workspaces list
   * @returns AdminWorkspaceListItemResponseDto
   * @throws ApiError
   */
  public static getAllWorkspacesList(): CancelablePromise<$OpenApiTs['/api/admin/workspaces/all']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/workspaces/all',
    });
  }

  /**
   * Get organization invitations list
   * @returns AdminGetInvitationsItemResponseDto
   * @throws ApiError
   */
  public static getOrganizationInvitationsList(
    data: $OpenApiTs['/api/admin/organizations/{oid}/invitations']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/organizations/{oid}/invitations']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/organizations/{oid}/invitations',
      path: {
        oid,
      },
    });
  }

  /**
   * Get organization users list
   * @returns GetOrgMembersResponseDto
   * @throws ApiError
   */
  public static getOrganizationUsersList(
    data: $OpenApiTs['/api/admin/organizations/{oid}/users']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/organizations/{oid}/users']['get']['res'][200]> {
    const { oid, pageNo, pageSize, orderBy, orderType, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/organizations/{oid}/users',
      path: {
        oid,
      },
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
      },
    });
  }

  /**
   * Get user details
   * @returns AdminUserDetailsResponseDto
   * @throws ApiError
   */
  public static getUserDetails(
    data: $OpenApiTs['/api/admin/users/{userId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/users/{userId}']['get']['res'][200]> {
    const { userId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/users/{userId}',
      path: {
        userId,
      },
    });
  }

  /**
   * Remove the requesting admin from an organization
   * @returns SuccessErrorResponseDto
   * @throws ApiError
   */
  public static removeSelfFromOrganization(
    data: $OpenApiTs['/api/admin/me/organizations/{oid}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/me/organizations/{oid}']['delete']['res'][200]> {
    const { oid, overrideExternalManagement } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/admin/me/organizations/{oid}',
      path: {
        oid,
      },
      query: {
        overrideExternalManagement,
      },
    });
  }

  /**
   * Get user organizations by user email
   * @returns AdminGetUserOrganizationsByEmailResponseDto
   * @throws ApiError
   */
  public static getUserOrganizationsByEmail(
    data: $OpenApiTs['/api/admin/users/email/{userEmail}/organizations']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/users/email/{userEmail}/organizations']['get']['res'][200]> {
    const { userEmail } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/users/email/{userEmail}/organizations',
      path: {
        userEmail,
      },
    });
  }

  /**
   * Get all users list
   * @returns AdminUsersResponseDto
   * @throws ApiError
   */
  public static getAllUsers(
    data: $OpenApiTs['/api/admin/users']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/users']['get']['res'][200]> {
    const { pageNo, pageSize, orderBy, orderType, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/users',
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
      },
    });
  }

  /**
   * Get all admins list
   * @returns AdminUsersResponseDto
   * @throws ApiError
   */
  public static getAdmins(
    data: $OpenApiTs['/api/admin/admins']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/admins']['get']['res'][200]> {
    const { pageNo, pageSize, orderBy, orderType, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/admins',
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
      },
    });
  }

  /**
   * Update user role
   * @returns AdminToggleAdminRoleResponseDto
   * @throws ApiError
   */
  public static toggleAdminRole(
    data: $OpenApiTs['/api/admin/users/{uid}/admin-role']['put']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/users/{uid}/admin-role']['put']['res'][200]> {
    const { uid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/admin/users/{uid}/admin-role',
      path: {
        uid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Set user disabled state
   * @returns AdminSetUserDisabledResponseDto
   * @throws ApiError
   */
  public static setUserDisabled(
    data: $OpenApiTs['/api/admin/users/{uid}/disabled']['put']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/users/{uid}/disabled']['put']['res'][200]> {
    const { uid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/admin/users/{uid}/disabled',
      path: {
        uid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Create new AS One plan
   * @returns void
   * @throws ApiError
   */
  public static createNewAsOnePlan(
    data: $OpenApiTs['/api/admin/as-one-plan']['put']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/as-one-plan']['put']['res'][204]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/admin/as-one-plan',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Edit AS One plan
   * @returns void
   * @throws ApiError
   */
  public static editAsOnePlan(
    data: $OpenApiTs['/api/admin/as-one-plan/{subscriptionProductId}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/as-one-plan/{subscriptionProductId}']['post']['res'][204]> {
    const { subscriptionProductId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/as-one-plan/{subscriptionProductId}',
      path: {
        subscriptionProductId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get jobs report
   * @returns JobReportResponseDto
   * @throws ApiError
   */
  public static getJobsReport(
    data: $OpenApiTs['/api/admin/jobs-report']['get']['req'] = {},
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs-report']['get']['res'][200]> {
    const {
      pageNo,
      pageSize,
      orderBy,
      orderType,
      statuses,
      search,
      from,
      to,
      asOne,
      post,
      durationFrom,
      durationTo,
      meetingTypes,
      includeExternallyManaged,
    } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs-report',
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        statuses,
        search,
        from,
        to,
        asOne,
        post,
        durationFrom,
        durationTo,
        meetingTypes,
        includeExternallyManaged,
      },
    });
  }

  /**
   * @returns binary Jobs report CSV export
   * @throws ApiError
   */
  public static exportJobsReport(
    data: $OpenApiTs['/api/admin/jobs-report/export']['get']['req'] = {},
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs-report/export']['get']['res'][200]> {
    const {
      statuses,
      search,
      from,
      to,
      asOne,
      post,
      durationFrom,
      durationTo,
      meetingTypes,
      includeExternallyManaged,
    } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs-report/export',
      query: {
        statuses,
        search,
        from,
        to,
        asOne,
        post,
        durationFrom,
        durationTo,
        meetingTypes,
        includeExternallyManaged,
      },
    });
  }

  /**
   * Get job by ID
   * @returns AdminJobDetailsResponseDto
   * @throws ApiError
   */
  public static getJobById(
    data: $OpenApiTs['/api/admin/job/{jobId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/job/{jobId}']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/job/{jobId}',
      path: {
        jobId,
      },
    });
  }

  /**
   * Get job assignee history
   * @returns AdminGetJobAssigneeHistoryResponseDto
   * @throws ApiError
   */
  public static getJobAssigneeHistory(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/assignee']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/assignee']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{jobId}/assignee',
      path: {
        jobId,
      },
    });
  }

  /**
   * Trigger enhanced on demand (AI Enhancements)
   * @returns TriggerEnhanceOnDemandResponseDto
   * @throws ApiError
   */
  public static triggerEnhanceOnDemand(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/enhance-on-demand']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/enhance-on-demand']['post']['res'][200]> {
    const { jobId, llmTranscriptSelectionMode } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs/{jobId}/enhance-on-demand',
      path: {
        jobId,
      },
      query: {
        llmTranscriptSelectionMode,
      },
    });
  }

  /**
   * Generate an on-demand LLM transcript issue report and proposed fixes
   * @returns TriggerLLMTranscriptIssueReportResponseDto
   * @throws ApiError
   */
  public static triggerLlmTranscriptIssueReport(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/llm-transcript-issue-report']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/llm-transcript-issue-report']['post']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs/{jobId}/llm-transcript-issue-report',
      path: {
        jobId,
      },
    });
  }

  /**
   * Get the LLM transcript issue report and fix report for a job
   * @returns GetLLMTranscriptIssueReportResponseDto
   * @throws ApiError
   */
  public static getLlmTranscriptIssueReport(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/llm-transcript-issue-report']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/llm-transcript-issue-report']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{jobId}/llm-transcript-issue-report',
      path: {
        jobId,
      },
    });
  }

  /**
   * Get admin settings
   * @returns GetSettingsResponse
   * @throws ApiError
   */
  public static getSettings(): CancelablePromise<$OpenApiTs['/api/admin/settings']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/settings',
    });
  }

  /**
   * Update admin setting
   * @returns AdminUpdateSettingResponseDto
   * @throws ApiError
   */
  public static updateSetting(
    data: $OpenApiTs['/api/admin/settings/{name}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/settings/{name}']['post']['res'][200]> {
    const { name, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/settings/{name}',
      path: {
        name,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get Job Utterances
   * @returns GetJobUtterancesResponseDto
   * @throws ApiError
   */
  public static getJobUtterances(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/utterances']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/utterances']['get']['res'][200]> {
    const { jobId, transcript } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{jobId}/utterances',
      path: {
        jobId,
      },
      query: {
        transcript,
      },
    });
  }

  /**
   * Get Job Metadata
   * @returns GetEnhancementsResponseDto
   * @throws ApiError
   */
  public static getJobEnhancements(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/enhancements']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/enhancements']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{jobId}/enhancements',
      path: {
        jobId,
      },
    });
  }

  /**
   * Notify all online users about new version
   * @returns void
   * @throws ApiError
   */
  public static notifyAboutNewVersion(): CancelablePromise<
    $OpenApiTs['/api/admin/new-version-notification']['post']['res'][204]
  > {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/new-version-notification',
    });
  }

  /**
   * Trigger job event
   * @returns TriggerJobResponseDto
   * @throws ApiError
   */
  public static triggerJob(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/trigger']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/trigger']['post']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs/{jobId}/trigger',
      path: {
        jobId,
      },
    });
  }

  /**
   * Get Job Pipeline Timestamps History by Job ID
   * @returns JobPipelineTimestampsHistoryResponseDto
   * @throws ApiError
   */
  public static getJobPipelineTimestampsHistory(
    data: $OpenApiTs['/api/admin/job-pipeline-timestamps-history/job/{jobId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/job-pipeline-timestamps-history/job/{jobId}']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/job-pipeline-timestamps-history/job/{jobId}',
      path: {
        jobId,
      },
    });
  }

  /**
   * Get ASOne Edits
   * @returns ASOneEditsResponseDto
   * @throws ApiError
   */
  public static getAsOneEdits(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/asone-edits']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/asone-edits']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{jobId}/asone-edits',
      path: {
        jobId,
      },
    });
  }

  /**
   * Disable attorney access
   * @returns PrismaAttorneyAccessDto
   * @throws ApiError
   */
  public static disableAttorneyAccess(
    data: $OpenApiTs['/api/admin/attorney-access/{attorneyAccessId}/disable']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/attorney-access/{attorneyAccessId}/disable']['patch']['res'][200]> {
    const { attorneyAccessId } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/attorney-access/{attorneyAccessId}/disable',
      path: {
        attorneyAccessId,
      },
    });
  }

  /**
   * Enable attorney access
   * @returns PrismaAttorneyAccessDto
   * @throws ApiError
   */
  public static enableAttorneyAccess(
    data: $OpenApiTs['/api/admin/attorney-access/{attorneyAccessId}/enable']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/attorney-access/{attorneyAccessId}/enable']['patch']['res'][200]> {
    const { attorneyAccessId } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/attorney-access/{attorneyAccessId}/enable',
      path: {
        attorneyAccessId,
      },
    });
  }

  /**
   * Add new attorney access
   * @returns PrismaAttorneyAccessDto
   * @throws ApiError
   */
  public static addNewAttorneyAccess(
    data: $OpenApiTs['/api/admin/attorney-access/{email}/{recordingSessionId}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/attorney-access/{email}/{recordingSessionId}']['post']['res'][200]> {
    const { email, recordingSessionId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/attorney-access/{email}/{recordingSessionId}',
      path: {
        email,
        recordingSessionId,
      },
    });
  }

  /**
   * Get attorney accesses list
   * @returns PaginatedAttorneyAccessResponseDto
   * @throws ApiError
   */
  public static getAttorneyAccessesList(
    data: $OpenApiTs['/api/admin/attorney-access']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/attorney-access']['get']['res'][200]> {
    const { pageNo, pageSize, orderBy, orderType, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/attorney-access',
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
      },
    });
  }

  /**
   * Get attorney users list
   * @returns GetAttorneyUsersResponseDto
   * @throws ApiError
   */
  public static getAttorneyUsersList(
    data: $OpenApiTs['/api/admin/attorney-users']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/attorney-users']['get']['res'][200]> {
    const { skip, take, orderBy, orderType, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/attorney-users',
      query: {
        skip,
        take,
        orderBy,
        orderType,
        search,
      },
    });
  }

  /**
   * Delete attorney user
   * @returns string Returns "ok" on success
   * @throws ApiError
   */
  public static deleteAttorneyUser(
    data: $OpenApiTs['/api/admin/attorney-users/{email}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/attorney-users/{email}']['delete']['res'][200]> {
    const { email } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/admin/attorney-users/{email}',
      path: {
        email,
      },
    });
  }

  /**
   * Verify attorney email
   * @returns string Returns "ok" on success
   * @throws ApiError
   */
  public static verifyAttorney(
    data: $OpenApiTs['/api/admin/verify-attorney/{email}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/verify-attorney/{email}']['post']['res'][200]> {
    const { email } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/verify-attorney/{email}',
      path: {
        email,
      },
    });
  }

  /**
   * Get attorney passcodes list
   * @returns PaginatedAttorneyPasscodeResponseDto
   * @throws ApiError
   */
  public static getAttorneyPasscodesList(
    data: $OpenApiTs['/api/admin/attorney-passcode']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/attorney-passcode']['get']['res'][200]> {
    const { pageNo, pageSize, orderBy, orderType, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/attorney-passcode',
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
      },
    });
  }

  /**
   * Send question to AI with transcript context
   * @returns TranscriptChatResponseDto
   * @throws ApiError
   */
  public static sendTranscriptQuestionToAi(
    data: $OpenApiTs['/api/admin/transcript/{transcriptId}/chat']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/transcript/{transcriptId}/chat']['post']['res'][200]> {
    const { transcriptId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/transcript/{transcriptId}/chat',
      path: {
        transcriptId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get transcript chat history
   * @returns PrismaJobTranscriptMessagesHistoryDto
   * @throws ApiError
   */
  public static getTranscriptChatHistory(
    data: $OpenApiTs['/api/admin/transcript/{transcriptId}/chat']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/transcript/{transcriptId}/chat']['get']['res'][200]> {
    const { transcriptId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/transcript/{transcriptId}/chat',
      path: {
        transcriptId,
      },
    });
  }

  /**
   * Send question to AI with transcript context
   * @returns TranscriptChatResponseDto
   * @throws ApiError
   */
  public static sendRepositoryQuestionToAi(
    data: $OpenApiTs['/api/admin/repository/{repositoryId}/chat']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/repository/{repositoryId}/chat']['post']['res'][200]> {
    const { repositoryId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/repository/{repositoryId}/chat',
      path: {
        repositoryId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get transcript chat history
   * @returns PrismaJobTranscriptMessagesHistoryDto
   * @throws ApiError
   */
  public static getRepositoryChatHistory(
    data: $OpenApiTs['/api/admin/repository/{repositoryId}/chat']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/repository/{repositoryId}/chat']['get']['res'][200]> {
    const { repositoryId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/repository/{repositoryId}/chat',
      path: {
        repositoryId,
      },
    });
  }

  /**
   * Parse transcript
   * @returns void
   * @throws ApiError
   */
  public static parseTranscript(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/version/{versionId}/parse-docx-transcript']['get']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/admin/jobs/{jobId}/version/{versionId}/parse-docx-transcript']['get']['res'][204]
  > {
    const { jobId, versionId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{jobId}/version/{versionId}/parse-docx-transcript',
      path: {
        jobId,
        versionId,
      },
    });
  }

  /**
   * List of available open ai models
   * @returns string Returns OpenAI models list
   * @throws ApiError
   */
  public static getAvailableOpenAiModels(): CancelablePromise<
    $OpenApiTs['/api/admin/openai/models']['get']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/openai/models',
    });
  }

  /**
   * List of available ASR proxy models
   * @returns string Returns ASR proxy models list
   * @throws ApiError
   */
  public static getAvailableAsrProxyModels(): CancelablePromise<
    $OpenApiTs['/api/admin/proxy/models']['get']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/proxy/models',
    });
  }

  /**
   * Find and resubmit stuck jobs
   * @returns ResubmitJobsResponseDto Returns information about resubmitted jobs
   * @throws ApiError
   */
  public static resubmitStuckJobs(): CancelablePromise<
    $OpenApiTs['/api/admin/jobs/resubmit-stuck']['post']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs/resubmit-stuck',
    });
  }

  /**
   * Update description in classified error
   * @returns PrismaClassifiedPipelineErrorDto
   * @throws ApiError
   */
  public static updateClassifiedErrorDescription(
    data: $OpenApiTs['/api/admin/classified-errors/{errorId}/description']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/classified-errors/{errorId}/description']['patch']['res'][200]> {
    const { errorId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/classified-errors/{errorId}/description',
      path: {
        errorId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Resubmit jobs (Admin only)
   * @returns ResubmitJobsResponseDto Resubmitted jobs; No Show jobs are skipped and omitted from results.
   * @throws ApiError
   */
  public static bulkResubmitJobs(
    data: $OpenApiTs['/api/admin/jobs-bulk-resubmit']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs-bulk-resubmit']['post']['res'][201]> {
    const {
      requestBody,
      chosenTranscriptionModel,
      forceRetranscribe,
      priority,
      clearStylefixCache,
      rushedJob,
      noShow,
      forcePreprocessing,
      useAssemblyTwoStageClustering,
      speakersExpected,
      minSpeakersExpected,
      maxSpeakersExpected,
      llmTranscriptSelectionMode,
    } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs-bulk-resubmit',
      query: {
        chosenTranscriptionModel,
        forceRetranscribe,
        priority,
        clearStylefixCache,
        rushedJob,
        noShow,
        forcePreprocessing,
        useAssemblyTwoStageClustering,
        speakersExpected,
        minSpeakersExpected,
        maxSpeakersExpected,
        llmTranscriptSelectionMode,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Creating bulk of draft job (e2e)
   * @returns CreateBulkJobsResponseDto
   * @throws ApiError
   */
  public static createBulkJobs(
    data: $OpenApiTs['/api/admin/{wsId}/jobs/create-bulk-and-submit']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/{wsId}/jobs/create-bulk-and-submit']['post']['res'][200]> {
    const { wsId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/{wsId}/jobs/create-bulk-and-submit',
      path: {
        wsId,
      },
    });
  }

  /**
   * Get bulk of job statuses (e2e)
   * @returns BulkJobStatusItemResponseDto
   * @throws ApiError
   */
  public static getBulkJobsStatuses(
    data: $OpenApiTs['/api/admin/e2e/jobs/statuses']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/e2e/jobs/statuses']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/e2e/jobs/statuses',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get bulk of job pipeline statuses (e2e)
   * @returns BulkJobStatusItemResponseDto
   * @throws ApiError
   */
  public static getBulkJobsPipelineStatuses(
    data: $OpenApiTs['/api/admin/e2e/jobs/pipeline-statuses']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/e2e/jobs/pipeline-statuses']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/e2e/jobs/pipeline-statuses',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * List job transactions
   * @returns PrismaTransactionDto
   * @throws ApiError
   */
  public static getJobTransactions(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/transactions']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/transactions']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{jobId}/transactions',
      path: {
        jobId,
      },
    });
  }

  /**
   * Mark or unmark a job as abandoned for processing reports
   * @returns void
   * @throws ApiError
   */
  public static updateJobAbandonedProcessing(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/abandoned-processing']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/abandoned-processing']['patch']['res'][204]> {
    const { jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/jobs/{jobId}/abandoned-processing',
      path: {
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Refund job
   * @returns AdminRefundJobResponseDto
   * @throws ApiError
   */
  public static refundJob(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/refund']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/refund']['post']['res'][200]> {
    const { jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs/{jobId}/refund',
      path: {
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Confirm user after registration
   * @returns void
   * @throws ApiError
   */
  public static confirmUser(
    data: $OpenApiTs['/api/admin/users/{userId}/confirm']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/users/{userId}/confirm']['post']['res'][204]> {
    const { userId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/users/{userId}/confirm',
      path: {
        userId,
      },
    });
  }

  /**
   * @returns AdminConfirmUserForTestsResponseDto
   * @throws ApiError
   */
  public static confirmUserForTests(
    data: $OpenApiTs['/api/admin/test/confirm-user']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/test/confirm-user']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/test/confirm-user',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Grant admin roles for tests
   * @returns GrantAdminRolesResponseDto
   * @throws ApiError
   */
  public static grantAdminRolesForTests(
    data: $OpenApiTs['/api/admin/test/grant-admin-roles']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/test/grant-admin-roles']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/test/grant-admin-roles',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Verify user email after registration
   * @returns void
   * @throws ApiError
   */
  public static verifyUserEmail(
    data: $OpenApiTs['/api/admin/users/{userId}/verify-email']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/users/{userId}/verify-email']['post']['res'][204]> {
    const { userId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/users/{userId}/verify-email',
      path: {
        userId,
      },
    });
  }

  /**
   * Generate or regenerate metadata for a job using agentic flow
   * @returns AgenticMetadataResponseDto
   * @throws ApiError
   */
  public static regenerateMetadata(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/agentic/metadata']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/agentic/metadata']['post']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs/{jobId}/agentic/metadata',
      path: {
        jobId,
      },
    });
  }

  /**
   * Generate Reporter Summary using agentic flow
   * @returns ReporterSummaryResponseDto
   * @throws ApiError
   */
  public static generateReporterSummary(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/agentic/reporter-summary']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/agentic/reporter-summary']['post']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs/{jobId}/agentic/reporter-summary',
      path: {
        jobId,
      },
    });
  }

  /**
   * Remove foreign language content from transcript using agentic flow
   * @returns RemoveForeignLanguageResponseDto
   * @throws ApiError
   */
  public static removeForeignLanguage(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/agentic/foreign-language-removal']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/agentic/foreign-language-removal']['post']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs/{jobId}/agentic/foreign-language-removal',
      path: {
        jobId,
      },
    });
  }

  /**
   * Correct diarization errors in transcript using agentic flow
   * @returns CorrectDiarizationErrorsResponseDto
   * @throws ApiError
   */
  public static correctDiarizationErrors(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/agentic/diarization-error-correction']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/agentic/diarization-error-correction']['post']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs/{jobId}/agentic/diarization-error-correction',
      path: {
        jobId,
      },
    });
  }

  /**
   * Check if cloning a job from another environment into the current one is available (VS Admin)
   * @returns CheckIsCloningAvailableResponseDto
   * @throws ApiError
   */
  public static checkIsCloningAvailable(): CancelablePromise<
    $OpenApiTs['/api/admin/is-cloning-available']['get']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/is-cloning-available',
    });
  }

  /**
   * Mint a platform service credential; the secret is returned once
   * @returns ServiceCredentialCreatedResponseDto
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/admin/service-credentials']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/service-credentials']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/service-credentials',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * List platform service credentials
   * @returns PrismaServiceCredentialDto
   * @throws ApiError
   */
  public static findAll(): CancelablePromise<$OpenApiTs['/api/admin/service-credentials']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/service-credentials',
    });
  }

  /**
   * Revoke a platform service credential
   * @returns void
   * @throws ApiError
   */
  public static revoke(
    data: $OpenApiTs['/api/admin/service-credentials/{id}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/service-credentials/{id}']['delete']['res'][204]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/admin/service-credentials/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * Create SMS OTP Country Rule
   * @returns PrismaSMSCountryCodeDto
   * @throws ApiError
   */
  public static create1(
    data: $OpenApiTs['/api/admin/sms-countries']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/sms-countries']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/sms-countries',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get all SMS OTP Country Rule
   * @returns PrismaSMSCountryCodeDto
   * @throws ApiError
   */
  public static findAll1(): CancelablePromise<$OpenApiTs['/api/admin/sms-countries']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/sms-countries',
    });
  }

  /**
   * Delete empty SMS OTP Country Rule
   * @returns PrismaSMSCountryCodeDto
   * @throws ApiError
   */
  public static removeEmpty(): CancelablePromise<$OpenApiTs['/api/admin/sms-countries']['delete']['res'][200]> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/admin/sms-countries',
    });
  }

  /**
   * Get SMS OTP Country Rule
   * @returns PrismaSMSCountryCodeDto
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/admin/sms-countries/{code}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/sms-countries/{code}']['get']['res'][200]> {
    const { code } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/sms-countries/{code}',
      path: {
        code,
      },
    });
  }

  /**
   * Update SMS OTP Country Rule
   * @returns PrismaSMSCountryCodeDto
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/admin/sms-countries/{code}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/sms-countries/{code}']['patch']['res'][200]> {
    const { code, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/sms-countries/{code}',
      path: {
        code,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete SMS OTP Country Rule
   * @returns PrismaSMSCountryCodeDto
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/admin/sms-countries/{code}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/sms-countries/{code}']['delete']['res'][200]> {
    const { code } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/admin/sms-countries/{code}',
      path: {
        code,
      },
    });
  }
}

export class FeatureFlagsService {
  /**
   * Create new feature flag
   * @returns PrismaFeatureFlagDto
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/feature-flags/admin']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/feature-flags/admin']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/feature-flags/admin',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Find all feature flags
   * @returns PrismaFeatureFlagDto
   * @throws ApiError
   */
  public static findAll(): CancelablePromise<$OpenApiTs['/api/feature-flags/admin']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/feature-flags/admin',
    });
  }

  /**
   * Create new feature flag for AttorneyView
   * @returns void
   * @throws ApiError
   */
  public static createForAttorneyView(
    data: $OpenApiTs['/api/feature-flags/admin/attorney-view']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/feature-flags/admin/attorney-view']['post']['res'][204]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/feature-flags/admin/attorney-view',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Find all feature flags for AttorneyView
   * @returns PrismaFeatureFlagDto
   * @throws ApiError
   */
  public static findAllForAttorneyView(): CancelablePromise<
    $OpenApiTs['/api/feature-flags/admin/attorney-view']['get']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/feature-flags/admin/attorney-view',
    });
  }

  /**
   * Update a feature flag for AttorneyView
   * @returns void
   * @throws ApiError
   */
  public static updateForAttorneyView(
    data: $OpenApiTs['/api/feature-flags/admin/attorney-view/{featureFlagId}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/feature-flags/admin/attorney-view/{featureFlagId}']['patch']['res'][204]> {
    const { featureFlagId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/feature-flags/admin/attorney-view/{featureFlagId}',
      path: {
        featureFlagId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete a feature flag for AttorneyView
   * @returns void
   * @throws ApiError
   */
  public static removeForAttorneyView(
    data: $OpenApiTs['/api/feature-flags/admin/attorney-view/{featureFlagId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/feature-flags/admin/attorney-view/{featureFlagId}']['delete']['res'][204]> {
    const { featureFlagId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/feature-flags/admin/attorney-view/{featureFlagId}',
      path: {
        featureFlagId,
      },
    });
  }

  /**
   * Update organization feature flag
   * @returns PrismaOrganizationFeatureFlagDto
   * @throws ApiError
   */
  public static updateOrganizationFeatureFlag(
    data: $OpenApiTs['/api/feature-flags/admin/organization/{oid}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/feature-flags/admin/organization/{oid}']['post']['res'][200]> {
    const { oid, requestBody, overrideExternalManagement } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/feature-flags/admin/organization/{oid}',
      path: {
        oid,
      },
      query: {
        overrideExternalManagement,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Find one feature flag
   * @returns PrismaFeatureFlagDto Feature flag or 404
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/feature-flags/admin/{featureFlagId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/feature-flags/admin/{featureFlagId}']['get']['res'][200]> {
    const { featureFlagId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/feature-flags/admin/{featureFlagId}',
      path: {
        featureFlagId,
      },
    });
  }

  /**
   * Update a feature flag
   * @returns PrismaFeatureFlagDto
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/feature-flags/admin/{featureFlagId}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/feature-flags/admin/{featureFlagId}']['patch']['res'][200]> {
    const { featureFlagId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/feature-flags/admin/{featureFlagId}',
      path: {
        featureFlagId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete a feature flag
   * @returns PrismaFeatureFlagDto
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/feature-flags/admin/{featureFlagId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/feature-flags/admin/{featureFlagId}']['delete']['res'][200]> {
    const { featureFlagId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/feature-flags/admin/{featureFlagId}',
      path: {
        featureFlagId,
      },
    });
  }
}

export class AssemblyAdminService {
  /**
   * Inspect Assembly webhooks queued for >3h and re-enqueue any whose transcripts have completed or errored
   * @returns CheckStuckAssemblyWebhooksResponseDto
   * @throws ApiError
   */
  public static checkStuckWebhooks(): CancelablePromise<
    $OpenApiTs['/api/admin/assembly/check-stuck-webhooks']['post']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/assembly/check-stuck-webhooks',
    });
  }
}

export class AsrProxyAdminService {
  /**
   * @returns ModelSettingsResponseDto
   * @throws ApiError
   */
  public static getModelSettings(): CancelablePromise<
    $OpenApiTs['/api/admin/asr-proxy/model-settings']['get']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/asr-proxy/model-settings',
    });
  }

  /**
   * @returns ModelSettingsResponseDto
   * @throws ApiError
   */
  public static setModelNormalizers(
    data: $OpenApiTs['/api/admin/asr-proxy/model-settings/{modelName}/normalizers']['put']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/asr-proxy/model-settings/{modelName}/normalizers']['put']['res'][200]> {
    const { modelName, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/admin/asr-proxy/model-settings/{modelName}/normalizers',
      path: {
        modelName,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns ModelSettingsResponseDto
   * @throws ApiError
   */
  public static setModelQualityCheckers(
    data: $OpenApiTs['/api/admin/asr-proxy/model-settings/{modelName}/quality-checkers']['put']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/admin/asr-proxy/model-settings/{modelName}/quality-checkers']['put']['res'][200]
  > {
    const { modelName, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/admin/asr-proxy/model-settings/{modelName}/quality-checkers',
      path: {
        modelName,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Liveness, AssemblyAI adapter and Temporal worker health
   * @returns AsrProxyHealthResponseDto
   * @throws ApiError
   */
  public static health(): CancelablePromise<$OpenApiTs['/api/admin/asr-proxy/health']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/asr-proxy/health',
    });
  }

  /**
   * List the AssemblyAI Universal-2 proxy model
   * @returns AsrProxyModelsResponseDto
   * @throws ApiError
   */
  public static models(): CancelablePromise<$OpenApiTs['/api/admin/asr-proxy/models']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/asr-proxy/models',
    });
  }

  /**
   * @returns AsrProxyProviderOptionsResponseDto
   * @throws ApiError
   */
  public static providerOptions(): CancelablePromise<
    $OpenApiTs['/api/admin/asr-proxy/provider-options']['get']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/asr-proxy/provider-options',
    });
  }

  /**
   * @returns AsrProxySetProviderOptionsResponseDto
   * @throws ApiError
   */
  public static setProviderOptions(
    data: $OpenApiTs['/api/admin/asr-proxy/provider-options']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/asr-proxy/provider-options']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/asr-proxy/provider-options',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns AsrProxyProviderLimitsResponseDto
   * @throws ApiError
   */
  public static providerLimits(): CancelablePromise<
    $OpenApiTs['/api/admin/asr-proxy/provider-limits']['get']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/asr-proxy/provider-limits',
    });
  }

  /**
   * @returns AsrProxyHealthCheckResponseDto
   * @throws ApiError
   */
  public static healthCheck(): CancelablePromise<$OpenApiTs['/api/admin/asr-proxy/health-check']['post']['res'][200]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/asr-proxy/health-check',
    });
  }

  /**
   * @returns AsrProxyJobsResponseDto
   * @throws ApiError
   */
  public static jobs(
    data: $OpenApiTs['/api/admin/asr-proxy/jobs']['get']['req'] = {},
  ): CancelablePromise<$OpenApiTs['/api/admin/asr-proxy/jobs']['get']['res'][200]> {
    const { limit, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/asr-proxy/jobs',
      query: {
        limit,
        search,
      },
    });
  }

  /**
   * @returns AsrProxyReloadResponseDto
   * @throws ApiError
   */
  public static reload(): CancelablePromise<$OpenApiTs['/api/admin/asr-proxy/reload']['post']['res'][200]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/asr-proxy/reload',
    });
  }

  /**
   * @returns AsrProxySettingsResponseDto
   * @throws ApiError
   */
  public static settings(): CancelablePromise<$OpenApiTs['/api/admin/asr-proxy/settings']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/asr-proxy/settings',
    });
  }

  /**
   * @returns AsrProxyDefaultModelResponseDto
   * @throws ApiError
   */
  public static setDefaultModel(
    data: $OpenApiTs['/api/admin/asr-proxy/default-model']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/asr-proxy/default-model']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/asr-proxy/default-model',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns AsrProxyRetriesResponseDto
   * @throws ApiError
   */
  public static setRetries(
    data: $OpenApiTs['/api/admin/asr-proxy/retries']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/asr-proxy/retries']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/asr-proxy/retries',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns AsrProxyFallbacksResponseDto
   * @throws ApiError
   */
  public static setFallbacks(
    data: $OpenApiTs['/api/admin/asr-proxy/fallbacks']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/asr-proxy/fallbacks']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/asr-proxy/fallbacks',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns AsrProxyCreateTranscriptionResponseDto
   * @throws ApiError
   */
  public static createTranscription(
    data: $OpenApiTs['/api/admin/asr-proxy/transcriptions']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/asr-proxy/transcriptions']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/asr-proxy/transcriptions',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns AsrProxyRetrieveTranscriptionResponseDto
   * @throws ApiError
   */
  public static retrieveTranscription(
    data: $OpenApiTs['/api/admin/asr-proxy/transcriptions/{id}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/asr-proxy/transcriptions/{id}']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/asr-proxy/transcriptions/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * @returns AsrProxyRetrieveTranscriptionResponseDto
   * @throws ApiError
   */
  public static retrieveTranscriptionByProviderTranscriptId(
    data: $OpenApiTs['/api/admin/asr-proxy/transcriptions/provider/{provider}/{providerTranscriptId}']['get']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/admin/asr-proxy/transcriptions/provider/{provider}/{providerTranscriptId}']['get']['res'][200]
  > {
    const { provider, providerTranscriptId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/asr-proxy/transcriptions/provider/{provider}/{providerTranscriptId}',
      path: {
        provider,
        providerTranscriptId,
      },
    });
  }

  /**
   * Read the ASR model configured for an organization
   * @returns unknown
   * @throws ApiError
   */
  public static getOrganizationConfig(
    data: $OpenApiTs['/api/admin/asr-proxy/organizations/{organizationId}/config']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/asr-proxy/organizations/{organizationId}/config']['get']['res'][200]> {
    const { organizationId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/asr-proxy/organizations/{organizationId}/config',
      path: {
        organizationId,
      },
    });
  }

  /**
   * Set the ASR model for an organization
   * @returns AsrProxyOrganizationConfigResponseDto
   * @throws ApiError
   */
  public static setOrganizationModel(
    data: $OpenApiTs['/api/admin/asr-proxy/organizations/{organizationId}/config']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/asr-proxy/organizations/{organizationId}/config']['patch']['res'][200]> {
    const { organizationId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/asr-proxy/organizations/{organizationId}/config',
      path: {
        organizationId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Reset an organization to the ASR proxy default model
   * @returns void
   * @throws ApiError
   */
  public static deleteOrganizationConfig(
    data: $OpenApiTs['/api/admin/asr-proxy/organizations/{organizationId}/config']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/asr-proxy/organizations/{organizationId}/config']['delete']['res'][204]> {
    const { organizationId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/admin/asr-proxy/organizations/{organizationId}/config',
      path: {
        organizationId,
      },
    });
  }
}

export class AssemblyService {
  /**
   * @returns any
   * @throws ApiError
   */
  public static handleWebhook(
    data: $OpenApiTs['/api/assembly/webhook/{pipelineId}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/assembly/webhook/{pipelineId}']['post']['res'][200]> {
    const { pipelineId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/assembly/webhook/{pipelineId}',
      path: {
        pipelineId,
      },
    });
  }
}

export class LayoutsService {
  /**
   * @returns GetManyForUserResponseDto
   * @throws ApiError
   */
  public static getUserLayouts(): CancelablePromise<$OpenApiTs['/api/layouts/user/list']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/layouts/user/list',
    });
  }

  /**
   * @returns GetManyForUserResponseDto
   * @throws ApiError
   */
  public static getOrganizationLayouts(
    data: $OpenApiTs['/api/layouts/{oid}/list']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/layouts/{oid}/list']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/layouts/{oid}/list',
      path: {
        oid,
      },
    });
  }

  /**
   * @returns GetDownloadUrlsForLayoutResponseDto
   * @throws ApiError
   */
  public static getDownloadUrlsForLayout(
    data: $OpenApiTs['/api/layouts/{layoutId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/layouts/{layoutId}']['get']['res'][200]> {
    const { layoutId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/layouts/{layoutId}',
      path: {
        layoutId,
      },
    });
  }

  /**
   * @returns ReplaceLayoutResponseDto
   * @throws ApiError
   */
  public static replaceLayout(
    data: $OpenApiTs['/api/layouts/{layoutId}']['put']['req'],
  ): CancelablePromise<$OpenApiTs['/api/layouts/{layoutId}']['put']['res'][200]> {
    const { layoutId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/layouts/{layoutId}',
      path: {
        layoutId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns DeleteLayoutResponseDto
   * @throws ApiError
   */
  public static deleteLayout(
    data: $OpenApiTs['/api/layouts/{layoutId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/layouts/{layoutId}']['delete']['res'][200]> {
    const { layoutId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/layouts/{layoutId}',
      path: {
        layoutId,
      },
    });
  }

  /**
   * @returns CreateLayoutResponseDto
   * @throws ApiError
   */
  public static createLayout(
    data: $OpenApiTs['/api/layouts/{oid}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/layouts/{oid}']['post']['res'][200]> {
    const { oid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/layouts/{oid}',
      path: {
        oid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}

export class AdminE2eAsOneLoadService {
  /**
   * Seed a synthetic ASOne load-test job
   * Clones a pre-uploaded fixture (audio + session-text) under jobs/<newJobId>/, creates a RecordingSession + Job in the load-test org/user, and submits it to the preprocessor queue. Non-production environments only; requires INTERNAL_API_KEY.
   * @returns SeedAsoneLoadJobResponseDto
   * @throws ApiError
   */
  public static seedAsoneLoadJob(
    data: $OpenApiTs['/api/admin/e2e/asone-load/seed-job']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/e2e/asone-load/seed-job']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/e2e/asone-load/seed-job',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Bulk job-status lookup for load-test polling
   * Returns status + pipelineStatus + currentAttemptId for the supplied job IDs. Non-production environments only; requires INTERNAL_API_KEY.
   * @returns LoadJobStatusListResponseDto
   * @throws ApiError
   */
  public static getLoadJobStatuses(
    data: $OpenApiTs['/api/admin/e2e/asone-load/jobs/statuses']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/e2e/asone-load/jobs/statuses']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/e2e/asone-load/jobs/statuses',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}

export class DashboardService {
  /**
   * Get dashboard info
   * @returns OrganizationDashboardInfoResponseDto
   * @throws ApiError
   */
  public static getDashboardInfo(
    data: $OpenApiTs['/api/dashboard/{oid}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/dashboard/{oid}']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/{oid}',
      path: {
        oid,
      },
    });
  }

  /**
   * Get scriber dashboard info
   * @returns ScriberDashboardInfoResponseDto
   * @throws ApiError
   */
  public static getScriberDashboardInfo(
    data: $OpenApiTs['/api/dashboard/{oid}/scriber']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/dashboard/{oid}/scriber']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/{oid}/scriber',
      path: {
        oid,
      },
    });
  }
}

export class ReportsService {
  /**
   * Get jobs report
   * @returns JobReportResponseDto
   * @throws ApiError
   */
  public static getJobsReport(
    data: $OpenApiTs['/api/reports/{wsid}/jobs']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/reports/{wsid}/jobs']['get']['res'][200]> {
    const { wsid, pageNo, pageSize, orderBy, orderType, search, jobsFrom, jobsTo } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/reports/{wsid}/jobs',
      path: {
        wsid,
      },
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
        jobsFrom,
        jobsTo,
      },
    });
  }

  /**
   * Get user jobs report
   * @returns JobReportResponseDto
   * @throws ApiError
   */
  public static getUserJobsReport(
    data: $OpenApiTs['/api/reports/{wsid}/jobs/{userId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/reports/{wsid}/jobs/{userId}']['get']['res'][200]> {
    const { wsid, userId, pageNo, pageSize, orderBy, orderType, search, jobsFrom, jobsTo } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/reports/{wsid}/jobs/{userId}',
      path: {
        wsid,
        userId,
      },
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
        jobsFrom,
        jobsTo,
      },
    });
  }
}

export class SupportService {
  /**
   * Send email to sales team
   * @returns SendSalesEmailResponseDto
   * @throws ApiError
   */
  public static sendSalesEmail(
    data: $OpenApiTs['/api/support/sales']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/support/sales']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/support/sales',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Send email to sales team
   * @returns void
   * @throws ApiError
   */
  public static sendSalesEmailFromLanding(
    data: $OpenApiTs['/api/support/sales-landing']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/support/sales-landing']['post']['res'][204]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/support/sales-landing',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}

export class RsProService {
  /**
   * Check RSPro license status for user
   * @returns CheckRsProLicenseBodyDto
   * @throws ApiError
   */
  public static checkRsProLicense(): CancelablePromise<$OpenApiTs['/api/rspro/license']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/rspro/license',
    });
  }
}

export class CrashReportsService {
  /**
   * Open a crash report and get presigned upload links
   * @returns CrashReportTicket
   * @throws ApiError
   */
  public static begin(
    data: $OpenApiTs['/api/crash-reports']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/crash-reports']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/crash-reports',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Confirm the dump reached storage and open the Jira ticket
   * @returns CrashReportCompletion
   * @throws ApiError
   */
  public static complete(
    data: $OpenApiTs['/api/crash-reports/{reportId}/complete']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/crash-reports/{reportId}/complete']['post']['res'][200]> {
    const { reportId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/crash-reports/{reportId}/complete',
      path: {
        reportId,
      },
    });
  }
}

export class DesktopService {
  /**
   * Get desktop job info
   * @returns DesktopJobInfoDTO
   * @throws ApiError
   */
  public static getJobInfo(
    data: $OpenApiTs['/api/desktop/{jobId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/desktop/{jobId}']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/desktop/{jobId}',
      path: {
        jobId,
      },
    });
  }

  /**
   * Get desktop download links
   * @returns DesktopDownloadJobInfoDTO
   * @throws ApiError
   */
  public static getDesktopDownloadLinks(
    data: $OpenApiTs['/api/desktop/download/{jobId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/desktop/download/{jobId}']['get']['res'][200]> {
    const { jobId, version } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/desktop/download/{jobId}',
      path: {
        jobId,
      },
      query: {
        version,
      },
    });
  }

  /**
   * @deprecated
   * @returns DesktopUploadJobInfoDTO
   * @throws ApiError
   */
  public static getDesktopUploadLinks(
    data: $OpenApiTs['/api/desktop/upload/{jobId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/desktop/upload/{jobId}']['get']['res'][200]> {
    const { jobId, version } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/desktop/upload/{jobId}',
      path: {
        jobId,
      },
      query: {
        version,
      },
    });
  }
}

export class InvitationsService {
  /**
   * Get organization invitation
   * @returns GetInvitationResponseDto
   * @throws ApiError
   */
  public static getInvitation(
    data: $OpenApiTs['/api/invitations/{invitationId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/invitations/{invitationId}']['get']['res'][200]> {
    const { invitationId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/invitations/{invitationId}',
      path: {
        invitationId,
      },
    });
  }

  /**
   * Accept organization invitation
   * @returns AcceptInvitationResponseDto
   * @throws ApiError
   */
  public static acceptInvitation(
    data: $OpenApiTs['/api/invitations/{invitationId}/accept']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/invitations/{invitationId}/accept']['post']['res'][200]> {
    const { invitationId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/invitations/{invitationId}/accept',
      path: {
        invitationId,
      },
    });
  }
}

export class JobSubscriptionsService {
  /**
   * Get all subscriptions
   * @returns GetJobSubscriptionsListResponseDto
   * @throws ApiError
   */
  public static getList(): CancelablePromise<$OpenApiTs['/api/job-subscriptions']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/job-subscriptions',
    });
  }

  /**
   * Upsert subscription
   * @returns PrismaJobNotificationsSubscriptionDto
   * @throws ApiError
   */
  public static upsert(
    data: $OpenApiTs['/api/job-subscriptions/{jobId}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/job-subscriptions/{jobId}']['post']['res'][200]> {
    const { jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/job-subscriptions/{jobId}',
      path: {
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete subscription
   * @returns void
   * @throws ApiError
   */
  public static delete(
    data: $OpenApiTs['/api/job-subscriptions/{jobId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/job-subscriptions/{jobId}']['delete']['res'][204]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/job-subscriptions/{jobId}',
      path: {
        jobId,
      },
    });
  }
}

export class WorkspaceSubscriptionsService {
  /**
   * Get all subscriptions
   * @returns GetWorkspaceSubscriptionsListResponseDto
   * @throws ApiError
   */
  public static getList(): CancelablePromise<$OpenApiTs['/api/workspace-subscriptions']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/workspace-subscriptions',
    });
  }

  /**
   * Create subscription
   * @returns void
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/workspace-subscriptions/{workspaceId}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspace-subscriptions/{workspaceId}']['post']['res'][204]> {
    const { workspaceId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/workspace-subscriptions/{workspaceId}',
      path: {
        workspaceId,
      },
    });
  }

  /**
   * Delete subscription
   * @returns void
   * @throws ApiError
   */
  public static delete(
    data: $OpenApiTs['/api/workspace-subscriptions/{workspaceId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspace-subscriptions/{workspaceId}']['delete']['res'][204]> {
    const { workspaceId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/workspace-subscriptions/{workspaceId}',
      path: {
        workspaceId,
      },
    });
  }
}

export class TeamsService {
  /**
   * Create a new Team
   * @returns PrismaOrganizationRoleDto
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/teams']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/teams',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * List all Teams in an Organization
   * @returns PrismaOrganizationRoleDto
   * @throws ApiError
   */
  public static findAll(
    data: $OpenApiTs['/api/teams/organization/{oid}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams/organization/{oid}']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/teams/organization/{oid}',
      path: {
        oid,
      },
    });
  }

  /**
   * Find a team by ID
   * @returns FindOneTeamResponseDto
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/teams/{organizationRoleId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams/{organizationRoleId}']['get']['res'][200]> {
    const { organizationRoleId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/teams/{organizationRoleId}',
      path: {
        organizationRoleId,
      },
    });
  }

  /**
   * Update a Team
   * @returns PrismaOrganizationRoleDto
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/teams/{organizationRoleId}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams/{organizationRoleId}']['patch']['res'][200]> {
    const { organizationRoleId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/teams/{organizationRoleId}',
      path: {
        organizationRoleId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete Team
   * @returns void
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/teams/{organizationRoleId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams/{organizationRoleId}']['delete']['res'][204]> {
    const { organizationRoleId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/teams/{organizationRoleId}',
      path: {
        organizationRoleId,
      },
    });
  }

  /**
   * Find a team by ID
   * @returns FindOneTeamResponseDto
   * @throws ApiError
   */
  public static adminFindOne(
    data: $OpenApiTs['/api/teams/admin/{organizationRoleId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams/admin/{organizationRoleId}']['get']['res'][200]> {
    const { organizationRoleId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/teams/admin/{organizationRoleId}',
      path: {
        organizationRoleId,
      },
    });
  }

  /**
   * List available members within a team
   * @returns FindAvailableMembersItemResponseDto
   * @throws ApiError
   */
  public static findAvailableMembers(
    data: $OpenApiTs['/api/teams/{organizationRoleId}/available-members']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams/{organizationRoleId}/available-members']['get']['res'][200]> {
    const { organizationRoleId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/teams/{organizationRoleId}/available-members',
      path: {
        organizationRoleId,
      },
    });
  }

  /**
   * Find a team by slug
   * @returns FindOneTeamResponseDto
   * @throws ApiError
   */
  public static findOneBySlug(
    data: $OpenApiTs['/api/teams/{oid}/slug/{slug}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams/{oid}/slug/{slug}']['get']['res'][200]> {
    const { oid, slug } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/teams/{oid}/slug/{slug}',
      path: {
        oid,
        slug,
      },
    });
  }

  /**
   * Check if the given slug is available for the current organization
   * @returns IsSlugAvailableResponse
   * @throws ApiError
   */
  public static isTeamSlugAvailable(
    data: $OpenApiTs['/api/teams/is-available/{oid}/{organizationRoleId}/{slug}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams/is-available/{oid}/{organizationRoleId}/{slug}']['get']['res'][200]> {
    const { oid, organizationRoleId, slug } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/teams/is-available/{oid}/{organizationRoleId}/{slug}',
      path: {
        oid,
        organizationRoleId,
        slug,
      },
    });
  }

  /**
   * Check if the given slug is available
   * @returns IsSlugAvailableResponse
   * @throws ApiError
   */
  public static isSlugAvailable(
    data: $OpenApiTs['/api/teams/is-available/{oid}/{slug}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams/is-available/{oid}/{slug}']['get']['res'][200]> {
    const { oid, slug } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/teams/is-available/{oid}/{slug}',
      path: {
        oid,
        slug,
      },
    });
  }

  /**
   * Update Team members
   * @returns PrismaOrganizationRoleDto
   * @throws ApiError
   */
  public static updateMembers(
    data: $OpenApiTs['/api/teams/{organizationRoleId}/members']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams/{organizationRoleId}/members']['patch']['res'][200]> {
    const { organizationRoleId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/teams/{organizationRoleId}/members',
      path: {
        organizationRoleId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Remove team from user
   * @returns PrismaOrganizationMembershipDto
   * @throws ApiError
   */
  public static removeTeamFromUser(
    data: $OpenApiTs['/api/teams/{oid}/user/{userId}/{organizationRoleId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams/{oid}/user/{userId}/{organizationRoleId}']['delete']['res'][200]> {
    const { organizationRoleId, userId, oid } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/teams/{oid}/user/{userId}/{organizationRoleId}',
      path: {
        organizationRoleId,
        userId,
        oid,
      },
    });
  }

  /**
   * Remove user from team
   * @returns PrismaOrganizationRoleDto
   * @throws ApiError
   */
  public static removeMember(
    data: $OpenApiTs['/api/teams/{organizationRoleId}/member/{memberId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams/{organizationRoleId}/member/{memberId}']['delete']['res'][200]> {
    const { organizationRoleId, memberId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/teams/{organizationRoleId}/member/{memberId}',
      path: {
        organizationRoleId,
        memberId,
      },
    });
  }
}

export class PublicApiService {
  /**
   * Create a new job
   * @returns void
   * @throws ApiError
   */
  public static createJob(
    data: $OpenApiTs['/api/public/v1/{oid}/{wsid}/job']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/public/v1/{oid}/{wsid}/job']['post']['res'][204]> {
    const { oid, wsid, apiKey, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/public/v1/{oid}/{wsid}/job',
      path: {
        oid,
        wsid,
      },
      headers: {
        'api-key': apiKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * List workspaces in the organization
   * @returns any
   * @throws ApiError
   */
  public static listWorkspaces(
    data: $OpenApiTs['/api/public/v1/{oid}/workspaces']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/public/v1/{oid}/workspaces']['get']['res'][200]> {
    const { oid, apiKey } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/public/v1/{oid}/workspaces',
      path: {
        oid,
      },
      headers: {
        'api-key': apiKey,
      },
    });
  }

  /**
   * Resubmit a job through the pipeline
   * Equivalent to the admin Resubmit button. Re-uses the existing media; does not re-upload.
   * @returns any
   * @throws ApiError
   */
  public static resubmitJob(
    data: $OpenApiTs['/api/public/v1/{oid}/{jobId}/resubmit']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/public/v1/{oid}/{jobId}/resubmit']['post']['res'][200]> {
    const { oid, jobId, apiKey } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/public/v1/{oid}/{jobId}/resubmit',
      path: {
        oid,
        jobId,
      },
      headers: {
        'api-key': apiKey,
      },
    });
  }

  /**
   * Get Job details
   * @returns any
   * @throws ApiError
   */
  public static getJobDetails(
    data: $OpenApiTs['/api/public/v1/{oid}/{jobId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/public/v1/{oid}/{jobId}']['get']['res'][200]> {
    const { oid, jobId, apiKey } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/public/v1/{oid}/{jobId}',
      path: {
        oid,
        jobId,
      },
      headers: {
        'api-key': apiKey,
      },
    });
  }

  /**
   * Get S3 upload params for Job files
   * @returns S3SignedUrlResponseDto
   * @throws ApiError
   */
  public static getUploadParams(
    data: $OpenApiTs['/api/public/v1/{oid}/{jobId}/upload-params']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/public/v1/{oid}/{jobId}/upload-params']['get']['res'][200]> {
    const { oid, jobId, file, apiKey } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/public/v1/{oid}/{jobId}/upload-params',
      path: {
        oid,
        jobId,
      },
      headers: {
        'api-key': apiKey,
      },
      query: {
        file,
      },
    });
  }

  /**
   * Attach S3 uploaded file to Job
   * @returns string
   * @throws ApiError
   */
  public static attachFileToJob(
    data: $OpenApiTs['/api/public/v1/{oid}/{jobId}/file']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/public/v1/{oid}/{jobId}/file']['post']['res'][200]> {
    const { oid, jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/public/v1/{oid}/{jobId}/file',
      path: {
        oid,
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Submit Job
   * @returns boolean
   * @throws ApiError
   */
  public static submitJob(
    data: $OpenApiTs['/api/public/v1/{oid}/{jobId}/submit']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/public/v1/{oid}/{jobId}/submit']['post']['res'][200]> {
    const { oid, jobId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/public/v1/{oid}/{jobId}/submit',
      path: {
        oid,
        jobId,
      },
    });
  }
}

export class ServiceApiService {
  /**
   * Create a complete externally managed organization in one call
   * @returns BootstrapOrganizationResponseDto Idempotent replay
   * @throws ApiError
   */
  public static bootstrap(
    data: $OpenApiTs['/api/service/v1/organizations']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/service/v1/organizations']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/service/v1/organizations',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Read back an externally managed organization
   * @returns ServiceOrganizationResponseDto
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/service/v1/organizations/{oid}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/service/v1/organizations/{oid}']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/service/v1/organizations/{oid}',
      path: {
        oid,
      },
    });
  }

  /**
   * Update the name or seat count of an externally managed organization
   * @returns ServiceOrganizationResponseDto
   * @throws ApiError
   */
  public static patch(
    data: $OpenApiTs['/api/service/v1/organizations/{oid}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/service/v1/organizations/{oid}']['patch']['res'][200]> {
    const { oid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/service/v1/organizations/{oid}',
      path: {
        oid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Issue a new job credential for the organization
   * @returns IssuedCredentialResponseDto
   * @throws ApiError
   */
  public static rotateCredential(
    data: $OpenApiTs['/api/service/v1/organizations/{oid}/credentials']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/service/v1/organizations/{oid}/credentials']['post']['res'][201]> {
    const { oid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/service/v1/organizations/{oid}/credentials',
      path: {
        oid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Revoke a job credential of the organization
   * @returns void
   * @throws ApiError
   */
  public static revokeCredential(
    data: $OpenApiTs['/api/service/v1/organizations/{oid}/credentials/{credentialId}']['delete']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/service/v1/organizations/{oid}/credentials/{credentialId}']['delete']['res'][204]
  > {
    const { oid, credentialId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/service/v1/organizations/{oid}/credentials/{credentialId}',
      path: {
        oid,
        credentialId,
      },
    });
  }

  /**
   * Provision a member by email; links immediately when the user already exists
   * @returns ProvisionedMemberResponseDto
   * @throws ApiError
   */
  public static upsert(
    data: $OpenApiTs['/api/service/v1/organizations/{oid}/members']['put']['req'],
  ): CancelablePromise<$OpenApiTs['/api/service/v1/organizations/{oid}/members']['put']['res'][200]> {
    const { oid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/service/v1/organizations/{oid}/members',
      path: {
        oid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * List provisioned members with their states
   * @returns ProvisionedMemberResponseDto
   * @throws ApiError
   */
  public static list(
    data: $OpenApiTs['/api/service/v1/organizations/{oid}/members']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/service/v1/organizations/{oid}/members']['get']['res'][200]> {
    const { oid, state } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/service/v1/organizations/{oid}/members',
      path: {
        oid,
      },
      query: {
        state,
      },
    });
  }

  /**
   * Deactivate a provisioned member and release its license
   * @returns void
   * @throws ApiError
   */
  public static deactivate(
    data: $OpenApiTs['/api/service/v1/organizations/{oid}/members/{email}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/service/v1/organizations/{oid}/members/{email}']['delete']['res'][204]> {
    const { oid, email } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/service/v1/organizations/{oid}/members/{email}',
      path: {
        oid,
        email,
      },
    });
  }

  /**
   * Change the email of a provisioned member
   * @returns ProvisionedMemberResponseDto
   * @throws ApiError
   */
  public static changeEmail(
    data: $OpenApiTs['/api/service/v1/organizations/{oid}/members/{email}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/service/v1/organizations/{oid}/members/{email}']['patch']['res'][200]> {
    const { oid, email, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/service/v1/organizations/{oid}/members/{email}',
      path: {
        oid,
        email,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Reactivate a deactivated member and re-run license assignment
   * @returns ProvisionedMemberResponseDto
   * @throws ApiError
   */
  public static reactivate(
    data: $OpenApiTs['/api/service/v1/organizations/{oid}/members/{email}/reactivate']['post']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/service/v1/organizations/{oid}/members/{email}/reactivate']['post']['res'][200]
  > {
    const { oid, email } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/service/v1/organizations/{oid}/members/{email}/reactivate',
      path: {
        oid,
        email,
      },
    });
  }
}

export class ApiKeysService {
  /**
   * Create a new API key
   * @returns PrismaOrganizationApiKeyDto
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/api-keys/{organizationId}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/api-keys/{organizationId}']['post']['res'][200]> {
    const { organizationId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/api-keys/{organizationId}',
      path: {
        organizationId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * List all API keys in an Organization
   * @returns PrismaOrganizationApiKeyDto
   * @throws ApiError
   */
  public static findAll(
    data: $OpenApiTs['/api/api-keys/{organizationId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/api-keys/{organizationId}']['get']['res'][200]> {
    const { organizationId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/api-keys/{organizationId}',
      path: {
        organizationId,
      },
    });
  }

  /**
   * Delete API key
   * @returns void
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/api-keys/{organizationId}/{apiKeyId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/api-keys/{organizationId}/{apiKeyId}']['delete']['res'][204]> {
    const { organizationId, apiKeyId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/api-keys/{organizationId}/{apiKeyId}',
      path: {
        organizationId,
        apiKeyId,
      },
    });
  }
}

export class SmsCountriesService {
  /**
   * Create SMS OTP Country Rule
   * @returns PrismaSMSCountryCodeDto
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/admin/sms-countries']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/sms-countries']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/sms-countries',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get all SMS OTP Country Rule
   * @returns PrismaSMSCountryCodeDto
   * @throws ApiError
   */
  public static findAll(): CancelablePromise<$OpenApiTs['/api/admin/sms-countries']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/sms-countries',
    });
  }

  /**
   * Delete empty SMS OTP Country Rule
   * @returns PrismaSMSCountryCodeDto
   * @throws ApiError
   */
  public static removeEmpty(): CancelablePromise<$OpenApiTs['/api/admin/sms-countries']['delete']['res'][200]> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/admin/sms-countries',
    });
  }

  /**
   * Get SMS OTP Country Rule
   * @returns PrismaSMSCountryCodeDto
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/admin/sms-countries/{code}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/sms-countries/{code}']['get']['res'][200]> {
    const { code } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/sms-countries/{code}',
      path: {
        code,
      },
    });
  }

  /**
   * Update SMS OTP Country Rule
   * @returns PrismaSMSCountryCodeDto
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/admin/sms-countries/{code}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/sms-countries/{code}']['patch']['res'][200]> {
    const { code, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/sms-countries/{code}',
      path: {
        code,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete SMS OTP Country Rule
   * @returns PrismaSMSCountryCodeDto
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/admin/sms-countries/{code}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/sms-countries/{code}']['delete']['res'][200]> {
    const { code } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/admin/sms-countries/{code}',
      path: {
        code,
      },
    });
  }
}

export class SmsWhitelistService {
  /**
   * Create whitelisted mobile number
   * @returns PrismaSMSWhitelistDto
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/admin/sms-whitelist']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/sms-whitelist']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/sms-whitelist',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get all whitelisted mobile numbers
   * @returns PrismaSMSWhitelistDto
   * @throws ApiError
   */
  public static findAll(): CancelablePromise<$OpenApiTs['/api/admin/sms-whitelist']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/sms-whitelist',
    });
  }

  /**
   * Delete whitelisted mobile number
   * @returns PrismaSMSWhitelistDto
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/admin/sms-whitelist/{number}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/sms-whitelist/{number}']['delete']['res'][200]> {
    const { number } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/admin/sms-whitelist/{number}',
      path: {
        number,
      },
    });
  }
}

export class TransactionCodeService {
  /**
   * Create new Transaction Code
   * @returns PrismaTransactionCodeDto
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/transaction-codes']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/transaction-codes']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/transaction-codes',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Find all Transaction Codes
   * @returns GetTransactionCodesListResponseDto
   * @throws ApiError
   */
  public static findAll(
    data: $OpenApiTs['/api/transaction-codes']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/transaction-codes']['get']['res'][200]> {
    const { pageNo, pageSize, orderBy, orderType, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/transaction-codes',
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
      },
    });
  }

  /**
   * Find one Transaction Code
   * @returns PrismaTransactionCodeDto
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/transaction-codes/{code}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/transaction-codes/{code}']['get']['res'][200]> {
    const { code } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/transaction-codes/{code}',
      path: {
        code,
      },
    });
  }
}

export class WebsocketsService {
  /**
   * Create a websocket session via HTTP request
   * @returns any
   * @throws ApiError
   */
  public static create(): CancelablePromise<$OpenApiTs['/api/websockets/create']['post']['res'][200]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/websockets/create',
    });
  }

  /**
   * Subscribe websocket session to admin live jobs dashboard updates
   * @returns any
   * @throws ApiError
   */
  public static subscribeAdminJobsLiveDashboard(
    data: $OpenApiTs['/api/websockets/admin/jobs-live-dashboard/subscribe']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/websockets/admin/jobs-live-dashboard/subscribe']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/websockets/admin/jobs-live-dashboard/subscribe',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Unsubscribe websocket session from admin live jobs dashboard updates
   * @returns any
   * @throws ApiError
   */
  public static unsubscribeAdminJobsLiveDashboard(
    data: $OpenApiTs['/api/websockets/admin/jobs-live-dashboard/unsubscribe']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/websockets/admin/jobs-live-dashboard/unsubscribe']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/websockets/admin/jobs-live-dashboard/unsubscribe',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Subscribe websocket session to admin job details updates
   * @returns any
   * @throws ApiError
   */
  public static subscribeAdminJobDetails(
    data: $OpenApiTs['/api/websockets/admin/job-details/subscribe']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/websockets/admin/job-details/subscribe']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/websockets/admin/job-details/subscribe',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Unsubscribe websocket session from admin job details updates
   * @returns any
   * @throws ApiError
   */
  public static unsubscribeAdminJobDetails(
    data: $OpenApiTs['/api/websockets/admin/job-details/unsubscribe']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/websockets/admin/job-details/unsubscribe']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/websockets/admin/job-details/unsubscribe',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Receive API Gateway websocket responses via the default route
   * @returns any
   * @throws ApiError
   */
  public static default(): CancelablePromise<$OpenApiTs['/api/websockets/default']['post']['res'][200]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/websockets/default',
    });
  }

  /**
   * Ensure that a valid websocket exists and set the AWS API Gateway connection ID
   * @returns any
   * @throws ApiError
   */
  public static connect(): CancelablePromise<$OpenApiTs['/api/websockets/connect']['post']['res'][200]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/websockets/connect',
    });
  }

  /**
   * Delete the websocket session on disconnect
   * @returns any
   * @throws ApiError
   */
  public static disconnect(
    data: $OpenApiTs['/api/websockets/disconnect']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/websockets/disconnect']['post']['res'][200]> {
    const { xSessionId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/websockets/disconnect',
      headers: {
        'x-session-id': xSessionId,
      },
    });
  }
}

export class WebsocketConfigService {
  /**
   * Runtime WebSocket gateway configuration
   * Returns the WebSocket gateway host and stage so the frontend can connect without build-time environment variables.
   * @returns WebsocketConfigResponseDto WebSocket gateway configuration
   * @throws ApiError
   */
  public static getConfig(): CancelablePromise<$OpenApiTs['/api/websocket-config']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/websocket-config',
    });
  }
}

export class TemporalConfigService {
  /**
   * Runtime Temporal Web UI configuration
   * Returns the Temporal namespace and Web UI base URL so the frontend can build workflow debug links without build-time environment variables.
   * @returns TemporalConfigResponseDto Temporal Web UI configuration
   * @throws ApiError
   */
  public static getConfig(): CancelablePromise<$OpenApiTs['/api/temporal-config']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/temporal-config',
    });
  }
}

export class StripeConfigService {
  /**
   * Runtime Stripe client configuration
   * Returns the Stripe publishable key paired with this backend so the frontend can initialise Stripe.js without build-time environment variables.
   * @returns StripeConfigResponseDto Stripe client configuration
   * @throws ApiError
   */
  public static getConfig(): CancelablePromise<$OpenApiTs['/api/stripe-config']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/stripe-config',
    });
  }
}

export class HealthService {
  /**
   * Health check endpoint for uptime monitoring and Kubernetes liveness probe
   * Returns health status of the application including database and Redis connectivity
   * @returns HealthCheckResponseDto Service is healthy
   * @throws ApiError
   */
  public static healthCheck(): CancelablePromise<$OpenApiTs['/api/healthz']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/healthz',
      errors: {
        503: `Service is unhealthy`,
      },
    });
  }

  /**
   * Simple health check
   * Lightweight health check that only verifies the application is running
   * @returns SimpleHealthResponseDto Application is running
   * @throws ApiError
   */
  public static simpleHealth(): CancelablePromise<$OpenApiTs['/api/health']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/health',
    });
  }

  /**
   * Check liveness
   * @returns StatusResponseDto Liveness check
   * @throws ApiError
   */
  public static checkLiveness(): CancelablePromise<$OpenApiTs['/api/liveness']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/liveness',
    });
  }

  /**
   * Check readiness
   * @returns StatusResponseDto Readiness check
   * @throws ApiError
   */
  public static checkReadiness(): CancelablePromise<$OpenApiTs['/api/readiness']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/readiness',
    });
  }
}

export class VersionsService {
  /**
   * Create a new version for a job
   * @returns unknown
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/jobs/{jobId}/version']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/jobs/{jobId}/version']['post']['res'][200]> {
    const { jobId, requestBody, overrideUserId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/jobs/{jobId}/version',
      path: {
        jobId,
      },
      query: {
        overrideUserId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Create initial version for a job from transcript preparer service
   * @returns unknown
   * @throws ApiError
   */
  public static createInitialVersion(
    data: $OpenApiTs['/api/jobs/{jobId}/initial-version']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/jobs/{jobId}/initial-version']['post']['res'][200]> {
    const { jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/jobs/{jobId}/initial-version',
      path: {
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get a list all versions for a job
   * @returns PrismaJobFilesVersionDto
   * @throws ApiError
   */
  public static findAllVersions(): CancelablePromise<$OpenApiTs['/api/admin/versions']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/versions',
    });
  }

  /**
   * Get a list all versions for a job
   * @returns PrismaJobFilesVersionDto
   * @throws ApiError
   */
  public static findAllVersionsForJob(
    data: $OpenApiTs['/api/admin/jobs/{jobId}/versions']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{jobId}/versions']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{jobId}/versions',
      path: {
        jobId,
      },
    });
  }

  /**
   * Get a list all checkout events for a job
   * @returns PrismaJobFilesCheckoutEventDto
   * @throws ApiError
   */
  public static findAllCheckoutEventsForJob(
    data: $OpenApiTs['/api/{wsid}/jobs/{jobId}/checkout-events']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{jobId}/checkout-events']['get']['res'][200]> {
    const { wsid, jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/{wsid}/jobs/{jobId}/checkout-events',
      path: {
        wsid,
        jobId,
      },
    });
  }
}

export class CanvasService {
  /**
   * Get courses list
   * @returns CourseResponseDto
   * @throws ApiError
   */
  public static getCourses(): CancelablePromise<$OpenApiTs['/api/canvas/courses']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/canvas/courses',
    });
  }

  /**
   * Get course info
   * @returns CourseResponseDto
   * @throws ApiError
   */
  public static getCourse(
    data: $OpenApiTs['/api/canvas/courses/{courseId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/canvas/courses/{courseId}']['get']['res'][200]> {
    const { courseId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/canvas/courses/{courseId}',
      path: {
        courseId,
      },
    });
  }

  /**
   * Get course students list
   * @returns CourseStudentResponseDto
   * @throws ApiError
   */
  public static getCourseStudents(
    data: $OpenApiTs['/api/canvas/courses/{courseId}/students']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/canvas/courses/{courseId}/students']['get']['res'][200]> {
    const { courseId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/canvas/courses/{courseId}/students',
      path: {
        courseId,
      },
    });
  }

  /**
   * Create course student
   * @returns void
   * @throws ApiError
   */
  public static createCourseStudent(
    data: $OpenApiTs['/api/canvas/courses/{courseId}/students']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/canvas/courses/{courseId}/students']['post']['res'][204]> {
    const { courseId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/canvas/courses/{courseId}/students',
      path: {
        courseId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}

export class PromptsService {
  /**
   * @returns GetAllPromptsResponseDto
   * @throws ApiError
   */
  public static getAll(): CancelablePromise<$OpenApiTs['/api/prompts']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/prompts',
    });
  }

  /**
   * @returns UpdateTemplateResponseDto
   * @throws ApiError
   */
  public static updatePromptTemplate(
    data: $OpenApiTs['/api/prompts']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/prompts']['patch']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/prompts',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns PrismaPromptDto
   * @throws ApiError
   */
  public static getPrompt(
    data: $OpenApiTs['/api/prompts/{slug}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/prompts/{slug}']['get']['res'][200]> {
    const { slug } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/prompts/{slug}',
      path: {
        slug,
      },
    });
  }

  /**
   * @returns UpdateTemplateResponseDto
   * @throws ApiError
   */
  public static updatePromptDefaultModel(
    data: $OpenApiTs['/api/prompts/prompts/{slug}/default-model']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/prompts/prompts/{slug}/default-model']['patch']['res'][200]> {
    const { slug, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/prompts/prompts/{slug}/default-model',
      path: {
        slug,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns UpdateTemplateResponseDto
   * @throws ApiError
   */
  public static updatePromptModelForOrganization(
    data: $OpenApiTs['/api/prompts/organization/{oid}/prompt/{slug}/model']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/prompts/organization/{oid}/prompt/{slug}/model']['patch']['res'][200]> {
    const { oid, slug, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/prompts/organization/{oid}/prompt/{slug}/model',
      path: {
        oid,
        slug,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns PrismaPromptConfigDto
   * @throws ApiError
   */
  public static getPromptConfigsForOrg(
    data: $OpenApiTs['/api/prompts/organization/{oid}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/prompts/organization/{oid}']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/prompts/organization/{oid}',
      path: {
        oid,
      },
    });
  }
}

export class PipelineAttemptsService {
  /**
   * List current attempts (oldest first) that are not successful
   * @returns PaginatedPipelineCurrentAttemptResponseDto
   * @throws ApiError
   */
  public static getCurrentAttempts(
    data: $OpenApiTs['/api/admin/pipeline/current-attempts']['get']['req'] = {},
  ): CancelablePromise<$OpenApiTs['/api/admin/pipeline/current-attempts']['get']['res'][200]> {
    const { pageNo, pageSize, orderBy, orderType } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/pipeline/current-attempts',
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
      },
    });
  }

  /**
   * Submission summary for the last 24 hours (per hour buckets)
   * @returns PipelineJobSubmissionBucketResponseDto
   * @throws ApiError
   */
  public static getJobSubmissionSummary(): CancelablePromise<
    $OpenApiTs['/api/admin/pipeline/submissions/summary']['get']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/pipeline/submissions/summary',
    });
  }

  /**
   * Event duration stats (avg/percentiles) for completed events in last 24 hours
   * @returns PipelineEventDurationStatsResponseDto
   * @throws ApiError
   */
  public static getEventDurationSummary(): CancelablePromise<
    $OpenApiTs['/api/admin/pipeline/events/durations']['get']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/pipeline/events/durations',
    });
  }

  /**
   * List oldest errored jobs
   * @returns PaginatedPipelineErroredJobResponseDto
   * @throws ApiError
   */
  public static getErroredJobs(
    data: $OpenApiTs['/api/admin/pipeline/jobs/errored']['get']['req'] = {},
  ): CancelablePromise<$OpenApiTs['/api/admin/pipeline/jobs/errored']['get']['res'][200]> {
    const { pageNo, pageSize, orderBy, orderType } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/pipeline/jobs/errored',
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
      },
    });
  }

  /**
   * List processing jobs that have been running the longest
   * @returns PaginatedPipelineProcessingJobResponseDto
   * @throws ApiError
   */
  public static getLongestProcessingJobs(
    data: $OpenApiTs['/api/admin/pipeline/jobs/processing/longest']['get']['req'] = {},
  ): CancelablePromise<$OpenApiTs['/api/admin/pipeline/jobs/processing/longest']['get']['res'][200]> {
    const { pageNo, pageSize, orderBy, orderType } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/pipeline/jobs/processing/longest',
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
      },
    });
  }

  /**
   * Mark job as 'Ready for Editing' and close the latest attempt
   * @returns PipelineManualJobUpdateResponseDto
   * @throws ApiError
   */
  public static markJobReadyForEditing(
    data: $OpenApiTs['/api/admin/pipeline/jobs/{jobId}/ready-for-editing']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/pipeline/jobs/{jobId}/ready-for-editing']['patch']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/pipeline/jobs/{jobId}/ready-for-editing',
      path: {
        jobId,
      },
    });
  }

  /**
   * Mark the latest attempt as failed and reset the job's status to draft
   * @returns PipelineManualJobUpdateResponseDto
   * @throws ApiError
   */
  public static resetJobToDraft(
    data: $OpenApiTs['/api/admin/pipeline/jobs/{jobId}/reset-to-draft']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/pipeline/jobs/{jobId}/reset-to-draft']['patch']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/pipeline/jobs/{jobId}/reset-to-draft',
      path: {
        jobId,
      },
    });
  }

  /**
   * Mark a pipeline attempt as failed
   * @returns PipelineAttemptUpdateResponseDto
   * @throws ApiError
   */
  public static markAttemptFailed(
    data: $OpenApiTs['/api/admin/pipeline-attempts/{attemptId}/fail']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/pipeline-attempts/{attemptId}/fail']['patch']['res'][200]> {
    const { attemptId } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/pipeline-attempts/{attemptId}/fail',
      path: {
        attemptId,
      },
    });
  }

  /**
   * Mark or unmark a job as deleted
   * Marking a job as deleted requires ROLE_VS_ADMIN. Undeleting additionally requires ROLE_VS_DEV.
   * @returns PipelineJobRemovalResponseDto
   * @throws ApiError
   */
  public static updateJobRemovedState(
    data: $OpenApiTs['/api/admin/pipeline/jobs/{jobId}/deleted']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/pipeline/jobs/{jobId}/deleted']['patch']['res'][200]> {
    const { jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/pipeline/jobs/{jobId}/deleted',
      path: {
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}

export class AdminPipelinePerformanceService {
  /**
   * Normalized pipeline stage performance trends for the last 30 days
   * @returns PipelinePerformanceTrendsResponseDto
   * @throws ApiError
   */
  public static getTrends(): CancelablePromise<
    $OpenApiTs['/api/admin/pipeline/performance/trends']['get']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/pipeline/performance/trends',
    });
  }
}

export class AdminPipelineWatchlistService {
  /**
   * Currently stuck pipeline jobs for operational monitoring
   * @returns PipelineWatchlistResponseDto
   * @throws ApiError
   */
  public static getWatchlist(): CancelablePromise<$OpenApiTs['/api/admin/pipeline/watchlist']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/pipeline/watchlist',
    });
  }
}

export class InternalPipelineService {
  /**
   * Deliver a pipeline stage event to the orchestration state machine
   * Idempotent: redelivered events that are invalid for the current pipeline state are ignored, and events for superseded attempts are dropped. Callers (Temporal activities) retry until this endpoint accepts.
   * @returns any
   * @throws ApiError
   */
  public static handlePipelineEvent(
    data: $OpenApiTs['/api/internal/pipeline/events']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/internal/pipeline/events']['post']['res'][200]> {
    const { requestBody, apiKey } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/internal/pipeline/events',
      headers: {
        'api-key': apiKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}

export class InternalJobsService {
  /**
   * Job metadata snapshot for pipeline tooling
   * Read-only DB ground truth for diagnosis agents: derived jobKind (asone = has a RecordingSession, post = none), recording session type/status, and pipeline-relevant flags. No PII.
   * @returns unknown
   * @throws ApiError
   */
  public static getJobMetadata(
    data: $OpenApiTs['/api/internal/jobs/{jobId}/metadata']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/internal/jobs/{jobId}/metadata']['get']['res'][200]> {
    const { jobId, apiKey } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/internal/jobs/{jobId}/metadata',
      path: {
        jobId,
      },
      headers: {
        'api-key': apiKey,
      },
    });
  }

  /**
   * Get pipeline diagnostic state for a job
   * Returns the job row, every PipelineAttempt, every PipelineEvent (with errorDetails), JobOutput rows, and JobPipelineTimestamps. Intended for engineer debug / automated tests.
   * @returns any
   * @throws ApiError
   */
  public static getPipelineState(
    data: $OpenApiTs['/api/internal/jobs/{jobId}/pipeline-state']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/internal/jobs/{jobId}/pipeline-state']['get']['res'][200]> {
    const { jobId, apiKey } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/internal/jobs/{jobId}/pipeline-state',
      path: {
        jobId,
      },
      headers: {
        'api-key': apiKey,
      },
    });
  }

  /**
   * Re-evaluate the unlock policy for a job
   * Computes what UnlockPolicy.fromSubscription would return right now (FULL_UNLOCK / PARTIAL_UNLOCK / LOCKED) with a human-readable reason. Useful for explaining why a job is stuck locked without flipping any state.
   * @returns any
   * @throws ApiError
   */
  public static getUnlockPolicy(
    data: $OpenApiTs['/api/internal/jobs/{jobId}/unlock-policy']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/internal/jobs/{jobId}/unlock-policy']['get']['res'][200]> {
    const { jobId, apiKey } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/internal/jobs/{jobId}/unlock-policy',
      path: {
        jobId,
      },
      headers: {
        'api-key': apiKey,
      },
    });
  }

  /**
   * Get full Job details (cross-organization)
   * Engineer-only reader that returns a job by id without organization scoping. Previously exposed as GET /private/admin/:jobId behind an Organization API key, which let any org key read any job; now restricted to the INTERNAL_API_KEY.
   * @returns any
   * @throws ApiError
   */
  public static getJobDetails(
    data: $OpenApiTs['/api/internal/jobs/{jobId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/internal/jobs/{jobId}']['get']['res'][200]> {
    const { jobId, apiKey } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/internal/jobs/{jobId}',
      path: {
        jobId,
      },
      headers: {
        'api-key': apiKey,
      },
    });
  }

  /**
   * Resubmit a job through the pipeline
   * Equivalent to the admin Resubmit button. Re-uses the existing media; does not re-upload.
   * @returns any
   * @throws ApiError
   */
  public static resubmitJob(
    data: $OpenApiTs['/api/internal/jobs/{jobId}/resubmit']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/internal/jobs/{jobId}/resubmit']['post']['res'][200]> {
    const { jobId, requestBody, apiKey } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/internal/jobs/{jobId}/resubmit',
      path: {
        jobId,
      },
      headers: {
        'api-key': apiKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Flip asOneLocked=false without charging
   * Sets asOneLocked=false. Does NOT charge, does NOT trigger any pipeline event, does NOT change status. Use the public pay-to-unlock flow for the production billing path.
   * @returns any
   * @throws ApiError
   */
  public static unlockJob(
    data: $OpenApiTs['/api/internal/jobs/{jobId}/unlock']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/internal/jobs/{jobId}/unlock']['post']['res'][200]> {
    const { jobId, apiKey } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/internal/jobs/{jobId}/unlock',
      path: {
        jobId,
      },
      headers: {
        'api-key': apiKey,
      },
    });
  }
}

export class AdminTranscriptReviewService {
  /**
   * List transcript review sessions for a job
   * @returns TranscriptReviewSessionResponseDto
   * @throws ApiError
   */
  public static listSessionsForJob(
    data: $OpenApiTs['/api/admin/transcript-review/jobs/{jobId}/sessions']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/transcript-review/jobs/{jobId}/sessions']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/transcript-review/jobs/{jobId}/sessions',
      path: {
        jobId,
      },
    });
  }

  /**
   * Create transcript review session
   * @returns TranscriptReviewSessionResponseDto
   * @throws ApiError
   */
  public static createSession(
    data: $OpenApiTs['/api/admin/transcript-review/jobs/{jobId}/sessions']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/transcript-review/jobs/{jobId}/sessions']['post']['res'][200]> {
    const { jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/transcript-review/jobs/{jobId}/sessions',
      path: {
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get transcript review session
   * @returns TranscriptReviewSessionResponseDto
   * @throws ApiError
   */
  public static getSession(
    data: $OpenApiTs['/api/admin/transcript-review/sessions/{sessionId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/transcript-review/sessions/{sessionId}']['get']['res'][200]> {
    const { sessionId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/transcript-review/sessions/{sessionId}',
      path: {
        sessionId,
      },
    });
  }

  /**
   * Get stylefix replay fixture artifact summary for a job
   * @returns TranscriptReviewFixturesSummaryResponseDto
   * @throws ApiError
   */
  public static getStyleFixFixtureSummary(
    data: $OpenApiTs['/api/admin/transcript-review/jobs/{jobId}/fixtures/stylefix-chunks/summary']['get']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/admin/transcript-review/jobs/{jobId}/fixtures/stylefix-chunks/summary']['get']['res'][200]
  > {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/transcript-review/jobs/{jobId}/fixtures/stylefix-chunks/summary',
      path: {
        jobId,
      },
    });
  }

  /**
   * Get stylefix replay fixture manifest for a job
   * @returns TranscriptReviewFixtureManifestResponseDto
   * @throws ApiError
   */
  public static getStyleFixFixtureManifest(
    data: $OpenApiTs['/api/admin/transcript-review/jobs/{jobId}/fixtures/stylefix-chunks/manifest']['get']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/admin/transcript-review/jobs/{jobId}/fixtures/stylefix-chunks/manifest']['get']['res'][200]
  > {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/transcript-review/jobs/{jobId}/fixtures/stylefix-chunks/manifest',
      path: {
        jobId,
      },
    });
  }

  /**
   * Load one stylefix replay fixture chunk for transcript review
   * @returns TranscriptReviewFixtureEventsResponseDto
   * @throws ApiError
   */
  public static getStyleFixFixtureChunk(
    data: $OpenApiTs['/api/admin/transcript-review/jobs/{jobId}/fixtures/stylefix-chunks/chunks/{chunkIndex}']['get']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/admin/transcript-review/jobs/{jobId}/fixtures/stylefix-chunks/chunks/{chunkIndex}']['get']['res'][200]
  > {
    const { jobId, chunkIndex } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/transcript-review/jobs/{jobId}/fixtures/stylefix-chunks/chunks/{chunkIndex}',
      path: {
        jobId,
        chunkIndex,
      },
    });
  }

  /**
   * Load stylefix replay fixture artifacts for transcript review
   * @returns TranscriptReviewFixturesResponseDto
   * @throws ApiError
   */
  public static getStyleFixFixtures(
    data: $OpenApiTs['/api/admin/transcript-review/jobs/{jobId}/fixtures/stylefix-chunks']['get']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/admin/transcript-review/jobs/{jobId}/fixtures/stylefix-chunks']['get']['res'][200]
  > {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/transcript-review/jobs/{jobId}/fixtures/stylefix-chunks',
      path: {
        jobId,
      },
    });
  }

  /**
   * Import proofer replay events as proposals
   * @returns TranscriptReviewSessionResponseDto
   * @throws ApiError
   */
  public static importEvents(
    data: $OpenApiTs['/api/admin/transcript-review/sessions/{sessionId}/events/import']['post']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/admin/transcript-review/sessions/{sessionId}/events/import']['post']['res'][200]
  > {
    const { sessionId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/transcript-review/sessions/{sessionId}/events/import',
      path: {
        sessionId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Accept or reject a transcript review proposal
   * @returns TranscriptReviewSessionResponseDto
   * @throws ApiError
   */
  public static decideProposal(
    data: $OpenApiTs['/api/admin/transcript-review/sessions/{sessionId}/proposals/{proposalId}/decision']['patch']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/admin/transcript-review/sessions/{sessionId}/proposals/{proposalId}/decision']['patch']['res'][200]
  > {
    const { sessionId, proposalId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/transcript-review/sessions/{sessionId}/proposals/{proposalId}/decision',
      path: {
        sessionId,
        proposalId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Request LLM edit proposals for selected transcript lines
   * @returns TranscriptReviewSessionResponseDto
   * @throws ApiError
   */
  public static requestSelectedEdit(
    data: $OpenApiTs['/api/admin/transcript-review/sessions/{sessionId}/edits/selected']['post']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/admin/transcript-review/sessions/{sessionId}/edits/selected']['post']['res'][200]
  > {
    const { sessionId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/transcript-review/sessions/{sessionId}/edits/selected',
      path: {
        sessionId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Enqueue chunked LLM edit proposals for the whole transcript
   * @returns TranscriptReviewSessionResponseDto
   * @throws ApiError
   */
  public static requestWholeDocumentEdit(
    data: $OpenApiTs['/api/admin/transcript-review/sessions/{sessionId}/edits/whole-document']['post']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/admin/transcript-review/sessions/{sessionId}/edits/whole-document']['post']['res'][200]
  > {
    const { sessionId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/transcript-review/sessions/{sessionId}/edits/whole-document',
      path: {
        sessionId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Preview LLM edit proposals without a persisted review session
   * @returns TranscriptReviewProposalResponseDto
   * @throws ApiError
   */
  public static previewEdit(
    data: $OpenApiTs['/api/admin/transcript-review/edits/preview']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/transcript-review/edits/preview']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/transcript-review/edits/preview',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Publish accepted transcript review draft as a new job files version
   * @returns PublishTranscriptReviewSessionResponseDto
   * @throws ApiError
   */
  public static publishSession(
    data: $OpenApiTs['/api/admin/transcript-review/sessions/{sessionId}/publish']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/transcript-review/sessions/{sessionId}/publish']['post']['res'][200]> {
    const { sessionId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/transcript-review/sessions/{sessionId}/publish',
      path: {
        sessionId,
      },
    });
  }
}

export class AuditLogsService {
  /**
   * List audit log entries (newest first) matching the filters
   * @returns PaginatedAuditLogResponseDto
   * @throws ApiError
   */
  public static adminListAuditLogs(
    data: $OpenApiTs['/api/admin/audit-logs']['get']['req'] = {},
  ): CancelablePromise<$OpenApiTs['/api/admin/audit-logs']['get']['res'][200]> {
    const {
      pageNo,
      pageSize,
      orderBy,
      orderType,
      entityType,
      entityId,
      actorUserId,
      actorLabel,
      actorType,
      businessAction,
      organizationId,
      createdFrom,
      createdTo,
    } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/audit-logs',
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        entityType,
        entityId,
        actorUserId,
        actorLabel,
        actorType,
        businessAction,
        organizationId,
        createdFrom,
        createdTo,
      },
    });
  }

  /**
   * List entity types covered by the audit trail
   * @returns AuditLogEntityTypesResponseDto
   * @throws ApiError
   */
  public static adminListAuditLogEntityTypes(): CancelablePromise<
    $OpenApiTs['/api/admin/audit-logs/entity-types']['get']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/audit-logs/entity-types',
    });
  }
}
